import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import validator from "validator";
// import HelpIcon from '@mui/icons-material/Help';
import HelpIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import MilitaryTechOutlinedIcon from "@mui/icons-material/MilitaryTechOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@material-ui/core/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import {
  Container,
  Grid,
  TextField,
  FormHelperText,
  Paper,
  FormControlLabel,
  FormLabel,
  FormControl,
  Checkbox,
  InputLabel,
  Slider,
  Box,
  Typography,
  Button,
  Input,
  InputAdornment,
  Select,
  MenuItem,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Popover as AntdPopover, Input as AntdInput } from "antd";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@material-ui/icons/Clear";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import {
  individualBrowseWatch,
  searchProducts,
  searchLocation,
  addInventoryImage
} from "../../dealer/actions/dealerAction";
import searchinventry from "../actions/dashboardaapi";
import AddIcon from "../../../../assests/images/add.png";
import {
  getComponentActionList,
  isActionAllowed,
  getComponentViewsList,
  formatDate,
  getCustomLabel,
} from "../../../../common/components/Helper/Utils";
import _ from "lodash";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import Header from "../../../../common/components/Header";
import Footer from "../../../../common/components/Footer";
import { SpinnerRoundFilled } from "spinners-react";
import { Divider, List } from "antd";
import {
  brandList,
  caseMaterial,
  brandMaterial,
} from "../../browse-watches/actions/browseWatchesActions";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";
import FileUploadGroup from "../../../../common/components/FileuploadGroup";
import { getBusinessAccountIds } from "../actions/dashboardAction";
import "../../dashboard/style/createInventory.css";
import "../../dashboard/style/updateInventory.css";
const Loader = require("react-loader");

const getUsedGood = () => getCustomLabel("custom_used_good", "Used/Good");
const getMintVeryGood = () => getCustomLabel("custom_mint_verygood", "Mint/Very Good");
const getRetailReady = () => getCustomLabel("custom_retail_likenew", "Retail Ready/Like New");
const getNewCond = () => getCustomLabel("custom_new", "New");
const getUsed = () => getCustomLabel("custom_used", "Used");

const followersMarks1 = () => [
  { value: 1, scaledValue: 1, label: getUsedGood() },
  { value: 2, scaledValue: 2, label: getMintVeryGood() },
  { value: 3, scaledValue: 3, label: getRetailReady() },
  { value: 4, scaledValue: 4, label: getNewCond() },
];

const followersMarks2 = () => [
  { value: 1, scaledValue: 1, label: getNewCond() },
  { value: 2, scaledValue: 2, label: getUsed() },
];

const SectionCard = ({ icon, title, children, style }) => (
  <div className="ai-section-card" style={style}>
    <div className="ai-section-card__header">
      <span className="ai-section-card__icon">{icon}</span>
      <Typography className="ai-section-card__title">{title}</Typography>
    </div>
    <div className="ai-section-card__body">{children}</div>
  </div>
);

const FieldLabel = ({ children, required }) => (
  <Typography className="ai-field-label">
    {children}
    {required ? <span className="ai-field-label__required"> *</span> : null}
  </Typography>
);

const CONDITION_COLORS = [
  { border: "#F0B25F", bg: "#FFF8EE" },
  { border: "#8FCB9B", bg: "#F2FBF3" },
  { border: "#7FA6E8", bg: "#F3F6FE" },
  { border: "#B98CE0", bg: "#FAF5FE" },
];

const CONDITION_ICONS = [
  LocalMallOutlinedIcon,
  MilitaryTechOutlinedIcon,
  ShoppingCartOutlinedIcon,
  CardGiftcardOutlinedIcon,
];

const ConditionSelector = ({ marks, value, onChange }) => (
  <div className="ai-condition-group">
    {marks.map((mark, idx) => {
      const color = CONDITION_COLORS[idx % CONDITION_COLORS.length];
      const Icon = CONDITION_ICONS[idx % CONDITION_ICONS.length];
      const selected = Number(value) === mark.value;
      return (
        <div
          key={mark.value}
          className={`ai-condition-card${selected ? " ai-condition-card--selected" : ""}`}
          style={{ borderColor: color.border, background: color.bg }}
          onClick={(e) => onChange(e, mark.value)}
        >
          {selected && (
            <span className="ai-condition-card__check" style={{ background: color.border }}>
              <CheckIcon style={{ fontSize: 12, color: "#fff" }} />
            </span>
          )}
          <Icon className="ai-condition-card__icon" style={{ color: color.border }} />
          <span className="ai-condition-card__label" style={{ color: color.border }}>{mark.label}</span>
        </div>
      );
    })}
  </div>
);

const condition = [
  {
    value: 0,
    scaledValue: 1,
    label: "0 Inch",
  },
  {
    value: 5,
    scaledValue: 5,
    label: "5 Inc",
  },
];

const INVENTORY_MEDIA_POSITIONS = [
  "front",
  "back",
  "left",
  "right",
  "free_form",
  "buckle_opened",
  "buckle_closed",
  "wrist_shot",
];

const getInventoryMediaPositionIndex = (position) => {
  const normalizedPosition = String(position || "").toLowerCase();
  const configuredIndex = INVENTORY_MEDIA_POSITIONS.indexOf(normalizedPosition);
  if (configuredIndex !== -1) return configuredIndex;

  const preimageMatch = normalizedPosition.match(/^preimage(\d+)$/);
  if (preimageMatch) {
    return INVENTORY_MEDIA_POSITIONS.length + Number(preimageMatch[1]) - 1;
  }

  return Number.MAX_SAFE_INTEGER;
};

const sortInventoryImageFiles = (files = []) =>
  [...files].sort(
    (a, b) =>
      getInventoryMediaPositionIndex(a?.position || a?.id) -
      getInventoryMediaPositionIndex(b?.position || b?.id),
  );

const scale = (value) => {
  return (value * 25.4).toFixed(2) + " mm";
};

function numFormatter(num) {
  return num.toFixed(1) + " Inc"; // convert to K for number from > 1000 < 1 million
}

const scale1 = (value) => {
  return value;
};

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

class inventryupdateComponent extends Component {
  constructor(props) {
    super(props);
    this.modelNameWasCleared = false;
    this.productTitleManuallyEdited = false;
    this.state = {
      userData: sessionStorage.getItem("userDetails")
        ? JSON.parse(sessionStorage.getItem("userDetails"))
        : null,
      accountid: window.sessionStorage.getItem("accountId"),
      accountIds: [],
      isShopifyEnabled:
        window.sessionStorage.getItem("isShopifyEnabled") === "true",
      isShopifyVerified:
        window.sessionStorage.getItem("isShopifyVerified") === "true",
      isQboVerified: window.sessionStorage.getItem("isQboVerified") === "true",
      isEbayVerified: window.sessionStorage.getItem("isEbayVerified") === "true",
      shopifyConfig: false,
      qboConfig: false,
      initialQboConfig: false,
      initialShopifyConfig: false,
      initialEbayConfig: false,
      shopifyProductId: null,
      ebayConfig: false,
      open: false,
      setOpen: false,
      isDirty: false,
      ModelNumber: "",
      purchaseDate: "",
      purchaseDueDate: null,
      purchaseDate1: null,
      archiveDate: null,
      cursor: 0,
      PurchasedFrom: "",
      purchasedFromArray: [],
      purchaseFromContactId: null,
      dataset: [],
      isPopOverPurchasedFrom: false,
      isPopOverMemoDetails: false,
      isPopOverPartnershipDetails: false,
      PurchasedPrice: "",
      raw_PurchasedPrice: "",
      intial_purchased_price: "",
      SerialNumber: "",
      InventoryType: "",
      MemoDetails: "",
      memoDetailsArray: [],
      memoContactId: null,
      PartnershipDetails: "",
      partnershipDetailsArray: [],
      partnerContactId: null,
      purchasefrom: "",
      Condition: "1",
      BandSize: "",
      NumberOfLinks: "",
      raw_NumberOfLinks: "",
      DealerNotes: "",
      WholeSalePrice: "",
      intial_wholeSale_price: "",
      wholesale_price: "",
      raw_wholesale_price: "",
      RetailPrice: "",
      retail_price: "",
      raw_retail_price: "",
      intial_retail_price: "",
      retailwire_price: "",
      raw_retailwire_price: "",
      RetailWirePrice: "",
      intial_wire_price: "",
      DateFnsUtils: "",
      value: 0,
      finalcondition: "",
      finalbandsize: Number,
      isProduct_title_Changed: false,
      value1: 0,
      number: 0,
      serialno: "",
      WarentyPaper: "",
      warentypaperset: "",
      warranty_paper: "",
      inventoryDetailByIdDetails: [],
      onModelNumberErrorText: "",
      onPurchasedFromErrorText: "",
      onpurchaseDateErrorText: "",
      onPurchasedPriceErrorText: "",
      onSerialNumberErrorText: "",
      modificationDetailsError: "",
      onConditionErrorText: "",
      onCoditionTenSuccessText: "",
      onBandSizeErrorText: "",
      onDealerNotesErrorText: "",
      onNumberOfLinksErrorText: "",
      onWholeSalePriceErrorText: "",
      onRetailPriceErrorText: "",
      onRetailWirePriceErrorText: "",
      onPublicDealerNoteErrorText: "",
      onInventoryStatusErrorText: "",
      onProductTitleErrorText: "",
      onProductNameErrorText: "",
      onDescriptionErrorText: "",
      onModelNumberErrorText: "",
      onQuantityErrorText: "",
      onCaseSizeErrorText: "",
      onBandMaterialErrorText: "",
      onBrandNameErrorText: "",
      onCaseMaterialErrorText: "",
      onpurchaseDueDateErrorText: "",
      individualsearchdata: false,
      box: false,
      warranty_box: "",
      warrantybox: "",
      autocomplete: {
        currentInput: "",
        loading: false,
        data: [],
      },
      minmax_pricelist: {
        min_inventory_cost: "",
        max_inventory_cost: "",
        min_invoice_cost: "",
        max_invoice_cost: "",
      },
      showAdditionalDetails: false,
      selectedProduct: { productId: "" },
      selected: { product: null },
      loaded: false,
      purchaseprice: "",
      modification_deatils: "",
      ismodified: false,
      public_dealer_note: "",
      InventoryStatus: "",
      inventory_title: "",
      title_without_edit: "",
      purchase_expense: "",
      raw_PurchasedExpense: "",
      intial_purchase_expense: "",
      total_cost: "",
      raw_total_cost: "",
      brandname: "",
      quantity: "",
      updatememo: "",
      brand_name: "",
      product_name: "",
      case_material: "",
      band_material: "",
      case_size: "",
      dial_color: "",
      model_number: "",
      updatepartnershipnumber: "",
      purchase_expense_note: "",
      locationAutoCompleteData: {
        data: [],
      },
      locationSearch: "",
      locationloading: false,
      tag_price: "",
      raw_tag_price: "",
      intial_tag_price: "",
      archivePaperSet: "",
      archive: "",
      isService: false,
      serviceDate: "",
      warrentyExpiryDate: false,
      brandloading: false,
      brandAutoCompleteData: {
        data: [],
      },
      caseMaterialloading: false,
      caseMaterialAutoCompleteData: {
        data: [],
      },
      bandMaterialloading: false,
      bandMaterialAutoCompleteData: {
        data: [],
      },
      quantityDisabled: true,
      disabled: false,
      type: null,
      bulkUploadFile: [],
      fileArray: [],
      purchaseInvoice: null,
      inventryPricelist: [],
      ebayAmout: "",
      croono21Ammount: "",
      retailAmount: "",
      accessData: [],
      viewData: [],
      paymentDetailsText: "",
      onPaymentDetailsErrorText: "",
      paidStatus: true,
      intial_paid_status: true,
      paymentDate: null,
      notforSale: false,
      dealerInv: true,
      error: {},
      memoId: null,
      sold: null,
      qboitemid: null,
    };
    this.props.brandList();
    this.props.caseMaterial();
    this.props.brandMaterial();
    this.onchangeModelNumber = this.onchangeModelNumber.bind(this);
    this.handleNotforSaleCheck = this.handleNotforSaleCheck.bind(this);

    this.handleSelectedFiles = this.handleSelectedFiles.bind(this);
    this.DestructurefileType = this.DestructurefileType.bind(this);
    this.onchangePurchasedFrom = this.onchangePurchasedFrom.bind(this);
    this.onchangepurchaseDate = this.onchangepurchaseDate.bind(this);
    this.onchangepurchaseDate1 = this.onchangepurchaseDate1.bind(this);
    this.onchangePurchasedPrice = this.onchangePurchasedPrice.bind(this);
    this.onchangeSerialNumber = this.onchangeSerialNumber.bind(this);
    this.onchangeCondition = this.onchangeCondition.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onchangeBandSize = this.onchangeBandSize.bind(this);
    this.onchangeNumberOfLinks = this.onchangeNumberOfLinks.bind(this);
    this.onchangeDealerNotes = this.onchangeDealerNotes.bind(this);
    this.onchangeWholeSalePrice = this.onchangeWholeSalePrice.bind(this);
    this.onchangeRetailPrice = this.onchangeRetailPrice.bind(this);
    this.onchangeRetailWirePrice = this.onchangeRetailWirePrice.bind(this);
    this.onchangePaymentDetails = this.onchangePaymentDetails.bind(this);
    this.handleDateChange1 = this.handleDateChange1.bind(this);
    this.handleCheck1 = this.handleCheck1.bind(this);
    // this.autocomplete = this.autocomplete.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.onProductChange = this.onProductChange.bind(this);
    this.valuetext = this.valuetext.bind(this);
    // this.getAutocomplete = _.debounce(this.getAutocomplete, 500);
    this.checloaader = this.checloaader.bind(this);
    this.getInventryDetails = this.getInventryDetails.bind(this);
    this.onchangeModificationDetails =
      this.onchangeModificationDetails.bind(this);
    this.handleCheck2 = this.handleCheck2.bind(this);
    this.onchangeInventoryStatus = this.onchangeInventoryStatus.bind(this);
    this.onchangePublicDealerNote = this.onchangePublicDealerNote.bind(this);
    this.onchangeInventoryTitle = this.onchangeInventoryTitle.bind(this);
    this.onchangePurchaseExpense = this.onchangePurchaseExpense.bind(this);
    this.onchangePurchaseExpenseNote =
      this.onchangePurchaseExpenseNote.bind(this);
    this.onchangeLocation = this.onchangeLocation.bind(this);
    // this.locationAutoComplete = this.locationAutoComplete.bind(this);
    // this.getLocationAutocomplete = _.debounce(this.getLocationAutocomplete, 500);
    this.onchangeTagPrice = this.onchangeTagPrice.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePurchaseDate = this.handlePurchaseDate.bind(this);
    this.handleDueDateChange = this.handleDueDateChange.bind(this);
    this.onchangeProductName = this.onchangeProductName.bind(this);
    this.onchangeProductTitle = this.onchangeProductTitle.bind(this);
    this.onchangeDescription = this.onchangeDescription.bind(this);
    this.onchangeProductModelNumber =
      this.onchangeProductModelNumber.bind(this);
    // this.onchangeQuantity = this.onchangeQuantity.bind(this);
    this.onchangeCaseMaterial = this.onchangeCaseMaterial.bind(this);
    this.onchangecasematerial = this.onchangecasematerial.bind(this);
    this.onchangeBandMaterial = this.onchangeBandMaterial.bind(this);
    this.onchangebandmaterial = this.onchangebandmaterial.bind(this);
    this.onchangeBrandName = this.onchangeBrandName.bind(this);
    this.onchangebrand = this.onchangebrand.bind(this);
    this.onchangeCaseSize = this.onchangeCaseSize.bind(this);
    this.onchangeDialColor = this.onchangeDialColor.bind(this);
    this.backNavigation = this.backNavigation.bind(this);
    this.handleClickBreadCrumbs = this.handleClickBreadCrumbs.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.bulkUploadFile = this.bulkUploadFile.bind(this);
    this.getpriceListing = this.getpriceListing.bind(this);
    this.componentlist = this.componentlist.bind(this);
    this.debouncedGetContactDetails = _.debounce(this.getContactDetails, 1000);
    this.purchasedFromRef = React.createRef();
    this.memoDetailsRef = React.createRef();
    this.partnershipDetailsRef = React.createRef();
    this.handleIncludeShopify = this.handleIncludeShopify.bind(this);
    this.handleIncludeShopify = this.handleIncludeShopify.bind(this);
    this.handleIncludeQbo = this.handleIncludeQbo.bind(this);
    this.handleIncludeEbay = this.handleIncludeEbay.bind(this);
  }

  componentWillUnmount() { }
  componentlist = async () => {
    const accessDataObject = await getComponentActionList("edit_inventory");
    const viewDataObject = await getComponentViewsList("edit_inventory");
    this.setState({ accessData: accessDataObject, viewData: viewDataObject });
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ loaded: true, number: 50 });
    }, 900);
    this.componentlist();
    try {
      const PId = this.props.match.params.inventryId;
      if (PId !== undefined) {
        this.setState({
          selectedProduct: {
            productId: PId,
          },
        });
        this.getInventryDetails(PId);
      }
    } catch (error) {
      // console.log(error);
    }
    // this.onProductChange();
    this.getAccountIds();
  }
  formatAmount = (value) => {
    if (!value) return "";
    const num = value.toString().replace(/,/g, "");
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  getInventryDetails(id) {
    searchinventry.getinventryDetails(id).then((res) => {
      if (res.data.success === 1) {
        //Tag Price
        let backendTagPrice = res.data.data.tag_price
          ? res.data.data.tag_price.toString().replace(/,/g, "")
          : "";
        const tag = parseFloat(backendTagPrice);
        const safeTag = isNaN(tag) ? "" : tag;
        let formattedTagPrice = "";
        if (safeTag !== "") {
          formattedTagPrice = safeTag.toLocaleString("en-Us", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
        this.setState({
          tag_price: formattedTagPrice,
          raw_tag_price: safeTag === "" ? "" : safeTag.toFixed(2),
        });
        // Wholesale Price
        let backendWholeSalePrice = res.data.data.wholesale_price
          ? res.data.data.wholesale_price.toString().replace(/,/g, "")
          : "";
        const wholes = parseFloat(backendWholeSalePrice);
        // backendWholeSalePrice = backendWholeSalePrice.split(".")[0];
        // let formattedWholeSalePrice = backendWholeSalePrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const formattedWholeSalePrice = wholes.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        this.setState({
          wholesale_price: formattedWholeSalePrice,
          raw_wholesale_price: wholes.toFixed(2),
        });
        // Retail Price
        let backendRetailPrice = res.data.data.retail_price
          ? res.data.data.retail_price.toString().replace(/,/g, "")
          : "";
        const retail = parseFloat(backendRetailPrice);
        // backendRetailPrice = backendRetailPrice.split(".")[0];
        // let formattedRetailPrice = backendRetailPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const formattedRetailPrice = retail.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        this.setState({
          retail_price: formattedRetailPrice,
          raw_retail_price: retail.toFixed(2),
        });
        // Retail Wire Price
        let backendRetailWirePrice = res.data.data.retailwire_price
          ? res.data.data.retailwire_price.toString().replace(/,/g, "")
          : "";
        const retailwire = parseFloat(backendRetailWirePrice);
        // backendRetailWirePrice = backendRetailWirePrice.split(".")[0];
        // let formattedRetailWirePrice = backendRetailWirePrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const formattedRetailWirePrice = retailwire.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        this.setState({
          retailwire_price: formattedRetailWirePrice,
          raw_retailwire_price: retailwire.toFixed(2),
        });
        let backendPurchasedPrice = res.data.data.purchaseprice
          ? res.data.data.purchaseprice.toString().replace(/,/g, "")
          : "";
        const purchase = parseFloat(backendPurchasedPrice);
        const safePurchase = isNaN(purchase) ? "" : purchase;
        let formattedPurchasedPrice = "";
        if (safePurchase !== "") {
          formattedPurchasedPrice = safePurchase.toLocaleString("en-Us", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
        this.setState({
          PurchasedPrice: formattedPurchasedPrice,
          raw_PurchasedPrice:
            safePurchase === "" ? "" : safePurchase.toFixed(2),
        });
        let backendPurchasedExpense = res.data.data.purchase_expense
          ? res.data.data.purchase_expense.toString().replace(/,/g, "")
          : "";
        const exp = parseFloat(backendPurchasedExpense);
        const safeExp = isNaN(exp) ? "" : exp;
        let formattedPurchasedExpense = "";
        if (safeExp !== "") {
          formattedPurchasedExpense = safeExp.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
        this.setState({
          purchase_expense: formattedPurchasedExpense,
          raw_PurchasedExpense: safeExp === "" ? "" : safeExp.toFixed(2),
        });
        let backendTotalCost = res.data.data.total_cost
          ? res.data.data.total_cost.toString().replace(/,/g, "")
          : "";
        const total = parseFloat(backendTotalCost);
        const safeTotal = isNaN(total) ? "" : total;
        let formattedTotalCost = "";
        if (safeTotal !== "") {
          formattedTotalCost = safeTotal.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        }
        this.setState({
          total_cost: formattedTotalCost,
          raw_total_cost: safeTotal === "" ? "" : safeTotal.toFixed(2),
        });
        let backendNumberofLinks = res.data.data.NumberOfLinks
          ? res.data.data.NumberOfLinks.toString().replace(/,/g, "")
          : "";
        const link = parseFloat(backendNumberofLinks);
        const formattedNumberofLinks = link.toLocaleString("en-Us", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        this.setState({
          NumberOfLinks: formattedNumberofLinks,
          raw_NumberOfLinks: link.toFixed(2),
        });
        var condition =
          res.data.data && res.data.data.condition
            ? res.data.data.condition
            : "1";
        var modelnumber =
          res.data.data && res.data.data.productid
            ? res.data.data.productid
            : "";

        if (Number(res.data.data.quantity) > 1) {
          this.setState({
            quantityDisabled: true,
            SerialNumber: "",
          });
        } else {
          this.setState({
            SerialNumber:
              res.data.data && res.data.data.serialno
                ? res.data.data.serialno
                : "",
          });
        }
        // if(this.state.inventoryDetailByIdDetails.type === "misc_watch" || this.state.inventoryDetailByIdDetails.type === "misc_product"){
        //   this.setState({

        //   })
        // }

        let technical_details = {};
        if (
          res.data?.data?.technical_details &&
          typeof res.data.data.technical_details === "string"
        ) {
          technical_details = JSON.parse(res.data?.data?.technical_details);
        } else {
          technical_details = res.data?.data?.technical_details
            ? res.data?.data?.technical_details
            : {};
        }
        this.setState({
          // tag_price: res.data.data.formattedTagPrice || "",
          intial_tag_price: res.data.data.intial_tag_price || 0,
        });
        this.modelNameWasCleared = false;
        this.productTitleManuallyEdited = false;
        this.isModelTitleSynced =
          (technical_details?.product_name || "").trim() ===
          (typeof technical_details?.product_title === "string"
            ? technical_details.product_title.trim()
            : "");
        this.setState({
          inventoryDetailByIdDetails: res.data.data,
          minmax_pricelist:
            res.data.data && res.data.data.minmax_pricelist
              ? res.data.data.minmax_pricelist
              : null,
          dateformat: res.data.data.purchasedate,
          product_name:
            res.data.data && technical_details?.product_name
              ? technical_details.product_name
              : "",
          model_number:
            res.data.data && technical_details?.model_number
              ? technical_details.model_number
              : "",
          band_material:
            res.data.data && technical_details?.band_material
              ? technical_details.band_material
              : "",
          brand_name:
            res.data.data && technical_details?.brand_name
              ? technical_details.brand_name
              : "",
          case_material:
            res.data.data && technical_details?.case_material
              ? technical_details.case_material
              : "",
          case_size:
            res.data.data && technical_details?.case_size
              ? technical_details.case_size
              : "",
          dial_color:
            res.data.data && technical_details?.dial_color
              ? technical_details.dial_color
              : "",
          product_title:
            typeof technical_details?.product_title === "string"
              ? technical_details.product_title.trim()
              : "",
          description:
            res.data.data && technical_details?.description
              ? technical_details.description
              : "",
          Condition: condition,
          dealerInv:
            res.data.data && res.data.data.is_include_dealerfeed
              ? res.data.data.is_include_dealerfeed
              : false,
          shopifyConfig:
            res.data.data && res.data.data.is_include_shopify
              ? res.data.data.is_include_shopify
              : false,
          initialShopifyConfig:
            res.data.data && res.data.data.is_include_shopify
              ? res.data.data.is_include_shopify
              : false,
          shopifyProductId:
            res.data.data && res.data.data.shopifyproductid
              ? res.data.data.shopifyproductid
              : null,
          Qboitemid:
            res.data.data && res.data.data.qboitemid
              ? res.data.data.qboitemid
              : null,
          qboConfig: res.data.data && res.data.data.qboitemid ? true : false,
          initialQboConfig:
            res.data.data && res.data.data.qboitemid ? true : false,
          initialEbayConfig: res.data.data && res.data.data.is_addinventory_ebay && res.data.data.ebay_listing_id ? true : false,
          BandSize:
            res.data.data && res.data.data.bandsize
              ? res.data.data.bandsize
              : "",
          ModelNumber: modelnumber,
          PurchasedFrom:
            res.data.data && res.data.data.purchasefrom
              ? res.data.data.purchasefrom
              : "",
          quantity:
            res.data.data && res.data.data.quantity
              ? res.data.data.quantity
              : "",
          // purchaseDate: ((res.data.data) && (res.data.data.purchasedate)) ? res.data.data.purchasedate : "",
          // PurchasedPrice:
          //   res.data.data && res.data.data.purchaseprice
          //     ? res.data.data.purchaseprice
          //     : "",
          intial_purchased_price:
            res.data.data && res.data.data.purchaseprice
              ? res.data.data.purchaseprice
              : "",
          paymentDate: res.data.data.purchase_payment_date
            ? formatDate(res.data.data.purchase_payment_date, "YYYY-MM-DD")
            : null,
          intial_payment_date: res.data.data.purchase_payment_date
            ? formatDate(res.data.data.purchase_payment_date, "YYYY-MM-DD")
            : "",
          // paymentDate: ((res.data.data) && (res.data.data.purchase_payment_date)) ? res.data.data.purchase_payment_date : null,
          // purchaseDueDate: ((res.data.data) && (res.data.data.purchase_payment_duedate)) ? res.data.data.purchase_payment_duedate : null,
          paymentDetailsText:
            res.data.data && res.data.data.purchase_payment_details
              ? res.data.data.purchase_payment_details
              : "",
          intial_payment_details:
            res.data.data && res.data.data.purchase_payment_details
              ? res.data.data.purchase_payment_details
              : "",
          // paidStatus:
          //   res.data.data && res.data.data.purchase_invoice_paid
          //     ? res.data.data.purchase_invoice_paid
          //     : false,
          // intial_paid_status:
          //    res.data.data && res.data.data.purchase_invoice_paid
          //       ? res.data.data.purchase_invoice_paid
          //       : false,
          paidStatus: !!(res.data.data && res.data.data.purchase_invoice_paid),
          intial_paid_status: !!(
            res.data.data && res.data.data.purchase_invoice_paid
          ),

          // notforSale: ((res.data.data) && (res.data.data.is_notsale)) ? res.data.data.is_notsale : false,
          // SerialNumber: ,
          InventoryType:
            res.data.data && res.data.data.inventorytype
              ? res.data.data.inventorytype
              : "",
          InventoryStatus:
            res.data.data && res.data.data.inventory_status
              ? res.data.data.inventory_status
              : "",
          MemoDetails:
            res.data.data &&
              res.data.data.memodetails &&
              res.data.data.memodetails !== "null"
              ? res.data.data.memodetails
              : "",
          PartnershipDetails:
            res.data.data &&
              res.data.data.partnershipdetais &&
              res.data.data.partnershipdetais !== "null"
              ? res.data.data.partnershipdetais
              : "",
          NumberOfLinks:
            res.data.data && res.data.data.links ? res.data.data.links : "",
          DealerNotes:
            res.data.data && res.data.data.note ? res.data.data.note : "",
          intial_Dealer_Notes:
            res.data.data && res.data.data.note ? res.data.data.note : "",
          WholeSalePrice:
            res.data.data && res.data.data.wholesaleprice
              ? this.formatAmount(res.data.data.wholesaleprice)
              : "",
          raw_wholesale_price: res.data.data.wholesaleprice
            ? res.data.data.wholesaleprice.toString().replace(/,/g, "")
            : "",
          intial_wholeSale_price:
            res.data.data && res.data.data.wholesaleprice
              ? res.data.data.wholesaleprice
              : "",
          RetailPrice:
            res.data.data && res.data.data.retailprice
              ? this.formatAmount(res.data.data.retailprice)
              : "",
          raw_retail_price: res.data.data.retailprice
            ? res.data.data.retailprice.toString().replace(/,/g, "")
            : "",
          intial_retail_price:
            res.data.data && res.data.data.retailprice
              ? res.data.data.retailprice
              : "",
          RetailWirePrice:
            res.data.data && res.data.data.retailwireprice
              ? this.formatAmount(res.data.data.retailwireprice)
              : "",
          raw_retailwire_price: res.data.data.retailwireprice
            ? res.data.data.retailwireprice.toString().replace(/,/g, "")
            : "",
          intial_wire_price:
            res.data.data && res.data.data.retailwireprice
              ? res.data.data.retailwireprice
              : "",
          brandname:
            res.data.data && res.data.data.brandname
              ? res.data.data.brandname
              : "",
          // purchase_expense:
          //   res.data.data && res.data.data.purchase_expense
          //     ? res.data.data.purchase_expense
          //     : "",
          raw_PurchasedExpense: res.data.data.purchase_expense
            ? res.data.data.purchase_expense.replace(/,/g, "")
            : "",
          intial_purchase_expense:
            res.data.data && res.data.data.purchase_expense
              ? res.data.data.purchase_expense
              : "",
          purchase_expense_note:
            res.data.data && res.data.data.purchase_expense_note
              ? res.data.data.purchase_expense_note
              : "",
          public_dealer_note:
            res.data.data && res.data.data.public_dealer_note
              ? res.data.data.public_dealer_note
              : "",
          intial_public_dealer_note:
            res.data.data && res.data.data.public_dealer_note
              ? res.data.data.public_dealer_note
              : "",
          // tag_price:
          //   res.data.data && res.data.data.tag_price
          //     ? res.data.data.tag_price
          //     : "",
          raw_tag_price: res.data.data.tag_price
            ? res.data.data.tag_price.replace(/,/g, "")
            : "",
          intial_tag_price:
            res.data.data && res.data.data.tag_price
              ? res.data.data.tag_price
              : "",
          updatememo:
            res.data.data && res.data.data.memo_number
              ? res.data.data.memo_number
              : "",
          updatepartnershipnumber:
            res.data.data && res.data.data.partnership_number
              ? res.data.data.partnership_number
              : "",
          ismodified:
            res.data.data && res.data.data.ismodified
              ? res.data.data.ismodified
              : false,
          modification_deatils:
            res.data.data && res.data.data.modification_deatils
              ? res.data.data.modification_deatils
              : "",
          // ismodified: ((res.data.data) && (res.data.data.modification_deatils)) ? true : false,
          // total_cost:
          //   res.data.data && res.data.data.total_cost
          //     ? res.data.data.total_cost
          //     : "",
          locationSearch:
            res.data.data && res.data.data.inventory_location
              ? res.data.data.inventory_location
              : "",
          inventory_title:
            (res.data.data?.type === "misc_watch" ||
              res.data.data?.type === "misc_product") &&
              (technical_details?.product_title || res.data.data?.inventory_title)
              ? technical_details.product_title || res.data.data.inventory_title
              : res.data.data && res.data.data.inventory_title
                ? res.data.data.inventory_title
                : "",
          title_without_edit:
            res.data.data && res.data.data?.invattr?.model
              ? res.data.data?.invattr?.model
              : "",
          type: res.data.data && res.data.data.type ? res.data.data.type : null,
          fileArray:
            res.data.data && res.data.data.purchaseinvoiceimages
              ? res.data.data.purchaseinvoiceimages.images
              : [],
          purchaseInvoice:
            res.data.data && res.data.data.purchaseinvoiceimages
              ? res.data.data.purchaseinvoiceimages
              : null,
          warranty_paper:
            res.data.data && res.data.data.warranty_paper
              ? res.data.data.warranty_paper
              : "",
          archive:
            res.data.data && res.data.data.archive ? res.data.data.archive : "",
          isService:
            res.data.data && res.data.data.is_service
              ? res.data.data.is_service
              : false,
          purchaseFromContactId: res?.data?.data?.purchasefromcontactid || null,
          memoContactId: res?.data?.data?.memocontactid || null,
          partnerContactId: res?.data?.data?.partnercontactid || null,
          memoId: res.data?.data?.memoid || "",
          sold: res.data?.data?.sold || null,
        });
        if (res.data.data && res.data.data.productid) {
          this.getpriceListing(res.data.data.productid);
        }
        if (res.data.data && res.data.data.imagepaths) {
          const imagepaths = res.data.data.imagepaths;
          const existingImageFiles = [];
          const existingVideoFiles = [];
          Object.keys(imagepaths).forEach((key) => {
            const url = imagepaths[key];
            if (!url) return;
            if (/^video/i.test(key)) {
              existingVideoFiles.push({
                id: key,
                url,
                name: key,
                duration: null,
              });
            } else {
              existingImageFiles.push({
                id: key,
                url,
                name: key,
              });
            }
          });
          this.setState({
            imageFiles: sortInventoryImageFiles(existingImageFiles),
            videoFiles: existingVideoFiles,
          });
        }
        this.checkboxselection();
        this.boxcheckboxselection();
        // this.archiveCheckboxselection()
        // let date = res.data.data.purchasedate;
        let date = res.data.data.purchasedate || null;
        // (res.data.data.type === null ? res.data.data.createdon : null);

        const NewDate = date ? formatDate(date, "MM/DD/YYYY") : null;

        this.setState((prevState) => ({
          purchaseDate: NewDate,
          // ... other dates
        }));
        let date1 = res.data.data.warrantydate;
        let date2 = res.data.data.archive_date;
        let date3 = res.data.data.service_date;
        let date4 = res.data.data.purchase_payment_date;
        let date5 = res.data.data.purchase_payment_duedate;
        // const NewDate = date ? moment(date).format('MM/DD/YYYY') : null;
        // const NewDate1 = date1 ? moment(date1).format('MM/DD/YYYY') : null;
        // const NewDate2 = date2 ? moment(date2).format('MM/DD/YYYY') : null;
        // const NewDate3 = date3 ? moment(date3).format('MM/DD/YYYY') : null;
        // const NewDate = date ? formatDate(date, "MM/DD/YYYY") : null;
        const NewDate1 = date1 ? formatDate(date1, "MM/DD/YYYY") : null;
        const NewDate2 = date2 ? formatDate(date2, "MM/DD/YYYY") : null;
        const NewDate3 = date3 ? formatDate(date3, "MM/DD/YYYY") : null;
        const NewDate4 = date4 ? formatDate(date4, "MM/DD/YYYY") : null;
        const NewDate5 = date5 ? formatDate(date5, "MM/DD/YYYY") : null;
        this.setState((prevState) => ({
          purchaseDate: NewDate,
          purchaseDate1: NewDate1,
          archiveDate: NewDate2,
          serviceDate: NewDate3,
          paymentDate: NewDate4,
          purchaseDueDate: NewDate5,
          // purchasedFromArray: res.data?.data?.purchasefrom ?
          //   [{ userId: this.props.currentUser.userId }] : prevState.purchasedFromArray,
          // memoDetailsArray: res.data?.data?.memodetails ?
          //   [{ userId: this.props.currentUser.userId }] : prevState.memoDetailsArray,
          // partnershipDetailsArray: res.data?.data?.partnershipdetais ?
          //   [{ userId: this.props.currentUser.userId }] : prevState.partnershipDetailsArray,
        }));
      } else if (res.data.success === 0) {
        this.setState({ loaded: true });
        window.location.href = "/login";
      }
      this.setState({ isDirty: false });
    });
  }
  getpriceListing(id) {
    searchinventry.getinventrypriceList(id).then((res) => {
      this.setState({
        inventryPricelist: res.data.data,
        loaded: true,
      });
      for (let i = 0; i < this.state.inventryPricelist.length; i++) {
        if (this.state.inventryPricelist[i].watch_source == "Chrono24") {
          this.setState({
            croono21Ammount: this.state.inventryPricelist[i].avg,
          });
        } else if (this.state.inventryPricelist[i].watch_source == "Retail") {
          this.setState({ retailAmount: this.state.inventryPricelist[i].avg });
        } else if (this.state.inventryPricelist[i].watch_source == "EBay") {
          this.setState({ ebayAmout: this.state.inventryPricelist[i].avg });
        }
      }
    });
  }
  handleClickBreadCrumbs(event) {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  }
  handleGoBack() {
    this.props.history.goBack();
  }
  handleIncludeShopify = (event) => {
    this.setState({
      shopifyConfig: event.target.checked,
      isDirty: true,
    });
  };
  handleIncludeQbo = (event) => {
    this.setState({
      qboConfig: event.target.checked,
      isDirty: true,
    });
  };
  handleIncludeEbay = (event) => {
    this.setState({
      ebayConfig: event.target.checked,
      isDirty: true,
    });
  };

  backNavigation() {
    const { history } = this.props;
    history.push("/myinventory", this.props.history.location.state);
    setTimeout(() => window.scrollTo(0, 0), 50);
  }
  checkboxselection() {
    if (this.state.inventoryDetailByIdDetails.warranty_paper === "1") {
      this.setState({
        warranty_paper: "1",
      });
    } else {
      this.setState({
        warranty_paper: "",
      });
    }
  }
  archiveCheckboxselection() {
    if (this.state.inventoryDetailByIdDetails.archive === 1) {
      this.setState({
        archive: true,
      });
    } else {
      this.setState({
        archive: false,
      });
    }
  }
  boxcheckboxselection() {
    if (this.state.inventoryDetailByIdDetails.warrantybox === "1") {
      this.setState({
        box: true,
      });
      localStorage.setItem("warranty_box", "1");
    } else {
      this.setState({
        box: false,
      });
      localStorage.setItem("warranty_box", "0");
    }
  }

  onProductChange = _.debounce((e, v, r) => {
    if (v) {
      switch (e) {
        case "product_selected":
          this.setState({
            ...this.state,
            selected: { product: v },
          });
          break;
        case "input_changed":
          this.state.autocomplete.currentInput = v;

          this.state.autocomplete.loading = true;
          this.setState({
            ...this.state,
          });
          if (v.length >= 3 && r == "input") {
            this.props.searchProducts({ searchText: v }, (error, res) => { });
          }
          break;
      }
    } else {
    }
  }, 600);

  //   autocomplete(evt) {
  //     console.log(evt.target.value, "autocomptete", this.state.loaded)
  //     let text = evt.target.value;
  //     this.setState({ searchString: text });
  //     this.setState({ loading: true });
  //     this.getAutocomplete(text);
  //   }
  //   getAutocomplete = (evt) => {
  //     console.log(evt, "getauto")
  //     this.props.searchProducts({ searchText: evt }, (error, res) => {
  //       this.setState({ searchItems: this.state.autocomplete.data });
  //       this.setState({ loading: false });
  //       if (this.state.autocomplete.data.length > 0) {
  //         this.setState({
  //           individualsearchdata: true,
  //         })
  //       } else {
  //         this.setState({
  //           individualsearchdata: false,

  //         })
  //         console.log("false1  false", this.state.autocomplete.data.length > 0, this.state.loaded)

  //       }
  //     });

  //     console.log(this.state.autocomplete.data);
  //   };
  hanldeKeyup(evt) { }

  hanldeKeydown(evt) {
    // console.log(evt.target.value)
  }

  handleListKeydown(evt) {
    // console.log(evt);
  }

  handleChange(evt) {
    this.setState({ item: { [evt.target.name]: evt.target.value } });
  }
  toggleAdditionalDetails = () => {
    this.setState((prev) => ({
      showAdditionalDetails: !prev.showAdditionalDetails,
    }));
  };
  componentWillReceiveProps(newProps) {
    this.state.autocomplete.data = newProps.autocompleteProducts.list;
    this.setState({
      ...this.state,
    });
    const individualBrowseWatchesStatus = newProps.individualBrowseWatchesInfo;
    if (individualBrowseWatchesStatus.success === 0) {
      this.setState({
        onModelNumberErrorText: individualBrowseWatchesStatus.message,
        isValid: false,
      });
    } else if (
      individualBrowseWatchesStatus.success === 1 &&
      individualBrowseWatchesStatus?.data &&
      individualBrowseWatchesStatus.data?.inventoryid
    ) {
      const inventoryDetailByIdDetails =
        newProps.individualBrowseWatchesInfo.data;
      if (
        inventoryDetailByIdDetails &&
        inventoryDetailByIdDetails.prodattr &&
        !inventoryDetailByIdDetails.invattr
      ) {
        inventoryDetailByIdDetails.invattr =
          inventoryDetailByIdDetails.prodattr;
      }
      if (
        inventoryDetailByIdDetails &&
        inventoryDetailByIdDetails.productid &&
        (!this.state.inventoryDetailByIdDetails ||
          (this.state.inventoryDetailByIdDetails &&
            this.state.inventoryDetailByIdDetails.productid !==
            inventoryDetailByIdDetails.productid))
      ) {
        this.getpriceListing(inventoryDetailByIdDetails.productid);
      }
      this.setState({
        inventoryDetailByIdDetails: inventoryDetailByIdDetails,
        ModelNumber:
          inventoryDetailByIdDetails && inventoryDetailByIdDetails.productid
            ? inventoryDetailByIdDetails.productid
            : "",
        minmax_pricelist: inventoryDetailByIdDetails.minmax_pricelist || null,
        onModelNumberErrorText: "",
        isValid: true,
      });
    }
  }

  handleSelectedFiles(value, disablevalue) {
    const imageFile = disablevalue;
    let fileArray = [];
    for (let i = 0; i < imageFile.length; i++) {
      if (imageFile?.name) {
        fileArray.push(URL.createObjectURL(imageFile[i]));
        continue;
      }
      //fileArray.push(imageFile[i])
    }

    // this.setState({ file: this.fileArray })
    // Drop the saved invoice list so the backend stores the newly uploaded
    // file instead (it ignores uploads whenever purchaseInvoiceImages is sent).
    this.setState({
      bulkUploadFile: imageFile,
      fileArray: fileArray,
      purchaseInvoice: null,
    });
    this.setState({ isDirty: true });
  }
  deleteExistingInvoiceFile = (fileToRemove) => {
    const remaining = (this.state.fileArray || []).filter(
      (file) => file !== fileToRemove
    );
    this.setState({
      fileArray: remaining,
      purchaseInvoice: { ...(this.state.purchaseInvoice || {}), images: remaining },
      isDirty: true,
    });
  };
  DestructurefileType = () => {
    const resultary = this.state.fileArray;
    const result = resultary.map((value) => {
      return {
        fileName: "image",
        imageUrl: value,
      };
    });
  };
  bulkUploadFile = ({ target }) => {
    const imageFile = target.files;
    let fileArray = [];
    for (let i = 0; i < imageFile.length; i++) {
      fileArray.push(URL.createObjectURL(imageFile[i]));
    }
    this.setState({ file: this.fileArray });
    this.setState({
      bulkUploadFile: imageFile,
      fileArray: fileArray,
    });
  };

  onchangeModelNumber(product, productId) {
    this.setState({
      inventoryDetailByIdDetails: product,
      title_without_edit: product.modelname,
      // loaded: true
    });
    // if(product && product.productid){
    //   this.getpriceListing(product.productid)
    // }
    this.setState({
      nonsearchstring: false,
    });
    this.setState({
      searchString: product.productname,
      ModelNumber: product.productid,
    });
    this.setState({ searchStringdetails: product.productname });
    this.setState({ autocomplete: { data: [] } });
    // this.props.fetchSearchBrowseWatches(productId);
    if (product.productid == null) {
      this.setState({
        individualsearchdata: true,
      });
    } else {
      this.setState({
        individualsearchdata: true,
      });
    }
    this.props.individualBrowseWatch(product.productid);
    this.setState({
      onModelNumberErrorText: "",
      isValid: true,
      nonsearchstring: false,
      individualsearchdata: false,
    });
  }

  onchangeModificationDetails(event) {
    // if (event.target.value !== "") {
    let ModificationDetailsVal = event.target.value;
    if (!ModificationDetailsVal) {
      this.setState({
        modification_deatils: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        modification_deatils: event.target.value,
        isValid: true,
      });
    }
    // }
    this.setState({ isDirty: true });
  }

  onchangeCaseSize(event) {
    const value = event.target.value;
    if (value === "") {
      this.setState({
        case_size: "",
        onCaseSizeErrorText: "",
        isValid: true,
      });
      return;
    }
    if (/[a-zA-Z]/.test(value)) {
      this.setState({
        onCaseSizeErrorText: "Enter the correct Case Size",
        isValid: false,
      });
      return;
    }
    const decimalRegex = /^\d*\.?\d{0,2}$/;
    if (!decimalRegex.test(value)) {
      return;
    }
    this.setState({
      case_size: value,
      onCaseSizeErrorText: "",
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  onchangebrand(product) {
    this.setState({
      brandAutoCompleteData: { data: [] },
      brand_name: product.brandname,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  onchangeBrandName(event) {
    this.setState({
      brandloading: true,
    });
    if (event.target.value.length > 0) {
      const searchString = event.target.value.toLowerCase();
      const filterArray = this.props.brandInfo.data.filter(function (data) {
        const brandName = data.brandname.toLowerCase();
        return !(brandName.indexOf(searchString) === -1);
      });
      this.setState({
        onBrandNameErrorText: "",
        brand_name: event.target.value,
        isValid: true,
        brandloading: false,
        brandAutoCompleteData: { data: filterArray },
      });
    } else {
      this.setState({
        brandloading: false,
        onBrandNameErrorText: "",
        brand_name: event.target.value,
        isValid: true,
        brandAutoCompleteData: { data: [] },
      });
    }
    this.setState({ isDirty: true });
  }

  onchangecasematerial(product) {
    this.setState({
      caseMaterialAutoCompleteData: { data: [] },
      case_material: product.casematerial,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  onchangeCaseMaterial(event) {
    this.setState({
      caseMaterialloading: true,
    });

    if (event.target.value.length > 0) {
      const searchString = event.target.value.toLowerCase();
      const filterArray = this.props.caseMaterialInfo.data.filter(
        function (data) {
          const caseMaterial = data.casematerial.toLowerCase();
          return !(caseMaterial.indexOf(searchString) === -1);
        },
      );
      this.setState({
        onCaseMaterialErrorText: "",
        case_material: event.target.value,
        isValid: true,
        caseMaterialloading: false,
        caseMaterialAutoCompleteData: { data: filterArray },
      });
    } else {
      this.setState({
        caseMaterialloading: false,
        onCaseMaterialErrorText: "",
        case_material: event.target.value,
        isValid: true,
        caseMaterialAutoCompleteData: { data: [] },
      });
    }
    this.setState({ isDirty: true });
  }

  onchangebandmaterial(product) {
    this.setState({
      bandMaterialAutoCompleteData: { data: [] },
      band_material: product.bandmaterial,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  onchangeBandMaterial(event) {
    this.setState({
      bandMaterialloading: true,
    });

    if (event.target.value.length > 0) {
      const searchString = event.target.value.toLowerCase();
      const filterArray = this.props.brandMaterialInfo.data.filter(
        function (data) {
          const bandMaterial = data.bandmaterial.toLowerCase();
          return !(bandMaterial.indexOf(searchString) === -1);
        },
      );
      this.setState({
        onBandMaterialErrorText: "",
        band_material: event.target.value,
        isValid: true,
        bandMaterialloading: false,
        bandMaterialAutoCompleteData: { data: filterArray },
      });
    } else {
      this.setState({
        bandMaterialloading: false,
        onBandMaterialErrorText: "",
        band_material: event.target.value,
        isValid: true,
        bandMaterialAutoCompleteData: { data: [] },
      });
    }
    this.setState({ isDirty: true });
  }

  onchangeDialColor(event) {
    if (event.target.value !== "") {
      let DialColorVal = event.target.value;
      if (!DialColorVal) {
        this.setState({
          onDialColorErrorText: "Enter the correct Case Material",
          isValid: false,
        });
      } else {
        this.setState({
          onDialColorErrorText: "",
          dial_color: event.target.value,
          isValid: true,
        });
      }
    } else {
      this.setState({
        onDialColorErrorText: "",
        dial_color: "",
        isValid: true,
      });
    }
    this.setState({ isDirty: true });
  }
  handleCheck2 = (event) => {
    if (event.target.checked) {
      this.setState({
        ismodified: true,
      });
    } else {
      this.setState({
        ismodified: false,
      });
    }
    this.setState({ isDirty: true });
  };

  handleDealerInclude = (event) => {
    this.setState({ dealerInv: event.target.checked });
    this.setState({ isDirty: true });
  };

  onchangePurchasedFrom(event) {
    this.setState({
      onPurchasedFromErrorText: "",
      PurchasedFrom: event.target.value,
      isValid: true,
    });
    if (event.target.value !== "") {
    } else {
    }
    this.setState({ isDirty: true });
  }

  getAccountIds = () => {
    getBusinessAccountIds(this.state.accountid, (error, res) => {
      if (error) {
        return;
      }
      if (res?.data && res?.success == 1) {
        this.setState({
          accountIds: res.data,
        });
      }
    });
  };

  getContactDetails = (type, contactType, callback) => {
    let payload = {
      key: this.state[type],
      type: contactType,
      accountids: this.state.accountIds,
    };
    searchinventry.getInventoryContactDetails(payload, (error, response) => {
      if (response?.data && response?.status == 1) {
        callback(response.data, null);
      }
      if (error) {
        callback(null, error);
      }
    });
  };

  onchangeContactSuggestion = (event, type, contactType) => {
    const { purchaseFromContactId, memoContactId, partnerContactId } =
      this.state;
    let value = event.target.value;
    let newState = { isValid: true, fieldLoader: true };
    if (type === "PurchasedFrom") {
      newState.PurchasedFrom = value;
    } else if (type === "MemoDetails") {
      newState.MemoDetails = value;
    } else if (type === "PartnershipDetails") {
      newState.PartnershipDetails = value;
    }
    this.setState(newState, () => {
      if (value && value?.length > 2) {
        this.debouncedGetContactDetails(
          type,
          contactType,
          (data = [], error) => {
            if (data?.length > 0) {
              const filteredData = this.destructureData(data);
              this.setState((prevState) => ({
                dataset: filteredData,
                purchasedFromArray:
                  type == "PurchasedFrom" ? data : prevState.purchasedFromArray,
                memoDetailsArray:
                  type == "MemoDetails" ? data : prevState.memoDetailsArray,
                partnershipDetailsArray:
                  type == "PartnershipDetails"
                    ? data
                    : prevState.partnershipDetailsArray,
                isPopOverPurchasedFrom: type == "PurchasedFrom" ? true : false,
                isPopOverMemoDetails: type == "MemoDetails" ? true : false,
                isPopOverPartnershipDetails:
                  type == "PartnershipDetails" ? true : false,
                fieldLoader: false,
              }));
            } else {
              this.setState((prevState) => ({
                purchasedFromArray:
                  type === "PurchasedFrom" ? [] : prevState.purchasedFromArray,
                memoDetailsArray:
                  type === "MemoDetails" ? [] : prevState.memoDetailsArray,
                partnershipDetailsArray:
                  type === "PartnershipDetails"
                    ? []
                    : prevState.partnershipDetailsArray,
                dataset: [],
                fieldLoader: false,
                purchaseFromContactId:
                  type === "PurchasedFrom" ? null : purchaseFromContactId,
                memoContactId: type === "MemoDetails" ? null : memoContactId,
                partnerContactId:
                  type === "PartnershipDetails" ? null : partnerContactId,
              }));
            }
          },
        );
      } else {
        this.setState((prevState) => ({
          purchasedFromArray:
            type === "PurchasedFrom" ? [] : prevState.purchasedFromArray,
          memoDetailsArray:
            type === "MemoDetails" ? [] : prevState.memoDetailsArray,
          partnershipDetailsArray:
            type === "PartnershipDetails"
              ? []
              : prevState.partnershipDetailsArray,
          dataset: [],
          fieldLoader: false,
          purchaseFromContactId:
            type === "PurchasedFrom" ? null : purchaseFromContactId,
          memoContactId: type === "MemoDetails" ? null : memoContactId,
          partnerContactId:
            type === "PartnershipDetails" ? null : partnerContactId,
        }));
      }
    });
    this.setState({ isDirty: true });
  };

  clearContactSuggestion = (type) => {
    const { purchaseFromContactId, memoContactId, partnerContactId } =
      this.state;
    this.setState({
      [type]: "",
      [`${type.charAt(0).toLowerCase() + type.slice(1)}Array`]: [],
      dataset: [],
      purchaseFromContactId:
        type === "PurchasedFrom" ? null : purchaseFromContactId,
      memoContactId: type === "MemoDetails" ? null : memoContactId,
      partnerContactId: type === "PartnershipDetails" ? null : partnerContactId,
    });
  };

  destructureData = (data) => {
    const groupedByEmail = {};
    data.forEach((value) => {
      const Email = value.email;
      groupedByEmail[Email] = groupedByEmail[Email] || [];
      groupedByEmail[Email].push(value);
    });
    const resultArray = Object.values(groupedByEmail);
    return resultArray;
  };

  getVideoDuration = (file) =>
    new Promise((resolve) => {
      try {
        const videoEl = document.createElement("video");
        videoEl.preload = "metadata";
        videoEl.onloadedmetadata = () => {
          URL.revokeObjectURL(videoEl.src);
          resolve(videoEl.duration);
        };
        videoEl.onerror = () => resolve(null);
        videoEl.src = URL.createObjectURL(file);
      } catch (e) {
        resolve(null);
      }
    });

  makeFileEntry = (file) => {
    return {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      file,
      url: URL.createObjectURL(file),
      name: file.name || "",
      size: file.size || 0,
      type: file.type || "",
    };
  };

  handleImagesSelected = (fileList) => {
    this.setState((prev) => {
      const currentFiles = prev.imageFiles || [];
      const takenPositions = new Set(
        currentFiles
          .map((file) => file?.position || (!file?.file ? file?.id : null))
          .filter(Boolean)
          .map(String),
      );

      const nextImagePosition = () => {
        const configuredPosition = INVENTORY_MEDIA_POSITIONS.find(
          (position) => !takenPositions.has(position),
        );
        if (configuredPosition) {
          takenPositions.add(configuredPosition);
          return configuredPosition;
        }

        let preimageNumber = 1;
        while (takenPositions.has(`preimage${preimageNumber}`)) {
          preimageNumber += 1;
        }
        const position = `preimage${preimageNumber}`;
        takenPositions.add(position);
        return position;
      };

      const newFiles = Array.from(fileList).map((file) => ({
        ...this.makeFileEntry(file),
        position: nextImagePosition(),
      }));

      return {
        imageFiles: sortInventoryImageFiles([...currentFiles, ...newFiles]),
        isDirty: true,
      };
    });
  };

  removeImageFile = (id) => {
    this.setState((prev) => {
      const target = (prev.imageFiles || []).find((f) => f.id === id);
      const removed = [...(prev.removedMedia || [])];
      if (target && !target.file) {
        removed.push({
          position: target.id,
          url: target.url,
          imageUrl: this.getMediaFileName(target.url),
        });
      }
      if (target && target.url && target.url.startsWith("blob:")) URL.revokeObjectURL(target.url);
      return {
        imageFiles: (prev.imageFiles || []).filter((f) => f.id !== id),
        removedMedia: removed,
        isDirty: true,
      };
    });
  };

  handleVideosSelected = (fileList) => {
    const newFiles = Array.from(fileList).map((file) => ({ ...this.makeFileEntry(file), duration: null }));
    this.setState((prev) => ({
      videoFiles: [...(prev.videoFiles || []), ...newFiles],
      isDirty: true,
    }));
    newFiles.forEach((nf) => {
      this.getVideoDuration(nf.file).then((seconds) => {
        this.setState((prev) => ({
          videoFiles: (prev.videoFiles || []).map((v) => (v.id === nf.id ? { ...v, duration: seconds } : v)),
        }));
      });
    });
  };

  removeVideoFile = (id) => {
    this.setState((prev) => {
      const target = (prev.videoFiles || []).find((f) => f.id === id);
      const removed = [...(prev.removedMedia || [])];
      if (target && !target.file) {
        removed.push({
          position: target.id,
          url: target.url,
          imageUrl: this.getMediaFileName(target.url),
        });
      }
      if (target && target.url && target.url.startsWith("blob:")) URL.revokeObjectURL(target.url);
      return {
        videoFiles: (prev.videoFiles || []).filter((f) => f.id !== id),
        removedMedia: removed,
        isDirty: true,
      };
    });
  };


  handleInvoiceFilesSelected = (fileList) => {
    const newFile = this.makeFileEntry(fileList[0]);
    this.setState((prev) => {
      (prev.invoiceFiles || []).forEach((f) => URL.revokeObjectURL(f.url));
      return { invoiceFiles: [newFile] };
    });
  };

  removeInvoiceFile = () => {
    this.setState((prev) => {
      prev.invoiceFiles.forEach((f) => URL.revokeObjectURL(f.url));
      return { invoiceFiles: [] };
    });
  };

  handleContactSelection = (data, type) => {
    const {
      isPopOverPurchasedFrom,
      isPopOverMemoDetails,
      isPopOverPartnershipDetails,
      purchaseFromContactId,
      memoContactId,
      partnerContactId,
    } = this.state;
    const fieldName = type;
    const value = [
      data?.businessname,
      data?.firstname && data?.lastname
        ? `${data?.firstname} ${data?.lastname}`
        : data?.firstname || data?.lastname,
    ]
      ?.filter(Boolean)
      ?.join(", ");
    const contactId = data?.contactid;
    this.setState({
      isDirty: true,
      [fieldName]: value,
      isPopOverPurchasedFrom:
        fieldName === "PurchasedFrom" ? false : isPopOverPurchasedFrom,
      isPopOverMemoDetails:
        fieldName === "MemoDetails" ? false : isPopOverMemoDetails,
      isPopOverPartnershipDetails:
        fieldName === "PartnershipDetails"
          ? false
          : isPopOverPartnershipDetails,
      purchaseFromContactId:
        fieldName === "PurchasedFrom" ? contactId : purchaseFromContactId,
      memoContactId: fieldName === "MemoDetails" ? contactId : memoContactId,
      partnerContactId:
        fieldName === "PartnershipDetails" ? contactId : partnerContactId,
    });
  };

  handleContact = (val) => {
    return [
      [val?.firstname, val?.lastname].filter(Boolean).join(" "),
      val?.businessname,
      val?.billingaddress1,
      val?.billingaddress2,
      val?.billingcity,
      val?.billingstate,
      val?.billingcountry,
      val?.billingzipcode,
    ]
      .filter(Boolean)
      .join(", ");
  };

  handleVisibleChange = (visible) => {
    this.setState({
      isPopOverPurchasedFrom: visible,
      isPopOverMemoDetails: visible,
      isPopOverPartnershipDetails: visible,
    });
  };

  isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
  };

  handlePurchaseDate = (date, e) => {
    if (date === null || this.isValidDate(date)) {
      this.setState({
        error: {
          ...this.state.error,
          ["PD"]: "",
        },
        purchaseDate: e,
      });
    } else {
      this.setState({
        error: {
          ...this.state.error,
          ["PD"]: `Invalid Date`,
        },
      });
    }
    this.setState({ isDirty: true });
  };

  handleDueDateChange = (date, e) => {
    if (date === null || this.isValidDate(date)) {
      this.setState({
        error: {
          ...this.state.error,
          ["PPDD"]: "",
        },
        purchaseDueDate: e,
      });
    } else {
      this.setState({
        error: {
          ...this.state.error,
          ["PPDD"]: `Invalid Date`,
        },
      });
    }
    this.setState({ isDirty: true });
  };

  onchangepurchaseDate(date, event) {
    this.setState({
      onpurchaseDateErrorText: "",
      selectedDate: event.target.value,
      selectedDate: date,
      isValid: true,
    });

    let purchaseDateVal = event.target.value;
    if (purchaseDateVal) {
      this.setState({
        onpurchaseDateErrorText: "Choose the correct Purchased Date",
        isValid: false,
      });
    } else {
    }
    this.setState({ isDirty: true });
  }
  onchangepurchaseDate1(date1, event) {
    this.setState({
      onpurchaseDateErrorText: "",
      selectedDate: event.target.value,
      selectedDate: date1,
      isValid: true,
    });

    let purchaseDateVal = event.target.value;
    if (purchaseDateVal) {
      this.setState({
        onpurchaseDateErrorText: "Choose the correct Purchased Date",
        isValid: false,
      });
    } else {
    }
    this.setState({ isDirty: true });
  }
  formatNumber(num) {
    if (!num) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getFormattedCaretPosition = (formattedValue, rawCaretPosition) => {
    if (!rawCaretPosition) return 0;
    let rawCount = 0;

    for (let index = 0; index < formattedValue.length; index += 1) {
      if (formattedValue[index] !== ",") {
        rawCount += 1;
      }

      if (rawCount === rawCaretPosition) {
        return index + 1;
      }
    }

    return formattedValue.length;
  };

  onchangePurchasedPrice = (event) => {
    const input = event.target;
    const rawCaretPosition = input.value
      .slice(0, input.selectionStart)
      .replace(/,/g, "").length;
    let value = input.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    const formatted = this.formatNumber(value);
    const caretPosition = this.getFormattedCaretPosition(
      formatted,
      rawCaretPosition,
    );
    const purchase = Number(value);
    const expense = Number(this.state.raw_PurchasedExpense || 0);
    const totalCost = Number((purchase + expense).toFixed(2));
    let totalDisplay = parseFloat(totalCost.toString());
    this.setState(
      {
        onPurchasedPriceErrorText: "",
        PurchasedPrice: formatted,
        raw_PurchasedPrice: value,
        total_cost: this.formatNumber(totalDisplay),
        raw_total_cost: totalDisplay,
        isValid: true,
      },
      () => {
        input.setSelectionRange(caretPosition, caretPosition);
      },
    );
    this.setState({ isDirty: true });
  };

  onchangeSerialNumber(event) {
    const inventoryType = this.state?.type;
    if (
      inventoryType === null ||
      inventoryType === undefined ||
      inventoryType === "misc_watch" ||
      inventoryType === "misc_product"
    ) {
      let SerialNumberVal = event.target.value;
      if (!SerialNumberVal || SerialNumberVal === "") {
        this.setState({
          onSerialNumberErrorText: "Enter the Serial Number",
          SerialNumber: event.target.value,
          isValid: false,
        });
      } else {
        this.setState({
          onSerialNumberErrorText: "",
          SerialNumber: event.target.value,
          isValid: true,
        });
      }

      this.setState({ isDirty: true });
    }
  }
  onchangeProductName(event) {
    const nextValue = event.target.value;
    const trimmedNextValue = nextValue.trim();
    const currentTitle = this.state.product_title || "";
    const hasExistingTitle = currentTitle.trim().length > 0;

    this.setState({
      onProductNameErrorText: "",
      product_name: nextValue,
      isValid: true,
    });
    if (!this.isModelTitleSynced) {
      const prevName = (this.state.product_name || "").trim();
      if (!currentTitle.trim() && !prevName && trimmedNextValue) {
        this.isModelTitleSynced = true;
        this.modelNameWasCleared = false;
        this.productTitleManuallyEdited = false;
        this.setState({ product_title: nextValue, isDirty: true });
        return;
      }
      this.setState({ isDirty: true });
      return;
    }

    if (!trimmedNextValue) {
      this.modelNameWasCleared = true;
      this.productTitleManuallyEdited = false;
      this.setState({ product_title: "" });
      this.setState({ isDirty: true });
      return;
    }

    if (this.modelNameWasCleared) {
      this.modelNameWasCleared = false;
      if (hasExistingTitle) {
        this.setState({ isDirty: true });
        return;
      }
      this.productTitleManuallyEdited = false;
      this.setState({ product_title: nextValue, isDirty: true });
      return;
    }

    if (!this.productTitleManuallyEdited && hasExistingTitle) {
      this.setState({ product_title: nextValue, isDirty: true });
      return;
    }

    this.setState({ isDirty: true });
  }

  onchangeProductTitle(event) {
    const nextValue = event.target.value;
    this.productTitleManuallyEdited = nextValue.trim().length > 0;

    this.setState({
      onProductTitleErrorText: "",
      product_title: nextValue,
      isValid: true,
    });
    if (event.target.value === "") {
      this.setState({
        isProduct_title_Changed: true,
      });
      setTimeout(() => {
        this.setState({
          isProduct_title_Changed: false,
        });
      }, 3000);
    }
    this.setState({ isDirty: true });
  }

  onchangeDescription(event) {
    this.setState({
      onDescriptionErrorText: "",
      description: event.target.value,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }
  onchangeProductModelNumber(event) {
    this.setState({
      onModelNumberErrorText: "",
      model_number: event.target.value,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  //  onchangeQuantity(event) {
  //   if (event.target.value !== "") {
  //     let QuantityVal = validator.isNumeric(event.target.value);
  //     if (!QuantityVal) {
  //       this.setState({
  //         onQuantityErrorText: "Enter Numeric Values Only",
  //         isValid: false,
  //       });
  //     } else if (Number(event.target.value) > 1) {
  //       this.setState({
  //         quantity: event.target.value,
  //         onQuantityErrorText: "",
  //         disabled: true,
  //         isValid: true,
  //         SerialNumber: "",
  //       });
  //     } else if (Number(event.target.value) === 1) {
  //       this.setState({
  //         quantity: event.target.value,
  //         onQuantityErrorText: "",
  //         disabled: false,
  //         isValid: true,
  //       });
  //     }
  //   } else {
  //     this.setState({
  //       onQuantityErrorText: "Quantity should be minumum of 1",
  //       isValid: false,
  //       quantity: "",
  //     });
  //   }
  //   this.setState({ isDirty: true })
  // }

  onchangeCondition(event, value) {
    let ConditionVal = value;
    if (!ConditionVal) {
      this.setState({
        onConditionErrorText: "Choose the correct Condition",
        isValid: false,
      });
    } else if (ConditionVal === 5) {
      this.setState({
        onCoditionTenSuccessText: "Used/Good",
        onConditionErrorText: "",
        Condition: value,
        isValid: true,
      });
    } else {
      this.setState({
        onConditionErrorText: "",
        Condition: value,
        isValid: true,
      });
    }
    this.setState({ isDirty: true });
  }

  onchangeBandSize(event) {
    this.setState({
      onBandSizeErrorText: "",
      BandSize: event.target.value.replace(/[^0-9\.]/g, ""),
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  onchangeDealerNotes(event) {
    this.setState({
      onDealerNotesErrorText: "",
      DealerNotes: event.target.value,
      isEdited: true,
    });
    // }
    this.setState({ isDirty: true });
  }

  onchangePublicDealerNote(event) {
    this.setState({
      public_dealer_note: event.target.value,
      isValid: true,
      isEdited: true,
    });
    this.setState({ isDirty: true });
  }

  onchangeTagPrice = (event) => {
    const input = event.target;
    const rawCaretPosition = input.value
      .slice(0, input.selectionStart)
      .replace(/,/g, "").length;
    let value = input.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const caretPosition = this.getFormattedCaretPosition(
      formatted,
      rawCaretPosition,
    );
    this.setState(
      {
        tag_price: formatted,
        raw_tag_price: value,
        isValid: true,
        isEdited: true,
        isDirty: true,
      },
      () => {
        input.setSelectionRange(caretPosition, caretPosition);
      },
    );
  };

  locationAutoComplete = (evt) => {
    let text = evt.target.value;
    this.setState({ locationSearch: text, locationloading: true });
    this.getLocationAutocomplete(text);
    this.setState({ isDirty: true });
  };

  getLocationAutocomplete = (evt) => {
    // if (evt.length > 0) {
    searchLocation({ locationSearch: evt || null }, (error, res) => {
      this.setState({ locationloading: false });
      this.setState({ locationAutoCompleteData: { data: res?.data } });
    });
    // } else {
    //   this.setState({ locationloading: false });
    //   this.setState({ locationAutoCompleteData: { data: [] } });
    // }
  };

  handleLocationFocus = (event) => {
    if (!event.target.value) {
      this.locationAutoComplete(event);
    }
  };

  handleLocationBlur = () => {
    this.setState({
      locationAutoCompleteData: {
        data: [],
      },
    });
  };
  formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    return `$${parseFloat(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };
  onchangeLocation(product) {
    this.setState({
      locationAutoCompleteData: { data: [] },
      locationSearch: product.locations,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }
  // formatNumber(num) {
  //   if (!num) return "";
  //   return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // }

  onchangePurchaseExpense = (event) => {
    const input = event.target;
    const rawCaretPosition = input.value
      .slice(0, input.selectionStart)
      .replace(/,/g, "").length;
    let value = input.value.replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    const formatted = this.formatNumber(value);
    const caretPosition = this.getFormattedCaretPosition(
      formatted,
      rawCaretPosition,
    );
    const purchase = Number(this.state.raw_PurchasedPrice || 0);
    const expense = Number(value);
    const totalCost = Number((purchase + expense).toFixed(2));
    let totalDisplay = parseFloat(totalCost.toString());
    this.setState(
      {
        purchase_expense: formatted,
        raw_PurchasedExpense: value,
        total_cost: this.formatNumber(totalDisplay),
        raw_total_cost: totalDisplay,
        isValid: true,
      },
      () => {
        input.setSelectionRange(caretPosition, caretPosition);
      },
    );
    this.setState({ isDirty: true });
  };

  onchangeInventoryStatus(event) {
    this.setState({
      InventoryStatus: event.target.value,
      isValid: true,
    });
  }

  onchangeInventoryTitle(event) {
    const nextValue = event.target.value;
    const isMiscInventory =
      this.state.type === "misc_watch" || this.state.type === "misc_product";

    this.setState({
      inventory_title: nextValue,
      ...(isMiscInventory ? { product_title: nextValue } : {}),
    });
    if (nextValue === "") {
      this.setState({
        isProduct_title_Changed: true,
      });
      setTimeout(() => {
        this.setState({
          isProduct_title_Changed: false,
        });
      }, 3000);
    }
    this.setState({ isDirty: true });
  }

  onchangePurchaseExpenseNote(event) {
    this.setState({
      purchase_expense_note: event.target.value,
      isValid: true,
    });
    this.setState({ isDirty: true });
  }

  onchangeNumberOfLinks(event) {
    let value = event.target.value.replace(/,/g, "");
    value = value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.setState({
      NumberOfLinks: formatted,
      raw_NumberOfLinks: value,
      onNumberOfLinksErrorText: "",
    });
    this.setState({ isDirty: true });
  }

  onchangeWholeSalePrice(event) {
    // if (event.target.value !== "") {
    const input = event.target;
    const rawCaretPosition = input.value
      .slice(0, input.selectionStart)
      .replace(/,/g, "").length;
    let value = input.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const caretPosition = this.getFormattedCaretPosition(
      formatted,
      rawCaretPosition,
    );
    this.setState(
      {
        onWholeSalePriceErrorText: "",
        WholeSalePrice: formatted,
        raw_wholesale_price: value,
      },
      () => {
        input.setSelectionRange(caretPosition, caretPosition);
      },
    );
    // }
    this.setState({ isDirty: true, isValid: true, isEdited: true });
  }

  ImagePreviewGrid = ({ files, onRemove }) => {
    const previewFile = this.state.imagePreviewFile || null;
    const setPreviewFile = (f) => this.setState({ imagePreviewFile: f });
    return (
      <div className="ai-uploads__previews">
        {sortInventoryImageFiles(files || []).map((f) => (
          <div className="ai-uploads__thumb" key={f.id}>
            <img src={f.url} alt={f.name} onClick={() => setPreviewFile(f)} />
            <div className="ai-uploads__thumb-preview-overlay" onClick={() => setPreviewFile(f)}>
              <VisibilityOutlinedIcon style={{ fontSize: 18, color: "#fff" }} />
            </div>
            <button
              type="button"
              className="ai-uploads__thumb-remove"
              onClick={() => onRemove(f.id)}
              aria-label="Remove image"
            >
              <CloseIcon style={{ fontSize: 12 }} />
            </button>
          </div>
        ))}

        <Dialog open={!!previewFile} onClose={() => setPreviewFile(null)} maxWidth="md" fullWidth>
          <div className="ai-invoice-dialog__header">
            <Typography className="ai-invoice-dialog__title">{previewFile?.name}</Typography>
            <IconButton size="small" onClick={() => setPreviewFile(null)} aria-label="Close preview">
              <CloseIcon style={{ fontSize: 18 }} />
            </IconButton>
          </div>
          <DialogContent className="ai-invoice-dialog__content">
            {previewFile && (
              <img src={previewFile.url} alt={previewFile.name} className="ai-invoice-dialog__image" />
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  VideoPreviewGrid = ({ files, onRemove }) => {
    const previewFile = this.state.videoPreviewFile || null;
    const setPreviewFile = (f) => this.setState({ videoPreviewFile: f });
    return (
      <div className="ai-uploads__previews">
        {(files || []).map((f) => (
          <div className="ai-uploads__thumb" key={f.id}>
            <video src={f.url} onClick={() => setPreviewFile(f)} className="ai-uploads__video-thumb" />
            <div className="ai-uploads__thumb-preview-overlay" onClick={() => setPreviewFile(f)}>
              <VisibilityOutlinedIcon style={{ fontSize: 18, color: "#fff" }} />
            </div>
            <div className="ai-uploads__thumb-meta">{f.duration ? `${Math.round(f.duration)}s` : ""}</div>
            <button
              type="button"
              className="ai-uploads__thumb-remove"
              onClick={() => onRemove(f.id)}
              aria-label="Remove video"
            >
              <CloseIcon style={{ fontSize: 12 }} />
            </button>
          </div>
        ))}

        <Dialog open={!!previewFile} onClose={() => setPreviewFile(null)} maxWidth="md" fullWidth>
          <div className="ai-invoice-dialog__header">
            <Typography className="ai-invoice-dialog__title">{previewFile?.name}</Typography>
            <IconButton size="small" onClick={() => setPreviewFile(null)} aria-label="Close preview">
              <CloseIcon style={{ fontSize: 18 }} />
            </IconButton>
          </div>
          <DialogContent className="ai-invoice-dialog__content">
            {previewFile && (
              <video src={previewFile.url} controls className="ai-invoice-dialog__video" />
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  onchangeRetailPrice(event) {
    const input = event.target;
    const rawCaretPosition = input.value
      .slice(0, input.selectionStart)
      .replace(/,/g, "").length;
    let value = input.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const caretPosition = this.getFormattedCaretPosition(
      formatted,
      rawCaretPosition,
    );
    this.setState(
      {
        onRetailPriceErrorText: "",
        RetailPrice: formatted,
        raw_retail_price: value,
      },
      () => {
        input.setSelectionRange(caretPosition, caretPosition);
      },
    );
    this.setState({ isDirty: true, isValid: true, isEdited: true });
  }

  onchangeRetailWirePrice(event) {
    const input = event.target;
    const rawCaretPosition = input.value
      .slice(0, input.selectionStart)
      .replace(/,/g, "").length;
    let value = input.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const caretPosition = this.getFormattedCaretPosition(
      formatted,
      rawCaretPosition,
    );
    this.setState(
      {
        onRetailWirePriceErrorText: "",
        RetailWirePrice: formatted,
        raw_retailwire_price: value,
      },
      () => {
        input.setSelectionRange(caretPosition, caretPosition);
      },
    );
    this.setState({ isDirty: true, isValid: true, isEdited: true });
  }

  onchangePaymentDetails(event) {
    this.setState({
      onPaymentDetailsErrorText: "",
      paymentDetailsText: event.target.value,
      isEdited: true,
    });
    this.setState({ isDirty: true });
  }

  onProductChange(e, v, r) {
    switch (e) {
      case "product_selected":
        this.onchangeModelNumber(v.productid);
        break;
      case "input_changed":
        this.state.autocomplete.currentInput = v;
        this.setState({
          ...this.state,
        });

        this.state.autocomplete.loading = true;
        this.setState({
          ...this.state,
        });

        if (v.length >= 3 && r == "input") {
          this.props.searchProducts({ searchText: v }, (error, res) => {
            // console.log(error, res);
          });
        }

        break;
    }
  }

  valuetext = (value) => {
    return "mm";
  };
  handleClickOpen = () => {
    this.setState({
      setOpen: "true",
    });
  };

  handleClose = () => {
    this.setState({
      setOpen: "false",
    });
  };

  handleTypeOfArchive = (event) => {
    if (event.target.checked == true) {
      this.setState({
        archive: "1",
      });
      localStorage.setItem("archive", "1");
    } else {
      this.setState({
        archive: "",
      });
      // this.setState({
      //   archiveDate: null,
      // })
      localStorage.setItem("archive", "");
    }
    this.setState({ isDirty: true });
  };
  handleTypeOfWarranty = (event) => {
    if (event.target.checked == true) {
      this.setState({
        warranty_paper: "1",
      });
      localStorage.setItem("warranty_paper", "1");
    } else {
      this.setState({
        warranty_paper: "",
      });
      localStorage.setItem("warranty_paper", "");
    }
    this.setState({ isDirty: true });
  };
  handleTypeOfService = (event) => {
    if (event.target.checked == true) {
      this.setState({
        isService: true,
      });
    } else {
      this.setState({
        isService: false,
      });
    }
    this.setState({ isDirty: true });
  };

  handlePaidStatusCheck = (event) => {
    this.setState({
      paidStatus: event.target.checked,
      isEdited: true,
    });
    this.setState({ isDirty: true });
  };

  handleNotforSaleCheck = (event) => {
    this.setState({
      notforSale: event.target.checked,
    });
  };

  getMediaFileName = (url) => {
    if (!url) return "";
    const clean = String(url).split("?")[0];
    return clean.substring(clean.lastIndexOf("/") + 1);
  };

  callAddInventoryImage = (fd, failMessage) =>
    new Promise((resolve) => {
      addInventoryImage(fd, (error) => {
        if (error) {
          toast(
            error?.response?.data?.message || error?.message || failMessage,
            {
              autoClose: 2000,
              type: toast.TYPE.ERROR,
              position: toast.POSITION.BOTTOM_CENTER,
            },
          );
          return resolve({ success: false, error });
        }
        return resolve({ success: true });
      });
    });

  uploadInventoryMedia = (inventoryId) => {
    const s = this.state || {};
    const imageFiles = s.imageFiles || [];
    const videoFiles = s.videoFiles || [];
    const removedMedia = s.removedMedia || [];

    const requests = [];

    removedMedia.forEach((m) => {
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", m.position);
      fd.set("image", m.url || "");
      fd.set("imageUrl", m.imageUrl || this.getMediaFileName(m.url));
      fd.set("type", "delete");
      fd.set("modified_by", this.props.currentUser?.userId);
      requests.push(() => this.callAddInventoryImage(fd, "Delete failed"));
    });
    const takenImagePositions = new Set(
      imageFiles
        .map((file) => file?.position || (!file?.file ? file?.id : null))
        .filter(Boolean)
        .map(String),
    );
    let preImageCounter = 0;
    const nextImagePosition = () => {
      const free = INVENTORY_MEDIA_POSITIONS.find((p) => !takenImagePositions.has(p));
      if (free) {
        takenImagePositions.add(free);
        return free;
      }
      let pos;
      do {
        preImageCounter += 1;
        pos = `preimage${preImageCounter}`;
      } while (takenImagePositions.has(pos));
      takenImagePositions.add(pos);
      return pos;
    };

    sortInventoryImageFiles(imageFiles).forEach((entry) => {
      if (!entry || !entry.file) return;
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", entry.position || nextImagePosition());
      fd.set("image", entry.file);
      fd.set("modified_by", this.props.currentUser?.userId);
      requests.push(() => this.callAddInventoryImage(fd, "Image upload failed"));
    });

    const takenVideoPositions = new Set(
      videoFiles.filter((v) => v && !v.file && v.id).map((v) => String(v.id)),
    );
    let videoCounter = 0;
    const nextVideoPosition = () => {
      let pos;
      do {
        videoCounter += 1;
        pos = `video${videoCounter}`;
      } while (takenVideoPositions.has(pos));
      takenVideoPositions.add(pos);
      return pos;
    };

    videoFiles.forEach((entry) => {
      if (!entry || !entry.file) return;
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", nextVideoPosition());
      fd.set("image", entry.file);
      fd.set("modified_by", this.props.currentUser?.userId);
      requests.push(() => this.callAddInventoryImage(fd, "Video upload failed"));
    });

    if (requests.length === 0) return Promise.resolve([]);
    return requests.reduce(
      (chain, req) => chain.then((acc) => req().then((r) => [...acc, r])),
      Promise.resolve([]),
    );
  };


  UploadDropzone = ({ icon, title, hint, onFilesSelected, inputId, multiple = true, accept }) => {
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.dataTransfer?.files?.length) {
        onFilesSelected(e.dataTransfer.files);
      }
    };

    const handleInputChange = (e) => {
      if (e.target.files && e.target.files.length) onFilesSelected(e.target.files);
    };

    return (
      <div
        className="ai-dropzone"
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <label htmlFor={inputId}>
          <div className="ai-dropzone__icon">{icon}</div>
          <Typography className="ai-dropzone__title">{title}</Typography>
          <Typography className="ai-dropzone__hint">{hint}</Typography>
        </label>
        <input
          id={inputId}
          type="file"
          accept={accept}
          multiple={multiple}
          style={{ display: "none" }}
          onChange={handleInputChange}
        />
      </div>
    );
  };

  handleCheck = (event) => {
    if (event.target.checked) {
      this.setState({
        warrentyExpiryDate: true,
        WarentyPaper: true,
        warranty_paper: "1",
        typeOfPaper: "1",
      });
    } else {
      this.setState({
        warrentyExpiryDate: false,
        WarentyPaper: false,
        warranty_paper: "0",
        typeOfPaper: "0",
      });
    }
  };

  handleCheck1 = (event) => {
    if (event.target.checked == true) {
      this.setState({
        box: true,
      });
      localStorage.setItem("warranty_box", "1");
    } else {
      this.setState({
        box: false,
      });
      localStorage.setItem("warranty_box", "0");
    }
    this.setState({ isDirty: true });
  };
  validateInput() {
    let onModelNumberErrorText = "";

    let onSerialNumberErrorText = "";
    let onConditionErrorText = "";
    let modificationDetailsError = "";
    let isValid = true;
    if (
      (!this.state.SerialNumber || this.state.SerialNumber.length === 0) &&
      this.state.type !== "misc_product"
    ) {
      onSerialNumberErrorText = "Enter Serial Number";
      isValid = false;
    }
    if (this.state.Condition.length === 0) {
      onConditionErrorText = "Enter Condition";
      isValid = false;
    }
    if (
      this.state.ismodified &&
      this.state.modification_deatils &&
      this.state.modification_deatils.length === 0
    ) {
      modificationDetailsError = "Enter Modiification Details";
      isValid = false;
    }
    this.setState({
      onSerialNumberErrorText,
      onConditionErrorText,
      modificationDetailsError,
    });
    return isValid;
  }
  normalizePriceWithDecimal = (value) => {
    if (!value) return "";
    const num = value.toString().replace(/,/g, "");
    return num.includes(".") ? num : `${num}.00`;
  };

  submitForm(event) {
    if (this.state.loading) {
      if (event && event.preventDefault) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    if (!this.state.isDirty) {
      if (event && event.preventDefault) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    if (this.state.PurchasedFrom && !this.state.purchaseFromContactId) {
      this.setState({ loading: false });
      this.purchasedFromRef?.current?.focus();
      return;
    } else if (this.state.MemoDetails && !this.state.memoContactId) {
      this.setState({ loading: false });
      this.memoDetailsRef.current?.focus();
      return;
    } else if (this.state.PartnershipDetails && !this.state.partnerContactId) {
      this.setState({ loading: false });
      this.partnershipDetailsRef.current?.focus();
      return;
    }
    let warrentydate = this.state.warranty_paper
      ? this.state.warranty_paper
      : this.state.inventoryDetailByIdDetails.warrantydate;
    let archive_date = this.state.archive
      ? this.state.archive
      : this.state.inventoryDetailByIdDetails.archive_date;
    let service_date = this.state.isService
      ? this.state.isService
      : this.state.inventoryDetailByIdDetails.service_date;
    let x = localStorage.getItem("warranty_box");
    if (warrentydate === "") {
      this.setState({ purchaseDate1: "" });
    } else {
      this.setState({
        purchaseDate1: this.state.purchaseDate1
          ? this.state.purchaseDate1
          : this.state.inventoryDetailByIdDetails.warrantydate,
      });
    }
    if (archive_date === "") {
      this.setState({ archiveDate: null });
    } else {
      this.setState({
        archiveDate: this.state.archiveDate
          ? this.state.archiveDate
          : this.state.inventoryDetailByIdDetails.archive_date,
      });
    }
    if (service_date === "") {
      this.setState({ serviceDate: null });
    } else {
      this.setState({
        serviceDate: this.state.serviceDate
          ? this.state.serviceDate
          : this.state.inventoryDetailByIdDetails.service_date,
      });
    }
    if (this.state.archive === false) {
      this.setState({ archiveDate: null });
    }
    if (this.state.warranty_paper != "1") {
      this.setState({ purchaseDate1: null });
      this.state.inventoryDetailByIdDetails.warrantydate = "";
    }
    if (!this.state.isService) {
      this.setState({ service_date: null });
    }
    //  if (this.validateInput()) {
    const isValid = this.validateInput();
    if (!isValid) {
      this.setState({ loading: false });
      return;
    }
    this.setState({ loading: true });

    if (!isValid) {
      return;
    }
    let technical_details = {};
    let attributes = {};
    const PId = this.props?.match?.params?.inventryId
      ? this.props?.match?.params?.inventryId
      : null;
    if (
      this.state.inventoryDetailByIdDetails.type === "misc_product" ||
      this.state.inventoryDetailByIdDetails.type === "misc_watch"
    ) {
      technical_details = {
        product_name: this.state.product_name ? this.state.product_name : "",
        brand_name: this.state.brand_name ? this.state.brand_name : "",
        description: this.state.description ? this.state.description : "",
        model_number: this.state.model_number ? this.state.model_number : "",
        product_title: this.state.product_title
          ? this.state.product_title.trim()
          : "",
        case_material: this.state.case_material
          ? this.state.case_material
          : "",
        case_size: this.state.case_size ? this.state.case_size : "",
        dial_color: this.state.dial_color ? this.state.dial_color : "",
        band_material: this.state.band_material
          ? this.state.band_material
          : "",
      };
    } else {
      attributes = {
        reference: this.state.inventoryDetailByIdDetails.model,
        productname: this.state.inventoryDetailByIdDetails.productname,
        productfamily: this.state.inventoryDetailByIdDetails.productfamily,
        bezel: "",
        gender: "",
        glass: this.state.inventoryDetailByIdDetails?.invattr?.glass,
        shape: this.state.inventoryDetailByIdDetails?.invattr?.shape,
        waterresistant: this.state.inventoryDetailByIdDetails?.waterresistant,
        caliber: this.state.inventoryDetailByIdDetails?.invattr?.caliber,
        movement: this.state.inventoryDetailByIdDetails?.invattr?.movement,
        casesize: this.state.inventoryDetailByIdDetails?.invattr?.casesize,
        powerreserve:
          this.state.inventoryDetailByIdDetails?.invattr?.powerreserve,
        indices: this.state.inventoryDetailByIdDetails?.invattr?.indices,
        casematerial:
          this.state.inventoryDetailByIdDetails?.invattr?.casematerial,
        bandmaterial:
          this.state.inventoryDetailByIdDetails?.invattr?.bandmaterial,
        dialcolor: this.state.inventoryDetailByIdDetails?.invattr?.dialcolor,
        inventory_title:
          this.state.inventoryDetailByIdDetails?.invattr?.model,
        circa: "",
        productcode: "",
        luminous: "",
        bandcolor: "",
        bandtype: "",
        buckletype: "",
      };
    }
    // console.log(this.state, 'this.statethis.state')
    // return
    let data = {
      product_id: this.state?.inventoryDetailByIdDetails?.productid || null,
      accountid: this.state?.accountid,
      type: this.state?.type,
      technical_details: technical_details
        ? JSON.stringify(technical_details)
        : null,
      attributes: attributes ? JSON.stringify(attributes) : null,
      purchase_price: this.state.raw_PurchasedPrice
        ? this.normalizePriceWithDecimal(this.state.raw_PurchasedPrice)
        : " ",
      old_purchase_price: this.state.intial_purchased_price
        ? this.normalizePriceWithDecimal(this.state.intial_purchased_price)
        : "",
      purchase_date: this.state.purchaseDate ? this.state.purchaseDate : "",
      purchase_from: this.state.PurchasedFrom ? this.state.PurchasedFrom : "",
      purchasefromcontactid: this.state.purchaseFromContactId || null,
      memocontactid: this.state.memoContactId || null,
      partnercontactid: this.state.partnerContactId || null,
      serial_no: this.state.SerialNumber ? this.state.SerialNumber : "",
      inventory_type: this.state.InventoryType
        ? this.state.InventoryType
        : "",
      inventory_status: this.state.InventoryStatus
        ? this.state.InventoryStatus
        : "",
      memo_details: this.state.MemoDetails ? this.state.MemoDetails : "",
      partnership_detais: this.state.PartnershipDetails
        ? this.state.PartnershipDetails
        : "",
      condition: this.state.Condition
        ? this.state.Condition
        : this.state.inventoryDetailByIdDetails.condition,
      band_size: this.state.BandSize
        ? this.state.BandSize
        : this.state.inventoryDetailByIdDetails.bandsize,
      links: this.state.NumberOfLinks ? this.state.NumberOfLinks : "",
      note: this.state.DealerNotes ? this.state.DealerNotes : "",
      wholesale_price: this.state.raw_wholesale_price
        ? this.normalizePriceWithDecimal(this.state.raw_wholesale_price)
        : "",
      old_wholesale_price: this.state.intial_wholeSale_price
        ? this.normalizePriceWithDecimal(this.state.intial_wholeSale_price)
        : "",
      retail_price: this.state.raw_retail_price
        ? this.normalizePriceWithDecimal(this.state.raw_retail_price)
        : "",
      old_retail_price: this.state.intial_retail_price
        ? this.normalizePriceWithDecimal(this.state.intial_retail_price)
        : "",
      retailwire_price: this.state.raw_retailwire_price
        ? this.normalizePriceWithDecimal(this.state.raw_retailwire_price)
        : "",
      old_retailwire_price: this.state.intial_wire_price
        ? this.normalizePriceWithDecimal(this.state.intial_wire_price)
        : "",
      warranty_paper: this.state.warranty_paper
        ? this.state.warranty_paper
        : "",
      archive: this.state.archive ? this.state.archive : "",
      is_service: this.state.isService ? this.state.isService : "",
      service_date: this.state.serviceDate ? this.state.serviceDate : "",
      warranty_box: x ? x : "0",
      created_by: this.props.currentUser.userId,
      warranty_date: this.state.purchaseDate1,
      archive_date: this.state.archiveDate,
      brandname: this.state.brandname ? this.state.brandname : "",
      inventory_id: this.state.inventoryDetailByIdDetails?.inventoryid
        ? this.state.inventoryDetailByIdDetails?.inventoryid
        : PId,
      public_dealer_note: this.state.public_dealer_note
        ? this.state.public_dealer_note
        : "",
      memo_number: this.state.updatememo ? this.state.updatememo : "",
      partnership_number: this.state.updatepartnershipnumber || "",
      total_cost: this.state.raw_total_cost
        ? this.normalizePriceWithDecimal(this.state.raw_total_cost)
        : "",
      tag_price: this.state.raw_tag_price
        ? this.normalizePriceWithDecimal(this.state.raw_tag_price)
        : "",
      old_tag_price: this.state.intial_tag_price
        ? this.normalizePriceWithDecimal(this.state.intial_tag_price)
        : "",
      modification_deatils: this.state.modification_deatils
        ? this.state.modification_deatils
        : "",
      purchase_expense: this.state.raw_PurchasedExpense
        ? this.normalizePriceWithDecimal(this.state.raw_PurchasedExpense)
        : "",
      old_purchase_expense: this.state.intial_purchase_expense
        ? this.normalizePriceWithDecimal(this.state.intial_purchase_expense)
        : "",
      purchase_expense_note: this.state.purchase_expense_note
        ? this.state.purchase_expense_note
        : "",
      paperType: this.state.typeOfPaper || "",
      inventory_location: this.state.locationSearch || "",
      inventory_title:
        this.state.type === "misc_watch" || this.state.type === "misc_product"
          ? this.state.product_title
            ? this.state.product_title.trim()
            : ""
          : this.state.inventory_title
            ? this.state.inventory_title.trim()
            : "",
      quantity: this.state.quantity || "1",
      // "ismodified": this.state.inventory_title.toLowerCase() !== this.state.title_without_edit.toLowerCase() ? true : false,
      ismodified: this.state.ismodified,
      purchase_payment_date: this.state.paymentDate ?? null,
      purchase_payment_duedate: this.state.purchaseDueDate ?? null,
      purchase_payment_details: this.state.paymentDetailsText,
      purchase_invoice_paid: this.state.paidStatus,
      is_include_dealerfeed: this.state.dealerInv,
      is_include_shopify: this.state.shopifyConfig,
      is_include_qbo: this.state.qboConfig,
      is_include_ebayconfig: this.state.ebayConfig,
      shopifyproductid: this.state.shopifyProductId
        ? this.state.shopifyProductId
        : null,
      // 'is_notsale': this.state.notforSale
    };
    const normalizePrice = (v) => {
      if (v === null || v === undefined || v === "") return 0;
      return Number(String(v).replace(/,/g, ""));
    };
    let changes = {
      is_note_edit: this.state.DealerNotes !== this.state.intial_Dealer_Notes,
      is_public_dealer_note_edit:
        this.state.public_dealer_note !==
        this.state.intial_public_dealer_note,
      is_purchase_payment_date_edit:
        formatDate(this.state.paymentDate, "YYYY-MM-DD") !==
        formatDate(this.state.intial_payment_date, "YYYY-MM-DD"),
      is_purchase_payment_details_edit:
        this.state.paymentDetailsText !== this.state.intial_payment_details,
      is_purchase_invoice_paid_edit:
        this.state.paidStatus !== this.state.intial_paid_status,
      is_purchesd_price_edit:
        normalizePrice(this.state.raw_PurchasedPrice) !==
        normalizePrice(this.state.intial_purchased_price),
      is_wholesale_price_edit:
        normalizePrice(this.state.raw_wholesale_price) !==
        normalizePrice(this.state.intial_wholeSale_price),
      is_retail_price_edit:
        normalizePrice(this.state.raw_retail_price) !==
        normalizePrice(this.state.intial_retail_price),
      is_retailwire_price_edit:
        normalizePrice(this.state.raw_retailwire_price) !==
        normalizePrice(this.state.intial_wire_price),
      is_tag_price_edit:
        normalizePrice(this.state.raw_tag_price) !==
        normalizePrice(this.state.intial_tag_price),
      is_purchase_expense_edit:
        normalizePrice(this.state.raw_PurchasedExpense) !==
        normalizePrice(this.state.intial_purchase_expense),
    };
    let filteredChanges = {};
    for (const key in changes) {
      if (changes[key]) {
        filteredChanges[key] = changes[key];
      }
    }
    data.eventrequestchanged = filteredChanges;
    if (data.inventory_id === "undefined") {
      data.inventory_id = PId;
    }
    if (this.state.purchaseInvoice && this.state.purchaseInvoice !== null) {
      data.purchaseInvoiceImages = JSON.stringify(this.state.purchaseInvoice);
    } // if (this.state.inventoryDetailByIdDetails.productid.length === 0) {
    //   delete data.product_id;
    // }
    if (attributes.length === 0) {
      delete data.attributes;
    }
    if (technical_details.length === 0) {
      delete data.technical_details;
    }
    if (this.state.PurchasedPrice.length === 0) {
      delete data.purchase_price;
    }
    if (this.state.InventoryStatus.length === 0) {
      delete data.inventory_status;
    }
    if (this.state.archive.length === 0) {
      delete data.archive;
    }
    if (!this.state.isService) {
      delete data.is_service;
    }
    if (this.state.MemoDetails.length === 0) {
      delete data.memo_details;
    }
    if (this.state.PartnershipDetails.length === 0) {
      delete data.partnership_detais;
    }
    if (
      this.state.purchaseDate === "Invalid date" ||
      this.state.purchaseDate === null
    ) {
      delete data.purchase_date;
    }
    if (this.state.PurchasedFrom.length === 0) {
      delete data.purchase_from;
    }
    if (!this.state.purchaseFromContactId) {
      delete data.purchasefromcontactid;
    }
    if (!this.state.memoContactId) {
      delete data.memocontactid;
    }
    if (!this.state.partnerContactId) {
      delete data.partnercontactid;
    }
    if (!this.state.SerialNumber || this.state.SerialNumber.length === 0) {
      delete data.serial_no;
    }
    if (this.state.Condition.length === 0) {
      delete data.condition;
    }
    if (this.state.BandSize.length === 0) {
      delete data.band_size;
    }
    if (this.state.NumberOfLinks.length === 0) {
      delete data.links;
    }
    if (this.state.DealerNotes.length === 0) {
      delete data.note;
    }
    if (this.state.WholeSalePrice.length === 0) {
      delete data.wholesale_price;
    }
    if (this.state.RetailPrice.length === 0) {
      delete data.retail_price;
    }
    if (this.state.RetailWirePrice.length === 0) {
      delete data.retailwire_price;
    }
    if (this.state.warranty_paper.length === 0) {
      delete data.warranty_paper;
      data.warranty_date = null;
    }

    if (
      this.state.purchaseDate1 === "Invalid date" ||
      this.state.purchaseDate1 === null ||
      this.state.purchaseDate1 === ""
    ) {
      delete data.warranty_date;
    }
    if (
      this.state.archiveDate === "Invalid date" ||
      this.state.archiveDate === null
    ) {
      delete data.archive_date;
    }
    if (
      this.state.serviceDate === "Invalid date" ||
      this.state.serviceDate === null
    ) {
      delete data.service_date;
    }
    if (this.props.currentUser.userId) {
      delete data.created_by;
    }

    if (!this.state.warranty_paper) {
      delete data.warranty_paper;
      data.warranty_date = null;
    }

    if (this.state.total_cost.length === 0) {
      delete data.total_cost;
    }
    if (this.state.tag_price.length === 0) {
      delete data.tag_price;
    }
    if (this.state.purchase_expense.length === 0) {
      delete data.purchase_expense;
    }
    if (this.state.purchase_expense_note.length === 0) {
      delete data.purchase_expense_note;
    }
    // if (this.state.locationSearch.length === 0) {
    //   delete data.inventory_location;
    // }
    if (this.state.public_dealer_note.length === 0) {
      delete data.public_dealer_note;
    }
    if (this.state.InventoryStatus.length === 0) {
      delete data.inventory_status;
    }
    if (
      (this.state.MemoDetails && this.state.MemoDetails.length === 0) ||
      !this.state.MemoDetails
    ) {
      delete data.memo_details;
    }
    if (
      !this.state.updatememo ||
      (this.state.updatememo && this.state.updatememo.length === 0)
    ) {
      delete data.memo_number;
    }
    if (
      !this.state.updatepartnershipnumber ||
      (this.state.updatepartnershipnumber &&
        this.state.updatepartnershipnumber.length === 0)
    ) {
      delete data.partnership_number;
    }
    if (
      (this.state.PartnershipDetails &&
        this.state.PartnershipDetails.length === 0) ||
      !this.state.PartnershipDetails
    ) {
      delete data.partnership_detais;
    }
    if (this.state.modification_deatils.length === 0) {
      delete data.modification_deatils;
    }
    if (this.state.InventoryType.length === 0) {
      delete data.inventory_type;
    }
    if (data.warranty_date === null || data.warranty_date === "null") {
      delete data.warranty_date;
    }
    if (
      !data.purchase_payment_date ||
      !this.state.paymentDate ||
      !this.state.paidStatus
    ) {
      delete data.purchase_payment_date;
    }
    if (
      !data.purchase_payment_duedate ||
      !this.state.purchaseDueDate ||
      this.state.paidStatus
    ) {
      delete data.purchase_payment_duedate;
    }

    let formData = new FormData();
    for (const key of Object.keys(this.state.bulkUploadFile)) {
      formData.append("image", this.state.bulkUploadFile[key]);
    }
    for (const key in data) {
      if (key === "eventrequestchanged") {
        formData.set("eventrequestchanged", JSON.stringify(data[key]));
      } else {
        formData.set(key, data[key]);
      }
    }
    searchinventry
      .updateInventryDetails(formData)
      .then((res) => {
        if (res && res.data && res.data.success === 1) {
          localStorage.removeItem("warranty_box");
          toast(res.data.data, {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.BOTTOM_CENTER,
          });

          const inventoryId = data?.inventory_id;
          const hasNewImages = (this.state.imageFiles || []).some((f) => f && f.file);
          const hasNewVideos = (this.state.videoFiles || []).some((v) => v && v.file);
          const hasRemovedMedia = (this.state.removedMedia || []).length > 0;
          const shouldUploadMedia =
            !!inventoryId && (hasNewImages || hasNewVideos || hasRemovedMedia);


          if (shouldUploadMedia) {
            this.uploadInventoryMedia(inventoryId)
              .then(() => {
                this.setState({ loading: false, removedMedia: [] });

                this.props.history.push(
                  "/inventory-detail/" + inventoryId + "/" + this.props.currentUser.userId,
                  this.props.history.location.state,
                );
              })
              .catch(() => {
                this.setState({ loading: false });
                this.props.history.push(
                  "/inventory-detail/" + inventoryId + "/" + this.props.currentUser.userId,
                  this.props.history.location.state,
                );
              });
          } else {
            this.setState({ loading: false });
            this.props.history.push(
              "/inventory-detail/" + inventoryId + "/" + this.props.currentUser.userId,
              this.props.history.location.state,
            );
          }
        } else {
          this.setState({ loading: false });
          toast(res?.data?.message || res?.data?.data, {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast(err?.response?.data?.message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });
    // }
  }
  checloaader() {
    this.setState({ loaded: false });
    setTimeout(() => {
      this.setState({ loaded: true });
    }, 3000);
  }

  handleDateChange = (date, e) => {
    if (date === null || this.isValidDate(date)) {
      this.setState({
        error: {
          ...this.state.error,
          ["PPD"]: "",
        },
        paymentDate: e,
      });
    } else {
      this.setState({
        error: {
          ...this.state.error,
          ["PPD"]: `Invalid Date`,
        },
      });
    }
    this.setState({ isDirty: true });
  };

  handleDateChange1 = (date, e, type) => {
    if (date === null || this.isValidDate(date)) {
      this.setState({
        error: {
          ...this.state.error,
          [type]: "",
        },
      });
      if (type === "Warranty") {
        this.setState({
          purchaseDate1: e,
        });
      } else if (type === "Archive") {
        this.setState({
          archiveDate: e,
        });
      } else if (type === "Service") {
        this.setState({
          serviceDate: e,
        });
      }
    } else {
      this.setState({
        error: {
          ...this.state.error,
          [type]: `Invalid Date`,
        },
      });
    }
    this.setState({ isDirty: true });
  };

  handleTypeOfPaperCheck = (event) => {
    const { value } = event.target;
    if (value === "Warranty") {
      this.setState({
        warrentyExpiryDate: true,
        WarentyPaper: true,
        warranty_paper: "1",
      });
    } else {
      this.setState({
        archivePaperSet: "1",
        archivePaper: true,
      });
    }
  };

  render() {
    const { searchItems, cursor, item } = this.state;
    const handleChange = (event, newValue) => {
      this.setState({
        onBandSizeErrorText: "",
        BandSize: newValue,
        isValid: true,
        value: newValue,
      });
    };
    const labelStyle = {
      display: "inline-block",
      width: "160px",
      fontWeight: "bold",
      verticalAlign: "top",
    };
    const valueStyle = {
      display: "inline-block",
      width: "calc(100% - 168px)",
      verticalAlign: "top",
      wordBreak: "break-word",
    };
    const { minmax_pricelist } = this.state;

    const hasPurchaseRange =
      minmax_pricelist &&
      minmax_pricelist.min_inventory_cost != null &&
      minmax_pricelist.max_inventory_cost != null &&
      !(
        Number(minmax_pricelist.min_inventory_cost) === 0 &&
        Number(minmax_pricelist.max_inventory_cost) === 0
      );

    const hasSellingRange =
      minmax_pricelist &&
      minmax_pricelist.min_invoice_cost != null &&
      minmax_pricelist.max_invoice_cost != null &&
      !(
        Number(minmax_pricelist.min_invoice_cost) === 0 &&
        Number(minmax_pricelist.max_invoice_cost) === 0
      );

    const purchaseRange = hasPurchaseRange
      ? Number(minmax_pricelist.min_inventory_cost) === 0
        ? this.formatCurrency(minmax_pricelist.max_inventory_cost)
        : `${this.formatCurrency(minmax_pricelist.min_inventory_cost)} - ${this.formatCurrency(minmax_pricelist.max_inventory_cost)}`
      : "N/A";

    const sellingRange = hasSellingRange
      ? Number(minmax_pricelist.min_invoice_cost) === 0
        ? this.formatCurrency(minmax_pricelist.max_invoice_cost)
        : `${this.formatCurrency(minmax_pricelist.min_invoice_cost)} - ${this.formatCurrency(minmax_pricelist.max_invoice_cost)}`
      : "N/A";
    const TextFieldComponent = (props) => {
      return <TextField {...props} disabled={true} />;
    };

    const marks = [
      {
        value: 0,
        label: "0mm",
      },
    ];

    return (
      <React.Fragment>
        <div>
          <Header />
          <Paper className="ai-page">
            {this.state.loaded === false ? (
              <div className="d-spinner">
                <SpinnerRoundFilled
                  size={51}
                  thickness={125}
                  speed={80}
                  color="rgba(57, 107, 172, 1)"
                  className="spp"
                  enabled={this.state.loaded === false}
                />
              </div>
            ) : (
              this.state.type === null && (
                <div className="space-1">
                  {/* <div>
                    <p className="ai-topbar__title">UPDATE INVENTORY</p>
                    <p className="ai-topbar__subtitle">Edit inventory details while preserving the existing update workflow.</p>
                  </div> */}
                  <form
                    className="ai-update-form"
                    id="add_inventory_form"
                  >
                    <Container maxWidth="xl" className="ai-container">
                      <div className="space-left-50">
                        <Typography
                          variant="h6"
                          component="p"
                          className="primary-text uppercase"
                        ></Typography>
                      </div>
                      <Grid
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Grid>
                          <ArrowBackIcon
                            style={{
                              color: "action",
                              paddingRight: "15px",
                              marginTop: "5px",
                              fontSize: 40,
                              cursor: "pointer",
                            }}
                            onClick={this.backNavigation}
                          ></ArrowBackIcon>
                        </Grid>
                        <Grid>
                          <div onClick={this.handleClickBreadCrumbs}>
                            <Stack spacing={1}>
                              <Breadcrumbs
                                aria-label="breadcrumb"
                                separator={
                                  <span className="sperator">›</span>
                                }
                              >
                                <Link
                                  className="link"
                                  style={{
                                    fontSize: "14px",
                                    color: "#CEA05F",
                                    textDecoration: "underline !important",
                                    backgroundColor: "white",
                                  }}
                                  onClick={this.backNavigation}
                                >
                                  My Inventory
                                </Link>

                                <Link
                                  className="link"
                                  style={{
                                    fontSize: "14px",
                                    color: "#CEA05F",
                                    textDecoration: "underline !important",
                                    backgroundColor: "white",
                                  }}
                                  onClick={this.handleGoBack}
                                >
                                  Inventory Details
                                </Link>
                                <Link
                                  style={{
                                    fontSize: "14px",
                                    color: "#9e9e9e",
                                    backgroundColor: "white",
                                  }}
                                  aria-current="page"
                                >
                                  Edit Inventory Details
                                </Link>
                              </Breadcrumbs>
                            </Stack>
                          </div>
                        </Grid>
                      </Grid>
                      <div className="space-left-50">
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={6}>
                            <div className="ai-col">
                              {/* Standard Watch */}
                              <SectionCard icon={<InfoOutlinedIcon />} title="BASIC INFORMATION">
                                <Loader loaded={this.state.loaded}>
                                  <Card className="ai-tech-card form-width-70 margin-t-b-5 margin-p-b-20">
                                    <CardContent>
                                      <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        className="color-BCBCBC ai-tech-card__title"
                                      >
                                        Technical Details
                                      </Typography>
                                      <Typography>
                                        <b style={labelStyle}>Model Name</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails &&
                                            this.state.inventoryDetailByIdDetails
                                              .invattr
                                            ? this.state.inventoryDetailByIdDetails
                                              .invattr.model
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Brand Name</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails &&
                                            this.state.inventoryDetailByIdDetails
                                              .brandname
                                            ? this.state.inventoryDetailByIdDetails
                                              .brandname
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Model Number</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails &&
                                            this.state.inventoryDetailByIdDetails
                                              .invattr
                                            ? this.state.inventoryDetailByIdDetails
                                              .invattr.reference
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Case Material</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails &&
                                            this.state.inventoryDetailByIdDetails
                                              .invattr
                                            ? this.state.inventoryDetailByIdDetails
                                              .invattr.casematerial
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Case Size</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails &&
                                            this.state.inventoryDetailByIdDetails
                                              .invattr
                                            ? this.state.inventoryDetailByIdDetails
                                              .invattr.casesize
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Dial Color</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails
                                            .invattr &&
                                            this.state.inventoryDetailByIdDetails
                                              .invattr.dialcolor
                                            ? this.state.inventoryDetailByIdDetails
                                              .invattr.dialcolor
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Band Material</b>
                                        <span style={valueStyle}>
                                          :{" "}
                                          {this.state.inventoryDetailByIdDetails &&
                                            this.state.inventoryDetailByIdDetails
                                              .invattr
                                            ? this.state.inventoryDetailByIdDetails
                                              .invattr.bandmaterial
                                            : "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Retail Price</b>
                                        <span style={valueStyle}>
                                          : {this.state.retailAmount || "-"}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Purchase Range</b>
                                        <span style={valueStyle}>
                                          : {purchaseRange}
                                        </span>
                                        <br />

                                        <b style={labelStyle}>Selling Range</b>
                                        <span style={valueStyle}>
                                          : {sellingRange}
                                        </span>
                                        <br />

                                        <Typography
                                          className="additionalDetails"
                                          onClick={this.toggleAdditionalDetails}
                                        >
                                          Additional Details
                                          {this.state.showAdditionalDetails ? (
                                            <KeyboardArrowUpIcon
                                              style={{ fontSize: "16px" }}
                                            />
                                          ) : (
                                            <KeyboardArrowDownIcon
                                              style={{ fontSize: "16px" }}
                                            />
                                          )}
                                        </Typography>
                                        {this.state.showAdditionalDetails && (
                                          <CardContent
                                            style={{ padding: "5px 0px 8px 0px" }}
                                          >
                                            <div style={{ marginLeft: "0px" }}>
                                              <b style={labelStyle}>Index Type</b>
                                              <span style={valueStyle}>
                                                :{" "}
                                                {this.state
                                                  .inventoryDetailByIdDetails
                                                  ?.invattr?.indices || "-"}
                                              </span>
                                              <br />

                                              <b style={labelStyle}>Buckle Type</b>
                                              <span style={valueStyle}>
                                                :{" "}
                                                {this.state
                                                  .inventoryDetailByIdDetails
                                                  ?.invattr?.buckletype || "-"}
                                              </span>
                                              <b style={labelStyle}>Bezel</b>
                                              <span style={valueStyle}>
                                                :{" "}
                                                {this.state
                                                  .inventoryDetailByIdDetails
                                                  ?.invattr?.bezel || "-"}
                                              </span>
                                              <br />

                                              <b style={labelStyle}>Band Color</b>
                                              <span style={valueStyle}>
                                                :{" "}
                                                {this.state
                                                  .inventoryDetailByIdDetails
                                                  ?.invattr?.bandcolor || "-"}
                                              </span>
                                              <br />
                                            </div>
                                          </CardContent>
                                        )}
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                </Loader>

                                {/* Standard Watch INVENTORY TITLE ITEM */}
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    Inventory Title
                                  </FieldLabel>

                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    onChange={this.onchangeInventoryTitle}
                                    value={this.state.inventory_title ?? ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="Inventory Title Item"
                                  >
                                  </Input>

                                  <FormHelperText className="error-o"></FormHelperText>
                                </FormControl>

                                {/* Standard Watch SERIAL NUMBER */}
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel required>
                                    Serial Number
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="serialNumber"
                                    placeholder="Enter serial number"
                                    value={this.state.SerialNumber ? this.state.SerialNumber : ""}
                                    onChange={this.onchangeSerialNumber}
                                    disabled={this.state.isDisabled || this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onSerialNumberErrorText}
                                  </FormHelperText>
                                </FormControl>

                                {/* Standard Watch PURCHASED FROM / PURCHASE DATE */}
                                {(isActionAllowed(
                                  this.state.viewData,
                                  "purchase_from",
                                ) ||
                                  isActionAllowed(
                                    this.state.viewData,
                                    "purchase_date",
                                  )) && (
                                    <Grid container spacing={2}>
                                      {isActionAllowed(
                                        this.state.viewData,
                                        "purchase_from",
                                      ) && (
                                          <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className="ai-field">
                                              <FieldLabel>Purchased From</FieldLabel>
                                              <div className="ai-input-icon-wrap">
                                                <AntdInput
                                                  id="PurchasedFrom"
                                                  type="text"
                                                  autoComplete="off"
                                                  className="ai-antd-input"
                                                  placeholder="Search dealer or source"
                                                  ref={this.purchasedFromRef}
                                                  value={this.state.PurchasedFrom}
                                                  onChange={(e) =>
                                                    this.onchangeContactSuggestion(
                                                      e,
                                                      "PurchasedFrom",
                                                      ["supplier", "memo_supplier"],
                                                    )
                                                  }
                                                  bordered={false}
                                                  disabled={this.state.isDisabled}
                                                />
                                                <span className="ai-input-icon-wrap__icon">
                                                  {!this.state.PurchasedFrom ? (
                                                    <SearchIcon
                                                      style={{ cursor: "pointer" }}
                                                      fontSize="small"
                                                    />
                                                  ) : this.state.fieldLoader ? (
                                                    <CircularProgress
                                                      style={{ width: 18, height: 18 }}
                                                    />
                                                  ) : (
                                                    <ClearIcon
                                                      id="clearBtn"
                                                      onClick={() =>
                                                        this.clearContactSuggestion(
                                                          "PurchasedFrom",
                                                        )
                                                      }
                                                      style={{ cursor: "pointer" }}
                                                      fontSize="small"
                                                    />
                                                  )}
                                                </span>
                                              </div>
                                            </FormControl>
                                            {this.state.purchasedFromArray &&
                                              this.state.purchasedFromArray.length > 0 &&
                                              this.state.PurchasedFrom?.length > 0 ? (
                                              <div>
                                                <AntdPopover
                                                  visible={
                                                    this.state.isPopOverPurchasedFrom
                                                  }
                                                  content={
                                                    <div
                                                      style={{
                                                        height: "200px",
                                                        overflow: "auto",
                                                      }}
                                                    >
                                                      {this.state.dataset
                                                        ?.slice(0, 15)
                                                        .map((value, key) => {
                                                          return value.map((el, index) => {
                                                            if (index < 1) {
                                                              const displayName = `${el?.firstname ?? ""
                                                                } ${el?.lastname ?? ""}`;
                                                              return (
                                                                <>

                                                                  {this.state.purchasedFromArray
                                                                    ?.filter(
                                                                      (v) =>
                                                                        v.email == el.email,
                                                                    )
                                                                    .map((el, index) => {
                                                                      return (
                                                                        <AccordionDetails
                                                                          key={index}
                                                                        >
                                                                          <Typography
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                            }}
                                                                            onClick={() =>
                                                                              this.handleContactSelection(
                                                                                el,
                                                                                "PurchasedFrom",
                                                                              )
                                                                            }
                                                                          >
                                                                            {this.handleContact(
                                                                              el,
                                                                            )}
                                                                          </Typography>
                                                                        </AccordionDetails>
                                                                      );
                                                                    })}
                                                                </>
                                                              );
                                                            }
                                                          });
                                                        })}
                                                    </div>
                                                  }
                                                  trigger="click"
                                                  placement="bottomRight"
                                                  onVisibleChange={this.handleVisibleChange}
                                                >
                                                  <div
                                                    style={{
                                                      width: 0,
                                                      height: 0,
                                                      position: "absolute",
                                                    }}
                                                  />
                                                </AntdPopover>
                                              </div>
                                            ) : (
                                              this.state.PurchasedFrom.length > 2 &&
                                              !this.state.purchasedFromArray.length &&
                                              !this.state.fieldLoader &&
                                              !this.state.purchaseFromContactId && (
                                                <AntdPopover
                                                  visible
                                                  content={
                                                    <div style={{ overflow: "auto" }}>
                                                      <a
                                                        className="dataItem"
                                                        href="javascript:void(0)"
                                                        onClick={() => {
                                                          // this.setState({
                                                          //   PurchasedFrom: "",
                                                          // });
                                                          const typeData = [
                                                            {
                                                              id: "supplier",
                                                              value: "Supplier",
                                                            },
                                                            {
                                                              id: "memo_supplier",
                                                              value: "Memo Supplier",
                                                            },
                                                          ];
                                                          const encodedTypeData = btoa(
                                                            JSON.stringify(typeData),
                                                          );
                                                          window.open(
                                                            `/contactmanagement/add?type=${encodedTypeData}`,
                                                            "_blank",
                                                          );
                                                          // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                        }}
                                                        style={{
                                                          cursor: "pointer",
                                                          textDecoration: "underline",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        Click here to Create New Contact
                                                      </a>
                                                    </div>
                                                  }
                                                  trigger="click"
                                                  placement="bottom"
                                                // overlayStyle={{ marginTop: "5px" }}
                                                >
                                                </AntdPopover>
                                              )
                                            )}
                                          </Grid>
                                        )}

                                      {isActionAllowed(
                                        this.state.viewData,
                                        "purchase_date",
                                      ) && (
                                          <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className="ai-field ai-datepicker">
                                              <FieldLabel>Purchased Date</FieldLabel>
                                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                  className="color-BCBCBC"
                                                  margin="normal"
                                                  id="date-picker-dialog"
                                                  format="MM/dd/yyyy"
                                                  value={this.state.purchaseDate || null}
                                                  onChange={(date, e) => {
                                                    this.handlePurchaseDate(
                                                      date,
                                                      e,
                                                      "Purchased Date",
                                                    );
                                                  }}
                                                  KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                  }}
                                                  style={{
                                                    marginBottom: "0px",
                                                    marginTop: "0px",
                                                  }}
                                                  helperText={
                                                    this.state.error["PD"]
                                                      ? "Invalid date"
                                                      : ""
                                                  }
                                                  error={this.state.error["PD"]}
                                                  placeholder="Purchased Date - MM/DD/YYYY"
                                                  onPaste={(event) =>
                                                    event.preventDefault()
                                                  }
                                                />
                                              </MuiPickersUtilsProvider>
                                              <FormHelperText className="error-o">
                                                {this.state.onpurchaseDateErrorText}
                                              </FormHelperText>
                                            </FormControl>
                                          </Grid>
                                        )}
                                    </Grid>
                                  )}

                                {/* Standard Watch PURCHASE PAYMENT STATUS / DATE */}
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Purchase Payment Status</FieldLabel>
                                      <Select
                                        disableUnderline
                                        className="ai-select"
                                        value={this.state.paidStatus ? "paid" : "unpaid"}
                                        onChange={(e) =>
                                          this.handlePaidStatusCheck({
                                            target: { checked: e.target.value === "paid" },
                                          })
                                        }
                                        disabled={this.state.userData?.roleId === 10}
                                        renderValue={(val) => (
                                          <span className="ai-status-pill">
                                            <span className="ai-status-pill__dot" />
                                            {val === "paid" ? "Paid" : "Unpaid"}
                                          </span>
                                        )}
                                      >
                                        <MenuItem value="paid">Paid</MenuItem>
                                        <MenuItem value="unpaid">Unpaid</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Standard Watch PURCHASE PAYMENT DATE */}
                                  <Grid item xs={12} sm={6}>
                                    {this.state.paidStatus ? (
                                      <FormControl fullWidth className="ai-field ai-datepicker">
                                        <FieldLabel>Purchase Payment Date</FieldLabel>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                          <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-purchase"
                                            format="MM/dd/yyyy"
                                            disableFuture
                                            value={this.state.paymentDate || null}
                                            onChange={this.handleDateChange}
                                            KeyboardButtonProps={{
                                              "aria-label": "change purchase payment date",
                                            }}
                                            placeholder="Purchase Payment Date - MM/DD/YYYY"
                                            onPaste={(event) => event.preventDefault()}
                                            helperText={this.state.error["PPD"] ? "Invalid date" : ""}
                                            error={Boolean(this.state.error["PPD"])}
                                            disabled={
                                              this.state.userData &&
                                              this.state.userData.roleId === 10
                                            }
                                          />
                                        </MuiPickersUtilsProvider>

                                        <FormHelperText className="error-o">
                                          {this.state.onpurchaseDateErrorText}
                                        </FormHelperText>
                                      </FormControl>
                                    ) : (
                                      <FormControl fullWidth className="ai-field ai-datepicker">
                                        <FieldLabel>Purchase Payment Due Date</FieldLabel>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                          <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-purchase-due"
                                            format="MM/dd/yyyy"
                                            value={this.state.purchaseDueDate || null}
                                            onChange={this.handleDueDateChange}
                                            KeyboardButtonProps={{
                                              "aria-label": "change purchase payment due date",
                                            }}
                                            placeholder="Purchase Payment Due Date - MM/DD/YYYY"
                                            onPaste={(event) => event.preventDefault()}
                                            helperText={this.state.error["PPDD"] ? "Invalid date" : ""}
                                            error={Boolean(this.state.error["PPDD"])}
                                            disabled={
                                              this.state.userData &&
                                              this.state.userData.roleId === 10
                                            }
                                          />
                                        </MuiPickersUtilsProvider>

                                        <FormHelperText className="error-o">
                                          {this.state.onpurchaseDueDateErrorText}
                                        </FormHelperText>
                                      </FormControl>
                                    )}
                                  </Grid>
                                </Grid>

                                {/* Standard Watch PURCHASE PAYMENT DETAILS */}
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    Purchase Payment Details
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple" multiline
                                    onChange={this.onchangePaymentDetails}
                                    value={this.state.paymentDetailsText ? this.state.paymentDetailsText : ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="Enter payment details"
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onPaymentDetailsErrorText}
                                  </FormHelperText>
                                </FormControl>

                                {/* Standard Watch PURCHASED PRICE / PURCHASE EXPENSE */}
                                {(isActionAllowed(
                                  this.state.viewData,
                                  "purchase_price",
                                ) ||
                                  isActionAllowed(
                                    this.state.viewData,
                                    "purchase_expense",
                                  )) && (
                                    <Grid container spacing={2}>
                                      {isActionAllowed(
                                        this.state.viewData,
                                        "purchase_price",
                                      ) && (
                                          <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className="ai-field">
                                              <FieldLabel>
                                                Purchased Price ($)
                                              </FieldLabel>
                                              <Input
                                                disableUnderline
                                                className="ai-input"
                                                id="component-simple"
                                                onChange={this.onchangePurchasedPrice}
                                                value={this.state.PurchasedPrice ? this.state.PurchasedPrice : ""}
                                                style={{
                                                  marginBottom: "10px"
                                                }}
                                                disabled={this.state.isDisabled}
                                                placeholder="0.00"
                                              />
                                              <FormHelperText className="error-o">
                                                {this.state.onPurchasedPriceErrorText}
                                              </FormHelperText>
                                            </FormControl>
                                          </Grid>
                                        )}

                                      {isActionAllowed(
                                        this.state.viewData,
                                        "purchase_expense",
                                      ) && (
                                          <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth className="ai-field">
                                              <FieldLabel>
                                                Purchase Expense ($)
                                              </FieldLabel>
                                              <Input
                                                disableUnderline
                                                className="ai-input"
                                                id="component-simple"
                                                onChange={this.onchangePurchaseExpense}
                                                value={this.state.purchase_expense}
                                                placeholder="0.00"
                                              />
                                              <FormHelperText className="error-o"></FormHelperText>
                                            </FormControl>
                                          </Grid>
                                        )}
                                    </Grid>
                                  )}

                                {/* Standard Watch PURCHASE EXPENSE NOTE */}
                                {isActionAllowed(
                                  this.state.viewData,
                                  "purchase_expense",
                                ) && (
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>
                                        {" "}
                                        Purchase Expense Note
                                      </FieldLabel>
                                      <Input
                                        disableUnderline
                                        className="ai-input"
                                        id="component-simple"
                                        onChange={this.onchangePurchaseExpenseNote}
                                        value={this.state.purchase_expense_note ? this.state.purchase_expense_note : ""}
                                        placeholder="Enter expense note"
                                      />
                                      <FormHelperText className="error-o"></FormHelperText>
                                    </FormControl>
                                  )}

                                {/* Standard Watch TOTAL COST */}
                                {isActionAllowed(
                                  this.state.viewData,
                                  "total_cost",
                                ) && (
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>
                                        {" "}
                                        Total Cost ($)
                                      </FieldLabel>
                                      <Input
                                        disableUnderline
                                        className="ai-input"
                                        id="component-simple"
                                        disabled value={this.state.total_cost}
                                        placeholder="0.00"
                                      ></Input>
                                      <FormHelperText className="error-o"></FormHelperText>
                                    </FormControl>
                                  )}
                              </SectionCard>

                              {/* Standard Watch INVENTORY TYPE */}
                              <SectionCard icon={<TuneOutlinedIcon />} title="INVENTORY DETAILS" style={{ marginTop: "10px" }}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Inventory Type</FieldLabel>

                                      <Select
                                        className="ai-select"
                                        id="inventory-type"
                                        value={this.state.InventoryType === "null" ? "" : this.state.InventoryType}
                                        onChange={(e) =>
                                          this.setState({
                                            InventoryType: e.target.value,
                                            MemoDetails: "",
                                            PartnershipDetails: "",
                                            memoContactId: null,
                                            partnerContactId: null,
                                            isDirty: true,
                                          })
                                        }
                                        disabled={this.state.userData?.roleId === 10}
                                        displayEmpty
                                        renderValue={(selected) => {
                                          if (!selected) {
                                            return <span style={{ color: "#999" }}>Select Type</span>;
                                          }
                                          const typeMap = {
                                            "1": "Regular Inventory",
                                            "2": "Memo Inventory",
                                            "3": "Partnership Inventory",
                                            "5": "Consignment Inventory",
                                            "4": "Trade Inventory",
                                          };
                                          return typeMap[selected] || selected;
                                        }}
                                      >
                                        <MenuItem value="">
                                          <em>Select Type</em>
                                        </MenuItem>
                                        <MenuItem value="1">Regular Inventory</MenuItem>
                                        <MenuItem value="2">Memo Inventory</MenuItem>
                                        <MenuItem value="3">Partnership Inventory</MenuItem>
                                        <MenuItem value="5">Consignment Inventory</MenuItem>
                                        <MenuItem value="4" style={{ display: "none" }}>
                                          Trade Inventory
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Standard Watch Memo Contact, Partnership Contact */}
                                  {this.state.InventoryType === "2" && (
                                    <Grid item xs={12} sm={6}>
                                      <FormControl
                                        className="form-width-70 "
                                        style={{ marginTop: "8px" }}
                                      >
                                        <InputLabel
                                          htmlFor="component-simple"
                                          shrink={true}
                                          style={{ color: "#424242" }}
                                        >
                                          Memo Contact
                                        </InputLabel>
                                        <AntdInput
                                          id="MemoDetails"
                                          type="text"
                                          ref={this.memoDetailsRef}
                                          autoComplete="off"
                                          value={this.state.MemoDetails}
                                          style={{
                                            marginBottom: "0px",
                                            marginTop: "10px",
                                            fontSize: "16px",
                                            paddingLeft: 0,
                                          }}
                                          onChange={(e) =>
                                            this.onchangeContactSuggestion(
                                              e,
                                              "MemoDetails",
                                              ["memo_supplier"],
                                            )
                                          }
                                          bordered={false}
                                          placeholder="Search Memo Contact Name / Business Name"
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                        <Divider
                                          style={{
                                            background: "#ada8a8",
                                            marginTop: "5px",
                                          }}
                                        />
                                        <div className="contactSearchIcon">
                                          <Grid container>
                                            <Grid item xs={6} sm={6} md={6}>
                                              {this.state.userData?.roleId !== 10 && (
                                                <>
                                                  {!this.state.MemoDetails ? (
                                                    <SearchIcon
                                                      style={{ cursor: "pointer" }}
                                                    />
                                                  ) : (
                                                    <>
                                                      {this.state.fieldLoader ? (
                                                        <CircularProgress
                                                          style={{
                                                            width: "25px",
                                                            height: "25px",
                                                          }}
                                                        />
                                                      ) : (
                                                        <ClearIcon
                                                          id="clearBtn"
                                                          onClick={() =>
                                                            this.clearContactSuggestion(
                                                              "MemoDetails",
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </Grid>
                                          </Grid>
                                        </div>
                                      </FormControl>
                                      {this.state.memoDetailsArray &&
                                        this.state.memoDetailsArray.length > 0 &&
                                        this.state.MemoDetails?.length > 0 ? (
                                        <div>
                                          <AntdPopover
                                            visible={this.state.isPopOverMemoDetails}
                                            content={
                                              <div
                                                style={{
                                                  height: "200px",
                                                  overflow: "auto",
                                                }}
                                              >
                                                {this.state.dataset
                                                  ?.slice(0, 15)
                                                  .map((value, key) => {
                                                    return value.map((el, index) => {
                                                      if (index < 1) {
                                                        const displayName = `${el?.firstname ?? ""
                                                          } ${el?.lastname ?? ""}`;
                                                        return (
                                                          <>

                                                            {this.state.memoDetailsArray
                                                              ?.filter(
                                                                (v) =>
                                                                  v.email == el.email,
                                                              )
                                                              .map((el, index) => {
                                                                return (
                                                                  <AccordionDetails
                                                                    key={index}
                                                                  >
                                                                    <Typography
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.handleContactSelection(
                                                                          el,
                                                                          "MemoDetails",
                                                                        )
                                                                      }
                                                                    >
                                                                      {this.handleContact(
                                                                        el,
                                                                      )}
                                                                    </Typography>
                                                                  </AccordionDetails>
                                                                );
                                                              })}
                                                            {/* </Accordion> */}
                                                          </>
                                                        );
                                                      }
                                                    });
                                                  })}
                                              </div>
                                            }
                                            trigger="click"
                                            placement="bottomRight"
                                            // placement="bottomLeft"
                                            onVisibleChange={this.handleVisibleChange}
                                          >
                                            <div
                                              style={{
                                                width: 0,
                                                height: 0,
                                                position: "absolute",
                                              }}
                                            />
                                          </AntdPopover>
                                        </div>
                                      ) : (
                                        this.state.MemoDetails?.length > 2 &&
                                        !this.state.memoDetailsArray.length &&
                                        !this.state.fieldLoader &&
                                        !this.state.memoContactId && (
                                          <AntdPopover
                                            // id={column.id}
                                            visible={
                                              this.state.MemoDetails?.length > 2 &&
                                              !this.state.memoDetailsArray.length &&
                                              !this.state.fieldLoader &&
                                              !this.state.memoContactId
                                            }
                                            content={
                                              <div style={{ overflow: "auto" }}>
                                                <a
                                                  className="dataItem"
                                                  onClick={() => {
                                                    // this.setState({
                                                    //   MemoDetails: "",
                                                    // });
                                                    const typeData = [
                                                      {
                                                        id: "memo_supplier",
                                                        value: "Memo Supplier",
                                                      },
                                                    ];
                                                    const encodedTypeData = btoa(
                                                      JSON.stringify(typeData),
                                                    );
                                                    window.open(
                                                      `/contactmanagement/add?type=${encodedTypeData}`,
                                                      "_blank",
                                                    );
                                                    // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                  }}
                                                  style={{
                                                    cursor: "pointer",
                                                    textDecoration: "underline",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Click here to Create New Contact
                                                </a>
                                              </div>
                                            }
                                            trigger="click"
                                            placement="bottom"
                                          // overlayStyle={{ marginTop: "5px" }}
                                          >
                                            {/* <div
                                      style={{
                                        width: 0,
                                        height: 0,
                                        position: "absolute",
                                      }}
                                    /> */}
                                          </AntdPopover>
                                        )
                                      )}
                                    </Grid>
                                  )}
                                  {this.state.InventoryType === "3" && (
                                    <Grid item xs={12} sm={6}>
                                      <FormControl
                                        className="form-width-70 "
                                        style={{ marginTop: "8px" }}
                                      >
                                        <InputLabel
                                          htmlFor="component-simple"
                                          shrink={true}
                                          style={{ color: "#424242" }}
                                        >
                                          Partnership Contact
                                        </InputLabel>
                                        <AntdInput
                                          id="PartnershipDetails"
                                          type="text"
                                          ref={this.partnershipDetailsRef}
                                          autoComplete="off"
                                          value={this.state.PartnershipDetails}
                                          style={{
                                            marginBottom: "0px",
                                            marginTop: "10px",
                                            fontSize: "16px",
                                            paddingLeft: 0,
                                          }}
                                          onChange={(e) =>
                                            this.onchangeContactSuggestion(
                                              e,
                                              "PartnershipDetails",
                                              ["partner"],
                                            )
                                          }
                                          bordered={false}
                                          placeholder="Search Partnership Contact Name / Business Name"
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                        <Divider
                                          style={{
                                            background: "#ada8a8",
                                            marginTop: "5px",
                                          }}
                                        />
                                        <div className="contactSearchIcon">
                                          <Grid container>
                                            <Grid item xs={6} sm={6} md={6}>
                                              {this.state.userData?.roleId !== 10 && (
                                                <>
                                                  {!this.state.PartnershipDetails ? (
                                                    <SearchIcon
                                                      style={{ cursor: "pointer" }}
                                                    />
                                                  ) : (
                                                    <>
                                                      {this.state.fieldLoader ? (
                                                        <CircularProgress
                                                          style={{
                                                            width: "25px",
                                                            height: "25px",
                                                          }}
                                                        />
                                                      ) : (
                                                        <ClearIcon
                                                          id="clearBtn"
                                                          onClick={() =>
                                                            this.clearContactSuggestion(
                                                              "PartnershipDetails",
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </Grid>
                                          </Grid>
                                        </div>
                                      </FormControl>
                                      {this.state.partnershipDetailsArray &&
                                        this.state.partnershipDetailsArray.length > 0 &&
                                        this.state.PartnershipDetails?.length > 0 ? (
                                        <div>
                                          <AntdPopover
                                            visible={
                                              this.state.isPopOverPartnershipDetails
                                            }
                                            content={
                                              <div
                                                style={{
                                                  height: "200px",
                                                  overflow: "auto",
                                                }}
                                              >
                                                {this.state.dataset
                                                  ?.slice(0, 15)
                                                  .map((value, key) => {
                                                    return value.map((el, index) => {
                                                      if (index < 1) {
                                                        const displayName = `${el?.firstname ?? ""
                                                          } ${el?.lastname ?? ""}`;
                                                        return (
                                                          <>

                                                            {this.state.partnershipDetailsArray
                                                              ?.filter(
                                                                (v) =>
                                                                  v.email == el.email,
                                                              )
                                                              .map((el, index) => {
                                                                return (
                                                                  <AccordionDetails
                                                                    key={index}
                                                                  >
                                                                    <Typography
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.handleContactSelection(
                                                                          el,
                                                                          "PartnershipDetails",
                                                                        )
                                                                      }
                                                                    >
                                                                      {this.handleContact(
                                                                        el,
                                                                      )}
                                                                    </Typography>
                                                                  </AccordionDetails>
                                                                );
                                                              })}
                                                            {/* </Accordion> */}
                                                          </>
                                                        );
                                                      }
                                                    });
                                                  })}
                                              </div>
                                            }
                                            trigger="click"
                                            placement="bottomRight"
                                            // placement="bottomLeft"
                                            onVisibleChange={this.handleVisibleChange}
                                          >
                                            <div
                                              style={{
                                                width: 0,
                                                height: 0,
                                                position: "absolute",
                                              }}
                                            />
                                          </AntdPopover>
                                        </div>
                                      ) : (
                                        this.state.PartnershipDetails.length > 2 &&
                                        !this.state.partnershipDetailsArray.length &&
                                        !this.state.fieldLoader &&
                                        !this.state.partnerContactId && (
                                          <AntdPopover
                                            // id={column.id}
                                            visible={
                                              this.state.PartnershipDetails?.length >
                                              2 &&
                                              !this.state.partnershipDetailsArray
                                                .length &&
                                              !this.state.fieldLoader &&
                                              !this.state.partnerContactId
                                            }
                                            content={
                                              <div style={{ overflow: "auto" }}>
                                                <a
                                                  className="dataItem"
                                                  href="javascript:void(0)"
                                                  onClick={() => {
                                                    // this.setState({
                                                    //   PartnershipDetails: "",
                                                    // });
                                                    const typeData = [
                                                      {
                                                        id: "partner",
                                                        value: "Partner",
                                                      },
                                                    ];
                                                    const encodedTypeData = btoa(
                                                      JSON.stringify(typeData),
                                                    );
                                                    window.open(
                                                      `/contactmanagement/add?type=${encodedTypeData}`,
                                                      "_blank",
                                                    );
                                                    // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                  }}
                                                  style={{
                                                    cursor: "pointer",
                                                    textDecoration: "underline",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Click here to Create New Contact
                                                </a>
                                              </div>
                                            }
                                            trigger="click"
                                            placement="bottom"
                                          // overlayStyle={{ marginTop: "5px" }}
                                          >
                                            {/* <div
                                      style={{
                                        width: 0,
                                        height: 0,
                                        position: "absolute",
                                      }}
                                    /> */}
                                          </AntdPopover>
                                        )
                                      )}
                                    </Grid>
                                  )}
                                  {(this.state.InventoryType === "2" ||
                                    this.state.InventoryType === "3") && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth className="ai-field">
                                          <FieldLabel>
                                            {this.state.InventoryType === "2" ? "MEMO NUMBER" : "PARTNERSHIP NUMBER"}
                                          </FieldLabel>
                                          <Input
                                            disableUnderline
                                            className="ai-input"
                                            id="component-simple"
                                            placeholder={
                                              this.state.inventory_type === "2"
                                                ? "Enter Memo Number"
                                                : "Enter Partnership Number"
                                            }
                                            value={this.state.InventoryType === "2" ? this.state.updatememo : this.state.updatepartnershipnumber}
                                            onChange={e => {
                                              this.setState({
                                                updatememo: this.state.InventoryType === "2" ? e.target.value : "",
                                                updatepartnershipnumber: this.state.InventoryType === "3" ? e.target.value : ""
                                              });
                                            }} disabled={this.state.userData && this.state.userData.roleId === 10} />
                                        </FormControl>
                                      </Grid>
                                    )}

                                  {/* Standard Watch Inventory Status */}
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Inventory Status</FieldLabel>
                                      <Select
                                        className="ai-select"
                                        id="component-simple"
                                        value={this.state.InventoryStatus || ""}
                                        onChange={(e) =>
                                          this.setState({
                                            InventoryStatus: e.target.value,
                                            isDirty: true,
                                          })
                                        }
                                        disabled={
                                          this.state.memoId &&
                                          this.state.InventoryStatus == 3 &&
                                          this.state.sold !== 1
                                        }
                                        displayEmpty
                                        renderValue={(selected) => {
                                          if (!selected) {
                                            return <span style={{ color: "#999" }}>Select Status</span>;
                                          }
                                          const statusMap = {
                                            "2": "Incoming",
                                            "6": "Needs Service / Polish",
                                            "7": "At Service",
                                            "11": "Intake Complete",
                                            "13": "Need to Post",
                                            "12": "Invoiced",
                                            "1": "Inhand",
                                            "3": "Out on Memo",
                                            "4": "On Hold / Reserved",
                                            "8": "Need to Ship",
                                            "9": "Shipped waiting on payment",
                                            "10": "Sold & Cashed Out",
                                            "5": "Available to Order",
                                          };
                                          return statusMap[selected] || selected;
                                        }}
                                      >
                                        <MenuItem value="">
                                          <em>Select Status</em>
                                        </MenuItem>
                                        <MenuItem value="2">Incoming</MenuItem>
                                        <MenuItem value="6">Needs Service / Polish</MenuItem>
                                        <MenuItem value="7">At Service</MenuItem>
                                        <MenuItem value="11">Intake Complete</MenuItem>
                                        <MenuItem value="13">Need to Post</MenuItem>
                                        <MenuItem value="12">Invoiced</MenuItem>
                                        <MenuItem value="1">Inhand</MenuItem>
                                        <MenuItem value="3">Out on Memo</MenuItem>
                                        <MenuItem value="4">On Hold / Reserved</MenuItem>
                                        <MenuItem value="8">Need to Ship</MenuItem>
                                        <MenuItem value="9">Shipped waiting on payment</MenuItem>
                                        <MenuItem value="10">Sold & Cashed Out</MenuItem>
                                        <MenuItem value="5">Available to Order</MenuItem>
                                      </Select>
                                    </FormControl>

                                  </Grid>

                                  {/* Standard Watch Inventory Location */}
                                  <Grid item xs={12} sm={6}>
                                    {/* <div> */}
                                    <FormControl fullWidth className="ai-field ai-field--dropdown">
                                      <FieldLabel>Inventory Location</FieldLabel>
                                      <Input
                                        className="ai-input"
                                        placeholder="Enter Inventory Location"
                                        id="autocomplete1"
                                        onChange={this.locationAutoComplete}
                                        onFocus={this.handleLocationFocus}
                                        onBlur={this.handleLocationBlur}
                                        value={this.state.locationSearch}
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                        endAdornment={
                                          this.state.locationloading ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={16} />
                                            </InputAdornment>
                                          ) : null
                                        }
                                      />
                                      {!this.state.locationloading && this.state.locationAutoCompleteData?.data?.length > 0 ? (
                                        <List
                                          className="searchlist MuiPaper-elevation1 inventrysearch ai-location-results"
                                          style={{ listStyle: "none" }}
                                        >
                                          {this.state.locationAutoCompleteData.data.map(
                                            (item, idx) => (
                                              <div key={idx}>
                                                <ListItem
                                                  className={
                                                    this.state.cursor === idx ? "active" : ""
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                  onMouseDown={() =>
                                                    this.onchangeLocation(item)
                                                  }
                                                >
                                                  <ListItemText
                                                    primary={item.locations}
                                                    style={{
                                                      marginTop: "10px",
                                                      marginLeft: "50px",
                                                    }}
                                                  />
                                                </ListItem>

                                                <Divider
                                                  variant="inset"
                                                  component="li"
                                                  style={{ margin: "5px" }}
                                                />
                                              </div>
                                            )
                                          )}
                                        </List>
                                      ) : null}
                                    </FormControl>
                                    {/* </div> */}
                                  </Grid>

                                  {/* Standard Watch Band Size */}
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Band Size</FieldLabel>
                                      <Input
                                        disableUnderline
                                        className="ai-input"
                                        id="component-simple"
                                        placeholder="Enter band size"
                                        value={
                                          this.state.BandSize ? this.state.BandSize : ""
                                        }
                                        onChange={this.onchangeBandSize}
                                        disabled={
                                          this.state.isDisabled ||
                                          (this.state.userData &&
                                            this.state.userData.roleId === 10)
                                        }
                                      />
                                      <FormHelperText className="error-o">
                                        {this.state.onBandSizeErrorText}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                </Grid>

                                {/* Standard Watch Condition */}
                                <div className="ai-condition" id="conditionField">
                                  <FieldLabel>Condition</FieldLabel>

                                  <ConditionSelector
                                    marks={followersMarks1()}
                                    value={this.state.Condition}
                                    onChange={this.onchangeCondition}
                                  />

                                  <div className="ai-condition-hint">
                                    <InfoOutlinedIcon style={{ fontSize: 14 }} />
                                    Select the condition that best describes your inventory.
                                  </div>

                                  <FormHelperText className="error-o">
                                    {this.state.onConditionErrorText}
                                  </FormHelperText>
                                </div>
                                {/* Standard Watch NUMBER OF LINKS / SCREWS */}
                                {this.state.viewData &&
                                  this.state.viewData.length === 0 && (
                                    <>
                                      <FormControl fullWidth className="ai-field">
                                        <FieldLabel>
                                          Number Of Links / Screws
                                        </FieldLabel>
                                        <Input
                                          disableUnderline
                                          className="ai-input"
                                          id="component-simple"
                                          value={this.state.NumberOfLinks ? this.state.NumberOfLinks : ""}
                                          onChange={this.onchangeNumberOfLinks}
                                          placeholder="Enter number"
                                          style={{
                                            marginBottom: "10px"
                                          }}
                                          disabled={this.state.isDisabled || this.state.userData && this.state.userData.roleId === 10}
                                        />
                                        <FormHelperText className="error-o">
                                          {this.state.onNumberOfLinksErrorText}
                                        </FormHelperText>
                                      </FormControl>

                                      {/* Standard Watch INTERNAL DEALER NOTE */}
                                      <FormControl fullWidth className="ai-field">
                                        <FieldLabel>
                                          Internal Dealer Note
                                        </FieldLabel>
                                        <Input disableUnderline
                                          className="ai-input ai-input--textarea ai-input--textarea-lg"
                                          id="component-simple"
                                          placeholder="Enter internal dealer note"
                                          multiline
                                          onChange={this.onchangeDealerNotes}
                                          value={this.state.DealerNotes ? this.state.DealerNotes : ""}
                                        />
                                        <FormHelperText className="error-o">
                                          {this.state.onDealerNotesErrorText}
                                        </FormHelperText>
                                      </FormControl>
                                    </>
                                  )}
                              </SectionCard>
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <div className="ai-col">
                              <SectionCard icon={<DescriptionOutlinedIcon />} title="SPECIFICATIONS & PRICING">
                                {this.state.viewData &&
                                  this.state.viewData.length !== 0 && (
                                    <>
                                      <FormControl fullWidth className="ai-field">
                                        <FieldLabel>
                                          Number Of Links / Screws
                                        </FieldLabel>
                                        <Input
                                          disableUnderline
                                          className="ai-input"
                                          id="component-simple"
                                          value={this.state.NumberOfLinks ? this.state.NumberOfLinks : ""}
                                          onChange={this.onchangeNumberOfLinks}
                                          placeholder="Enter number"
                                          style={{
                                            marginBottom: "10px"
                                          }}
                                          disabled={this.state.isDisabled || this.state.userData && this.state.userData.roleId === 10}
                                        />
                                        <FormHelperText className="error-o">
                                          {this.state.onNumberOfLinksErrorText}
                                        </FormHelperText>
                                      </FormControl>

                                      <FormControl fullWidth className="ai-field">
                                        <FieldLabel>
                                          Internal Dealer Note
                                        </FieldLabel>
                                        <Input
                                          disableUnderline
                                          multiline
                                          className="ai-input ai-input--textarea ai-input--textarea-lg"
                                          id="component-simple"
                                          onChange={this.onchangeDealerNotes}
                                          placeholder="Enter internal dealer note"
                                          value={this.state.DealerNotes ? this.state.DealerNotes : ""}
                                        />
                                        <FormHelperText className="error-o">
                                          {this.state.onDealerNotesErrorText}
                                        </FormHelperText>
                                      </FormControl>
                                    </>
                                  )}
                                <div>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Public Dealer Notes
                                    </FieldLabel>
                                    <Input
                                      disableUnderline
                                      multiline
                                      className="ai-input ai-input--textarea ai-input--textarea-lg"
                                      id="component-simple"
                                      onChange={this.onchangePublicDealerNote}
                                      value={this.state.public_dealer_note ? this.state.public_dealer_note : ""}
                                      disabled={this.state.userData && this.state.userData.roleId === 10}
                                      placeholder="Enter public dealer notes"
                                    />
                                    <FormHelperText className="error-o"></FormHelperText>
                                  </FormControl>
                                </div>
                              </SectionCard>
                              <SectionCard icon={<PaidOutlinedIcon />} title="TARGET PRICING DETAILS" style={{ marginTop: "10px" }}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    {getCustomLabel("custom_wholesale_price", "TARGET WHOLESALE PRICE")} ($)
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    style={{
                                      marginBottom: "10px"
                                    }}
                                    onChange={this.onchangeWholeSalePrice}
                                    value={this.state.WholeSalePrice ? this.state.WholeSalePrice : ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="0.00"
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onWholeSalePriceErrorText}
                                  </FormHelperText>
                                </FormControl>

                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    {getCustomLabel("custom_end_customer_price", "TARGET END CUSTOMER PRICE")} ($)
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    style={{
                                      marginBottom: "10px"
                                    }}
                                    onChange={this.onchangeRetailPrice}
                                    value={this.state.RetailPrice ? this.state.RetailPrice : ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="0.00"
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onRetailPriceErrorText}
                                  </FormHelperText>
                                </FormControl>

                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    {getCustomLabel("custom_end_customer_wire_price", "TARGET END CUSTOMER WIRE PRICE")} ($)
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    style={{
                                      marginBottom: "10px"
                                    }}
                                    onChange={this.onchangeRetailWirePrice}
                                    value={this.state.RetailWirePrice ? this.state.RetailWirePrice : ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="0.00"
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onRetailWirePriceErrorText}
                                  </FormHelperText>
                                </FormControl>

                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    {" "}
                                    {getCustomLabel("custom_tag_price", "TAG PRICE")} ($)
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    type="text"
                                    onChange={this.onchangeTagPrice}
                                    value={this.state.tag_price || ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="0.00"
                                  />
                                  <FormHelperText className="error-o"></FormHelperText>
                                </FormControl>
                              </SectionCard>
                              <Grid
                                item
                                md={6.1}
                                xl={6.1}
                                lg={6.1}
                                sm={12}
                                xs={12}
                              >
                                <SectionCard icon={<InsertDriveFileOutlinedIcon />} title="INVOICE FILE" style={{ marginTop: "10px" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                    <Typography className="ai-uploads__col-title">Invoice Images or File</Typography>
                                    <Tooltip title="Please attach images separately as high resolution JPG/PNG/JPEG/GIF/PDF/DOC/DOCX">
                                      <span>
                                        <HelpIcon fontSize="small" style={{ color: "#CEA05F" }} />
                                      </span>
                                    </Tooltip>
                                  </div>
                                  <div className="ai-invoice-upload">
                                    <FileUploadGroup
                                      imageDetails={this.state.fileArray}
                                      page={"Edit"}
                                      onFilesChange={this.handleSelectedFiles}
                                      deleteExistingData={this.deleteExistingInvoiceFile}
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                  </div>
                                </SectionCard>
                              </Grid>
                              <SectionCard icon={<WarningAmberOutlinedIcon />} title="ADDITIONAL OPTIONS" style={{ marginTop: "10px" }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      onClick={this.handleCheck1}
                                      className="ai-checkbox"
                                      checked={this.state.box == true}
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                  }
                                  label="I have a box"
                                />

                                <div className="ai-subgroup">
                                  <p className="ai-subgroup__title">Type of Paper</p>
                                  <div className="ai-checkbox-inline">
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          value="Warranty"
                                          className="ai-checkbox"
                                          checked={
                                            this.state.warranty_paper == "1"
                                          }
                                          onChange={this.handleTypeOfWarranty}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      }
                                      label="Warranty"
                                    />
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          className="ai-checkbox"
                                          value="Archive"
                                          checked={this.state.archive == "1"}
                                          onChange={this.handleTypeOfArchive}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      }
                                      label="Archive"
                                    />
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          className="ai-checkbox"
                                          value="isService"
                                          checked={this.state.isService}
                                          onChange={this.handleTypeOfService}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      }
                                      label="Service Card/Paper"
                                    />
                                    {/* </FormControl> */}
                                  </div>
                                  {this.state.warranty_paper && (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <FieldLabel>Warranty Expiry Date</FieldLabel>
                                      <KeyboardDatePicker
                                        className="ai-datepicker ai-datepicker-paper"
                                        margin="normal"
                                        id="date-picker-dialog"
                                        format="MM/dd/yyyy"
                                        value={this.state.purchaseDate1 || null}
                                        onChange={(date, e) => {
                                          this.handleDateChange1(date, e, "Warranty");
                                        }}
                                        KeyboardButtonProps={{
                                          "aria-label": "change date",
                                        }}
                                        helperText={
                                          this.state.error["Warranty"] ? "Invalid date" : ""
                                        }
                                        error={this.state.error["Warranty"]}
                                        placeholder="Warranty - MM/DD/YYYY"
                                        onPaste={(event) => event.preventDefault()}
                                        disabled={this.state.userData?.roleId === 10}
                                      />
                                    </MuiPickersUtilsProvider>
                                  )}
                                  {this.state.archive && (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <FieldLabel>Archive Date</FieldLabel>
                                      <KeyboardDatePicker
                                        className="ai-datepicker ai-datepicker-paper"
                                        margin="normal"
                                        id="date-picker-dialog"
                                        format="MM/dd/yyyy"
                                        value={this.state.archiveDate || null}
                                        onChange={(date, e) => {
                                          this.handleDateChange1(date, e, "Archive");
                                        }}
                                        KeyboardButtonProps={{
                                          "aria-label": "change date",
                                        }}
                                        style={{
                                          marginBottom: "20px",
                                          marginTop: "8px",
                                        }}
                                        helperText={
                                          this.state.error["Archive"]
                                            ? "Invalid date"
                                            : ""
                                        }
                                        error={this.state.error["Archive"]}
                                        placeholder="Archive - MM/DD/YYYY"
                                        onPaste={(event) => event.preventDefault()}
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                    </MuiPickersUtilsProvider>
                                  )}
                                  {this.state.isService && (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <FieldLabel>Service Card / Paper Date</FieldLabel>
                                      <KeyboardDatePicker
                                        className="ai-datepicker ai-datepicker-paper"
                                        margin="normal"
                                        id="date-picker-dialog"
                                        format="MM/dd/yyyy"
                                        value={this.state.serviceDate || null}
                                        onChange={(date, e) => {
                                          this.handleDateChange1(date, e, "Service");
                                        }}
                                        KeyboardButtonProps={{
                                          "aria-label": "change date",
                                        }}
                                        style={{
                                          marginBottom: "20px",
                                          marginTop: "0px",
                                        }}
                                        helperText={
                                          this.state.error["Service"]
                                            ? "Invalid date"
                                            : ""
                                        }
                                        error={this.state.error["Service"]}
                                        placeholder="Service Card / Paper - MM/DD/YYYY"
                                        onPaste={(event) => event.preventDefault()}
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                    </MuiPickersUtilsProvider>
                                  )}
                                </div>
                                <div className="ai-subgroup">
                                  <p className="ai-subgroup__title">Modification</p>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="checkedB1"
                                        className="ai-checkbox"
                                        checked={this.state.ismodified}
                                        onChange={this.handleCheck2}
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                    }
                                    label="Modified"
                                  />
                                  {this.state.ismodified && (
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel className="ai-subgroup__title">
                                        Modification Details
                                      </FieldLabel>
                                      <Input
                                        disableUnderline
                                        className="ai-input"
                                        id="component-simple"
                                        value={this.state.modification_deatils}
                                        onChange={this.onchangeModificationDetails}
                                        multiline maxRows={4}
                                        disabled={this.state.userData && this.state.userData.roleId === 10}
                                        placeholder="Enter modification details"
                                      />
                                      <FormHelperText className="error-o">
                                        {this.state.modificationDetailsError}
                                      </FormHelperText>
                                    </FormControl>
                                  )}
                                </div>

                                {this.state.userData &&
                                  (this.state.userData
                                    ?.dealerInventorySubscription ===
                                    "access_only" ||
                                    this.state.userData
                                      ?.dealerInventorySubscription ===
                                    "no_subscription") ? null : (
                                  <div className="ai-subgroup">
                                    <p className="ai-subgroup__title">
                                      Dealer Feed
                                    </p>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          className="float-right"
                                          value={this.state.dealerInv}
                                          checked={this.state.dealerInv}
                                          onChange={this.handleDealerInclude}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      }
                                      label="Include in the Dealer Feed"
                                    />
                                  </div>
                                )}
                                {this.state.isShopifyEnabled &&
                                  this.state.isShopifyVerified &&
                                  !this.state.initialShopifyConfig &&
                                  !this.state.sold ? (
                                  <div className="ai-subgroup">
                                    <p className="ai-subgroup__title">
                                      Shopify Configuration
                                    </p>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          className="float-right"
                                          value={this.state.shopifyConfig}
                                          checked={this.state.shopifyConfig}
                                          onChange={this.handleIncludeShopify}
                                        />
                                      }
                                      label="Include in shopify"
                                    />
                                  </div>
                                ) : null}
                                {this.state.isQboVerified &&
                                  !this.state.qboitemid &&
                                  !this.state.initialQboConfig &&
                                  !this.state.sold ? (
                                  <div className="ai-subgroup">
                                    <p className="ai-subgroup__title">
                                      Quickbook Configuration
                                    </p>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          value={this.state.qboConfig}
                                          checked={this.state.qboConfig}
                                          className="float-right"
                                          onChange={this.handleIncludeQbo}
                                        />
                                      }
                                      label="Include in the Quickbook"
                                    />
                                  </div>
                                ) : null}

                                {this.state.isEbayVerified &&
                                  // !this.state.ebayitemid &&
                                  !this.state.initialEbayConfig &&
                                  !this.state.sold ? (
                                  <div className="ai-subgroup">
                                    <p className="ai-subgroup__title">
                                      Ebay Configuration
                                    </p>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="checkedB1"
                                          value={this.state.ebayConfig}
                                          checked={this.state.ebayConfig}
                                          className="float-right"
                                          onChange={this.handleIncludeEbay}
                                        />
                                      }
                                      label="Include in the Ebay"
                                    />
                                  </div>
                                ) : null}

                              </SectionCard>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </Container>
                  </form>
                </div>
              )
            )}
            {this.state.loaded && this.state.type === null && (
              <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                <SectionCard icon={<CloudUploadOutlinedIcon />} title="UPLOADS (IMAGES & VIDEOS)">
                  <Typography className="ai-uploads__hint">
                    Upload related images and videos of the watch.
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">IMAGES</Typography>
                      <this.UploadDropzone
                        inputId="ai-upload-images"
                        icon={<ImageOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="JPG, PNG, JPEG"
                        accept="image/*"
                        onFilesSelected={this.handleImagesSelected}
                      />
                      <this.ImagePreviewGrid files={this.state.imageFiles} onRemove={this.removeImageFile} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">VIDEOS</Typography>
                      <this.UploadDropzone
                        inputId="ai-upload-videos"
                        icon={<VideocamOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="MP4, MOV "
                        accept="video/*"
                        onFilesSelected={this.handleVideosSelected}
                      />
                      <this.VideoPreviewGrid files={this.state.videoFiles} onRemove={this.removeVideoFile} />
                    </Grid>
                  </Grid>
                </SectionCard>
              </Grid>
            )}
            {this.state.type === null && (
              <div className="ai-bottombar">
                <Button className="ai-btn ai-btn--ghost" onClick={this.handleGoBack}>
                  Cancel
                </Button>
                <Button
                  className="ai-btn ai-btn--primary"
                  style={{
                    opacity: !this.state.isDirty ? 0.6 : 1,
                    cursor: !this.state.isDirty ? "not-allowed" : "pointer",
                    pointerEvents:
                      (this.state.disabled && !this.state.isDirty) || this.state.loading
                        ? "none"
                        : "auto",
                  }}
                  disabled={(this.state.disabled && !this.state.isDirty) || this.state.loading}
                  onClick={(e) => {
                    if (!this.state.isDirty || this.state.disabled || this.state.loading) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    this.submitForm(e);
                  }}
                >
                  {this.state.loading ? (
                    <>
                      <CircularProgress size={18} style={{ color: "#fff", marginRight: 8 }} />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </Button>
              </div>
            )}
            {/* Misc Product Form */}
            {this.state.type === "misc_product" ? (
              <form className="ai-update-form" id="add_inventory_form">
                <Container maxWidth="xl" className="ai-container">
                  <div>
                    <Typography
                      variant="h6"
                      component="p"
                      className="primary-text uppercase"
                    ></Typography>
                  </div>
                  <div>
                    <Grid
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: "0px",
                      }}
                    >
                      {/* <Grid>
                                    <ArrowBackIcon
                                      style={{
                                        color: "action",
                                        paddingRight: "15px",
                                        marginTop: '5px',
                                        fontSize: 40,
                                        cursor: "pointer",
                                      }}
                                      onClick={this.backNavigation}
                                    >

                                    </ArrowBackIcon>
                                  </Grid> */}
                      <Grid>
                        <div onClick={this.handleClickBreadCrumbs}>
                          <Stack spacing={1}>
                            <Breadcrumbs
                              aria-label="breadcrumb"
                              separator={
                                <span className="sperator">›</span>
                              }
                            >
                              <Link
                                className="link"
                                style={{
                                  fontSize: "14px",
                                  color: "#CEA05F",
                                  textDecoration:
                                    "underline !important",
                                  backgroundColor: "white",
                                }}
                                onClick={this.backNavigation}
                              >
                                My Inventory
                              </Link>

                              <Link
                                className="link"
                                style={{
                                  fontSize: "14px",
                                  color: "#CEA05F",
                                  textDecoration:
                                    "underline !important",
                                  backgroundColor: "white",
                                }}
                                onClick={this.handleGoBack}
                              >
                                Inventory Details
                              </Link>
                              <Link
                                style={{
                                  fontSize: "14px",
                                  color: "#9e9e9e",
                                  backgroundColor: "white",
                                }}
                                aria-current="page"
                              >
                                Edit Inventory Details
                              </Link>
                            </Breadcrumbs>
                          </Stack>
                        </div>
                      </Grid>
                    </Grid>
                    <div style={{ marginTop: "30px" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={6}>
                          <div className="ai-col">
                            <SectionCard icon={<InfoOutlinedIcon />} title="BASIC INFORMATION">
                              <Grid container spacing={2} className="ai-misc-grid">
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Model Name{" "}
                                    </FieldLabel>

                                    <Input disableUnderline placeholder="Enter Model Name" className="ai-input" id="component-simple" onChange={this.onchangeProductName} value={this.state.product_name ? this.state.product_name : ""} disabled={this.state.userData && this.state.userData.roleId === 10}></Input>

                                    <FormHelperText className="error-o">
                                      {this.state.onProductNameErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Inventory Title{" "}
                                    </FieldLabel>

                                    <Input
                                      disableUnderline
                                      className="ai-input"
                                      id="component-simple"
                                      onChange={this.onchangeProductTitle}
                                      value={this.state.product_title ?? ""}
                                      disabled={this.state.userData && this.state.userData.roleId === 10}
                                      placeholder="Inventory Title"
                                    >
                                    </Input>

                                    <FormHelperText className="error-o">
                                      {this.state.onProductTitleErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Description{" "}
                                    </FieldLabel>

                                    <Input disableUnderline className="ai-input" id="component-simple" onChange={this.onchangeDescription} value={this.state.description ? this.state.description : ""} disabled={this.state.userData && this.state.userData.roleId === 10} placeholder="Please Enter Description"></Input>

                                    <FormHelperText className="error-o">
                                      {this.state.onDescriptionErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>Brand</FieldLabel>
                                    <Input
                                      disableUnderline
                                      type="text"
                                      id="autocomplete1"
                                      placeholder="Brand"
                                      onChange={this.onchangeBrandName}
                                      value={this.state.brand_name ? this.state.brand_name : ""}
                                      className="ai-input"
                                      disabled={this.state.userData && this.state.userData.roleId === 10}
                                    />
                                    {this.state.brandloading ? (
                                      <CircularProgress />
                                    ) : this.state.brandAutoCompleteData.data.length > 0 ? (
                                      <List
                                        className="searchlist MuiPaper-elevation1 inventrysearch"
                                        style={{
                                          listStyle: "none",
                                          height: "auto",
                                        }}
                                      >
                                        {this.state.brandAutoCompleteData.data.map(
                                          (item, idx) => (
                                            <div>
                                              <ListItem
                                                className={
                                                  cursor === idx
                                                    ? "active"
                                                    : ""
                                                }
                                                key={idx}
                                                onClick={() =>
                                                  this.onchangebrand(item)
                                                }
                                              >
                                                <ListItemText
                                                  primary={item.brandname}
                                                  style={{
                                                    marginTop: "10px",
                                                    marginLeft: "50px",
                                                  }}
                                                />
                                              </ListItem>
                                              <Divider
                                                variant="inset"
                                                component="li"
                                                style={{ margin: "5px" }}
                                              />
                                            </div>
                                          ),
                                        )}
                                      </List>
                                    ) : null}
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Model Number
                                    </FieldLabel>

                                    <Input disableUnderline className="ai-input" id="component-simple" onChange={this.onchangeProductModelNumber} value={this.state.model_number ? this.state.model_number : ""} disabled={this.state.userData && this.state.userData.roleId === 10} placeholder="Enter Model Number"></Input>

                                    <FormHelperText className="error-o">
                                      {this.state.onModelNumberErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Quantity{" "}
                                    </FieldLabel>

                                    <Input disableUnderline className="ai-input" id="component-simple" // onChange={this.onchangeQuantity}
                                      value={this.state.quantity ? this.state.quantity : ""} disabled={this.state.userData && this.state.userData.roleId === 10 || this.state.quantityDisabled}></Input>

                                    <FormHelperText className="error-o">
                                      {this.state.onQuantityErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>Serial Number</FieldLabel>
                                    <Input
                                      disableUnderline
                                      className="ai-input"
                                      id="component-simple"
                                      onChange={this.onchangeSerialNumber}
                                      value={this.state.SerialNumber ? this.state.SerialNumber : ""}
                                      disabled={this.state.disabled || (this.state.userData && this.state.userData.roleId === 10)}
                                      placeholder="Enter serial number"
                                    />
                                    <FormHelperText className="error-o">
                                      {this.state.onSerialNumberErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </SectionCard>

                            <SectionCard icon={<TuneOutlinedIcon />} title="PURCHASE DETAILS" style={{ marginTop: "10px" }}>
                              {(isActionAllowed(
                                this.state.viewData,
                                "purchase_from",
                              ) ||
                                isActionAllowed(
                                  this.state.viewData,
                                  "purchase_date",
                                )) && (
                                  <Grid container spacing={2}>
                                    {isActionAllowed(
                                      this.state.viewData,
                                      "purchase_from",
                                    ) && (
                                        <Grid item xs={12} sm={6}>
                                          <FormControl fullWidth className="ai-field">
                                            <FieldLabel>Purchased From</FieldLabel>
                                            <div className="ai-input-icon-wrap">
                                              <AntdInput
                                                id="PurchasedFrom"
                                                type="text"
                                                autoComplete="off"
                                                className="ai-antd-input"
                                                placeholder="Search dealer or source"
                                                ref={this.purchasedFromRef}
                                                value={this.state.PurchasedFrom}
                                                onChange={(e) =>
                                                  this.onchangeContactSuggestion(
                                                    e,
                                                    "PurchasedFrom",
                                                    ["supplier", "memo_supplier"],
                                                  )
                                                }
                                                bordered={false}
                                                disabled={this.state.isDisabled}
                                              />
                                              <span className="ai-input-icon-wrap__icon">
                                                {!this.state.PurchasedFrom ? (
                                                  <SearchIcon
                                                    style={{ cursor: "pointer" }}
                                                    fontSize="small"
                                                  />
                                                ) : this.state.fieldLoader ? (
                                                  <CircularProgress
                                                    style={{ width: 18, height: 18 }}
                                                  />
                                                ) : (
                                                  <ClearIcon
                                                    id="clearBtn"
                                                    onClick={() =>
                                                      this.clearContactSuggestion(
                                                        "PurchasedFrom",
                                                      )
                                                    }
                                                    style={{ cursor: "pointer" }}
                                                    fontSize="small"
                                                  />
                                                )}
                                              </span>
                                            </div>
                                          </FormControl>
                                          {this.state.purchasedFromArray &&
                                            this.state.purchasedFromArray.length >
                                            0 &&
                                            this.state.PurchasedFrom?.length > 0 ? (
                                            <div>
                                              <AntdPopover
                                                visible={
                                                  this.state
                                                    .isPopOverPurchasedFrom
                                                }
                                                content={
                                                  <div
                                                    style={{
                                                      height: "200px",
                                                      overflow: "auto",
                                                    }}
                                                  >
                                                    {this.state.dataset
                                                      ?.slice(0, 15)
                                                      .map((value, key) => {
                                                        return value.map(
                                                          (el, index) => {
                                                            if (index < 1) {
                                                              const displayName = `${el?.firstname ??
                                                                ""
                                                                } ${el?.lastname ?? ""}`;
                                                              return (
                                                                <>
                                                                  {/* <Accordion>
                                                          <AccordionSummary
                                                            aria-controls="panel1d-content"
                                                            id="panel1d-header"
                                                          >
                                                            <Typography
                                                              style={{
                                                                padding: 10,
                                                                width: 300,
                                                                cursor: "pointer",
                                                              }}
                                                            >
                                                              {(el?.businessname ||
                                                                displayName) ??
                                                                ""}
                                                            </Typography>
                                                          </AccordionSummary> */}

                                                                  {this.state.purchasedFromArray
                                                                    ?.filter(
                                                                      (v) =>
                                                                        v.email ==
                                                                        el.email,
                                                                    )
                                                                    .map(
                                                                      (
                                                                        el,
                                                                        index,
                                                                      ) => {
                                                                        return (
                                                                          <AccordionDetails
                                                                            key={
                                                                              index
                                                                            }
                                                                          >
                                                                            <Typography
                                                                              style={{
                                                                                cursor:
                                                                                  "pointer",
                                                                              }}
                                                                              onClick={() =>
                                                                                this.handleContactSelection(
                                                                                  el,
                                                                                  "PurchasedFrom",
                                                                                )
                                                                              }
                                                                            >
                                                                              {this.handleContact(
                                                                                el,
                                                                              )}
                                                                            </Typography>
                                                                          </AccordionDetails>
                                                                        );
                                                                      },
                                                                    )}
                                                                  {/* </Accordion> */}
                                                                </>
                                                              );
                                                            }
                                                          },
                                                        );
                                                      })}
                                                  </div>
                                                }
                                                trigger="click"
                                                placement="bottomRight"
                                                // placement="bottomLeft"
                                                onVisibleChange={
                                                  this.handleVisibleChange
                                                }
                                              >
                                                <div
                                                  style={{
                                                    width: 0,
                                                    height: 0,
                                                    position: "absolute",
                                                  }}
                                                />
                                              </AntdPopover>
                                            </div>
                                          ) : (
                                            // this.state.paymentDetailsText === "Trade" &&
                                            this.state.PurchasedFrom.length > 2 &&
                                            !this.state.purchasedFromArray
                                              .length &&
                                            !this.state.fieldLoader &&
                                            !this.state.purchaseFromContactId && (
                                              <AntdPopover
                                                // id={column.id}
                                                visible
                                                content={
                                                  <div
                                                    style={{ overflow: "auto" }}
                                                  >
                                                    <a
                                                      className="dataItem"
                                                      href="javascript:void(0)"
                                                      onClick={() => {
                                                        // this.setState({
                                                        //   PurchasedFrom: "",
                                                        // });
                                                        const typeData = [
                                                          {
                                                            id: "supplier",
                                                            value: "Supplier",
                                                          },
                                                          {
                                                            id: "memo_supplier",
                                                            value:
                                                              "Memo Supplier",
                                                          },
                                                        ];
                                                        const encodedTypeData =
                                                          btoa(
                                                            JSON.stringify(
                                                              typeData,
                                                            ),
                                                          );
                                                        window.open(
                                                          `/contactmanagement/add?type=${encodedTypeData}`,
                                                          "_blank",
                                                        );
                                                        // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                      }}
                                                      style={{
                                                        cursor: "pointer",
                                                        textDecoration:
                                                          "underline",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      Click here to Create New
                                                      Contact
                                                    </a>
                                                  </div>
                                                }
                                                trigger="click"
                                                placement="bottom"
                                              // overlayStyle={{ marginTop: "5px" }}
                                              >
                                                {/* <div
                                        style={{
                                          width: 0,
                                          height: 0,
                                          position: "absolute",
                                        }}
                                      /> */}
                                              </AntdPopover>
                                            )
                                          )}
                                        </Grid>
                                      )}

                                    {isActionAllowed(
                                      this.state.viewData,
                                      "purchase_date",
                                    ) && (
                                        <Grid item xs={12} sm={6}>
                                          <FormControl
                                            fullWidth className="ai-field ai-datepicker"
                                          >
                                            <FieldLabel>Purchased Date</FieldLabel>
                                            <MuiPickersUtilsProvider
                                              utils={DateFnsUtils}
                                            >
                                              <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                format="MM/dd/yyyy"
                                                disableFuture={true}
                                                value={
                                                  this.state.purchaseDate || null
                                                }
                                                onChange={this.handlePurchaseDate}
                                                KeyboardButtonProps={{
                                                  "aria-label": "change date",
                                                }}
                                                placeholder="Purchased Date - MM/DD/YYYY"
                                                onPaste={(event) =>
                                                  event.preventDefault()
                                                }
                                                helperText={
                                                  this.state.error["PD"]
                                                    ? "Invalid date"
                                                    : ""
                                                }
                                                error={this.state.error["PD"]}
                                              />
                                            </MuiPickersUtilsProvider>
                                            <FormHelperText className="error-o">
                                              {this.state.onpurchaseDateErrorText}
                                            </FormHelperText>
                                          </FormControl>
                                        </Grid>
                                      )}
                                  </Grid>
                                )}

                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>Purchase Payment Status</FieldLabel>
                                    <Select
                                      disableUnderline
                                      className="ai-select"
                                      value={this.state.paidStatus ? "paid" : "unpaid"}
                                      onChange={(e) =>
                                        this.handlePaidStatusCheck({
                                          target: { checked: e.target.value === "paid" },
                                        })
                                      }
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                      renderValue={(val) => (
                                        <span className="ai-status-pill">
                                          <span className="ai-status-pill__dot" />
                                          {val === "paid" ? "Paid" : "Unpaid"}
                                        </span>
                                      )}
                                    >
                                      <MenuItem value="paid">Paid</MenuItem>
                                      <MenuItem value="unpaid">Unpaid</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                  {this.state.paidStatus ? (
                                    <FormControl fullWidth className="ai-field ai-datepicker">
                                      <FieldLabel>Purchase Payment Date</FieldLabel>

                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                          margin="normal"
                                          id="date-picker-purchase"
                                          format="MM/dd/yyyy"
                                          disableFuture
                                          value={this.state.paymentDate || null}
                                          onChange={this.handleDateChange}
                                          KeyboardButtonProps={{
                                            "aria-label": "change purchase payment date",
                                          }}
                                          placeholder="Purchase Payment Date - MM/DD/YYYY"
                                          onPaste={(event) => event.preventDefault()}
                                          helperText={this.state.error["PPD"] ? "Invalid date" : ""}
                                          error={Boolean(this.state.error["PPD"])}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      </MuiPickersUtilsProvider>

                                      <FormHelperText className="error-o">
                                        {this.state.onpurchaseDateErrorText}
                                      </FormHelperText>
                                    </FormControl>
                                  ) : (
                                    <FormControl fullWidth className="ai-field ai-datepicker">
                                      <FieldLabel>Purchase Payment Due Date</FieldLabel>

                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                          margin="normal"
                                          id="date-picker-purchase-due"
                                          format="MM/dd/yyyy"
                                          value={this.state.purchaseDueDate || null}
                                          onChange={this.handleDueDateChange}
                                          KeyboardButtonProps={{
                                            "aria-label": "change purchase payment due date",
                                          }}
                                          placeholder="Purchase Payment Due Date - MM/DD/YYYY"
                                          onPaste={(event) => event.preventDefault()}
                                          helperText={this.state.error["PPDD"] ? "Invalid date" : ""}
                                          error={Boolean(this.state.error["PPDD"])}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      </MuiPickersUtilsProvider>

                                      <FormHelperText className="error-o">
                                        {this.state.onpurchaseDueDateErrorText}
                                      </FormHelperText>
                                    </FormControl>
                                  )}

                                </Grid>
                              </Grid>

                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>
                                  Purchase Payment Details
                                </FieldLabel>
                                <Input disableUnderline
                                  className="ai-input" id="component-simple" multiline
                                  onChange={this.onchangePaymentDetails}
                                  value={this.state.paymentDetailsText ? this.state.paymentDetailsText : ""}
                                  disabled={this.state.userData && this.state.userData.roleId === 10}
                                  placeholder="Enter payment details"
                                />
                                <FormHelperText className="error-o">
                                  {this.state.onPaymentDetailsErrorText}
                                </FormHelperText>
                              </FormControl>

                              {(isActionAllowed(
                                this.state.viewData,
                                "purchase_price",
                              ) ||
                                isActionAllowed(
                                  this.state.viewData,
                                  "purchase_expense",
                                )) && (
                                  <Grid container spacing={2}>
                                    {isActionAllowed(
                                      this.state.viewData,
                                      "purchase_price",
                                    ) && (
                                        <Grid item xs={12} sm={6}>
                                          <FormControl fullWidth className="ai-field">
                                            <FieldLabel>
                                              Purchased Price ($)
                                            </FieldLabel>
                                            <Input
                                              disableUnderline
                                              className="ai-input"
                                              id="component-simple"
                                              onChange={this.onchangePurchasedPrice}
                                              value={this.state.PurchasedPrice ? this.state.PurchasedPrice : ""}
                                              style={{
                                                marginBottom: "10px"
                                              }}
                                              disabled={this.state.isDisabled}
                                              placeholder="0.00"
                                            />
                                            <FormHelperText className="error-o">
                                              {this.state.onPurchasedPriceErrorText}
                                            </FormHelperText>
                                          </FormControl>
                                        </Grid>
                                      )}

                                    {isActionAllowed(
                                      this.state.viewData,
                                      "purchase_expense",
                                    ) && (
                                        <Grid item xs={12} sm={6}>
                                          <FormControl fullWidth className="ai-field">
                                            <FieldLabel>
                                              Purchase Expense ($)
                                            </FieldLabel>
                                            <Input
                                              disableUnderline
                                              className="ai-input"
                                              id="component-simple"
                                              onChange={this.onchangePurchaseExpense}
                                              value={this.state.purchase_expense}
                                              placeholder="0.00"
                                            />
                                            <FormHelperText className="error-o"></FormHelperText>
                                          </FormControl>
                                        </Grid>
                                      )}
                                  </Grid>
                                )}

                              {isActionAllowed(
                                this.state.viewData,
                                "purchase_expense",
                              ) && (
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      {" "}
                                      Purchase Expense Note
                                    </FieldLabel>
                                    <Input
                                      disableUnderline
                                      className="ai-input"
                                      id="component-simple"
                                      onChange={this.onchangePurchaseExpenseNote}
                                      value={this.state.purchase_expense_note ? this.state.purchase_expense_note : ""}
                                      placeholder="Enter expense note"
                                    />
                                    <FormHelperText className="error-o"></FormHelperText>
                                  </FormControl>
                                )}

                              {isActionAllowed(
                                this.state.viewData,
                                "total_cost",
                              ) && (
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                      <FormControl fullWidth className="ai-field">
                                        <FieldLabel>Total Cost ($)</FieldLabel>
                                        <Input
                                          disableUnderline
                                          className="ai-input"
                                          id="component-simple"
                                          disabled value={this.state.total_cost}
                                          placeholder="0.00"
                                        />
                                        <FormHelperText className="error-o"></FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                )}
                            </SectionCard>

                            <SectionCard icon={<TuneOutlinedIcon />} title="INVENTORY DETAILS" style={{ marginTop: "10px" }}>
                              {/* <FormControl fullWidth className="ai-field">
                                <FieldLabel>Serial Number</FieldLabel>
                                <Input
                                  disableUnderline
                                  className="ai-input"
                                  id="component-simple"
                                  onChange={this.onchangeSerialNumber}
                                  value={this.state.SerialNumber ? this.state.SerialNumber : ""}
                                  disabled={this.state.isdisabled || (this.state.userData && this.state.userData.roleId === 10)}
                                  placeholder="Enter serial number"
                                />
                                <FormHelperText className="error-o">
                                  {this.state.onSerialNumberErrorText}
                                </FormHelperText>
                              </FormControl> */}

                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>Inventory Type</FieldLabel>

                                    <Select
                                      className="ai-select"
                                      id="inventory-type"
                                      value={this.state.InventoryType === "null" ? "" : this.state.InventoryType}
                                      onChange={(e) =>
                                        this.setState({
                                          InventoryType: e.target.value,
                                          MemoDetails: "",
                                          PartnershipDetails: "",
                                          memoContactId: null,
                                          partnerContactId: null,
                                          isDirty: true,
                                        })
                                      }
                                      disabled={this.state.userData && this.state.userData.roleId === 10}
                                      displayEmpty
                                      renderValue={(selected) => {
                                        if (!selected) {
                                          return <span style={{ color: "#999" }}>Select Type</span>;
                                        }
                                        const typeMap = {
                                          "1": "Regular Inventory",
                                          "2": "Memo Inventory",
                                          "3": "Partnership Inventory",
                                          "5": "Consignment Inventory",
                                          "4": "Trade Inventory",
                                        };
                                        return typeMap[selected] || selected;
                                      }}
                                    >
                                      <MenuItem value="">
                                        <em>Select Type</em>
                                      </MenuItem>
                                      <MenuItem value="1">Regular Inventory</MenuItem>
                                      <MenuItem value="2">Memo Inventory</MenuItem>
                                      <MenuItem value="3">Partnership Inventory</MenuItem>
                                      <MenuItem value="5">Consignment Inventory</MenuItem>
                                      <MenuItem value="4" style={{ display: "none" }}>
                                        Trade Inventory
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>

                                {this.state.InventoryType === "2" && (
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Memo Contact</FieldLabel>
                                      <AntdInput
                                        id="MemoDetails"
                                        type="text"
                                        ref={this.memoDetailsRef}
                                        autoComplete="off"
                                        value={this.state.MemoDetails}
                                        style={{
                                          marginBottom: "0px",
                                          marginTop: "10px",
                                          fontSize: "16px",
                                          paddingLeft: 0,
                                        }}
                                        onChange={(e) =>
                                          this.onchangeContactSuggestion(
                                            e,
                                            "MemoDetails",
                                            ["memo_supplier"],
                                          )
                                        }
                                        bordered={false}
                                        placeholder="Search Memo Contact Name / Business Name"
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                      <Divider
                                        style={{
                                          background: "#ada8a8",
                                          marginTop: "5px",
                                        }}
                                      />
                                      <div className="contactSearchIcon">
                                        <Grid container>
                                          <Grid item xs={6} sm={6} md={6}>
                                            {this.state.userData?.roleId !== 10 && (
                                              <>
                                                {!this.state.MemoDetails ? (
                                                  <SearchIcon
                                                    style={{ cursor: "pointer" }}
                                                  />
                                                ) : (
                                                  <>
                                                    {this.state.fieldLoader ? (
                                                      <CircularProgress
                                                        style={{
                                                          width: "25px",
                                                          height: "25px",
                                                        }}
                                                      />
                                                    ) : (
                                                      <ClearIcon
                                                        id="clearBtn"
                                                        onClick={() =>
                                                          this.clearContactSuggestion(
                                                            "MemoDetails",
                                                          )
                                                        }
                                                        style={{ cursor: "pointer" }}
                                                      />
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </FormControl>
                                    {this.state.memoDetailsArray &&
                                      this.state.memoDetailsArray.length > 0 &&
                                      this.state.MemoDetails?.length > 0 ? (
                                      <div>
                                        <AntdPopover
                                          visible={this.state.isPopOverMemoDetails}
                                          content={
                                            <div
                                              style={{
                                                height: "200px",
                                                overflow: "auto",
                                              }}
                                            >
                                              {this.state.dataset
                                                ?.slice(0, 15)
                                                .map((value, key) => {
                                                  return value.map((el, index) => {
                                                    if (index < 1) {
                                                      const displayName = `${el?.firstname ?? ""
                                                        } ${el?.lastname ?? ""}`;
                                                      return (
                                                        <>
                                                          {/* <Accordion>
                                                    <AccordionSummary
                                                      aria-controls="panel1d-content"
                                                      id="panel1d-header"
                                                    >
                                                      <Typography
                                                        style={{
                                                          padding: 10,
                                                          width: 300,
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {(el?.businessname ||
                                                          displayName) ??
                                                          ""}
                                                      </Typography>
                                                    </AccordionSummary> */}

                                                          {this.state.memoDetailsArray
                                                            ?.filter(
                                                              (v) =>
                                                                v.email == el.email,
                                                            )
                                                            .map((el, index) => {
                                                              return (
                                                                <AccordionDetails
                                                                  key={index}
                                                                >
                                                                  <Typography
                                                                    style={{
                                                                      cursor: "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                      this.handleContactSelection(
                                                                        el,
                                                                        "MemoDetails",
                                                                      )
                                                                    }
                                                                  >
                                                                    {this.handleContact(
                                                                      el,
                                                                    )}
                                                                  </Typography>
                                                                </AccordionDetails>
                                                              );
                                                            })}
                                                          {/* </Accordion> */}
                                                        </>
                                                      );
                                                    }
                                                  });
                                                })}
                                            </div>
                                          }
                                          trigger="click"
                                          placement="bottomRight"
                                          // placement="bottomLeft"
                                          onVisibleChange={this.handleVisibleChange}
                                        >
                                          <div
                                            style={{
                                              width: 0,
                                              height: 0,
                                              position: "absolute",
                                            }}
                                          />
                                        </AntdPopover>
                                      </div>
                                    ) : (
                                      this.state.MemoDetails?.length > 2 &&
                                      !this.state.memoDetailsArray.length &&
                                      !this.state.fieldLoader &&
                                      !this.state.memoContactId && (
                                        <AntdPopover
                                          // id={column.id}
                                          visible={
                                            this.state.MemoDetails?.length > 2 &&
                                            !this.state.memoDetailsArray.length &&
                                            !this.state.fieldLoader &&
                                            !this.state.memoContactId
                                          }
                                          content={
                                            <div style={{ overflow: "auto" }}>
                                              <a
                                                className="dataItem"
                                                onClick={() => {
                                                  // this.setState({
                                                  //   MemoDetails: "",
                                                  // });
                                                  const typeData = [
                                                    {
                                                      id: "memo_supplier",
                                                      value: "Memo Supplier",
                                                    },
                                                  ];
                                                  const encodedTypeData = btoa(
                                                    JSON.stringify(typeData),
                                                  );
                                                  window.open(
                                                    `/contactmanagement/add?type=${encodedTypeData}`,
                                                    "_blank",
                                                  );
                                                  // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                }}
                                                style={{
                                                  cursor: "pointer",
                                                  textDecoration: "underline",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Click here to Create New Contact
                                              </a>
                                            </div>
                                          }
                                          trigger="click"
                                          placement="bottom"
                                        // overlayStyle={{ marginTop: "5px" }}
                                        >
                                          {/* <div
                                  style={{
                                    width: 0,
                                    height: 0,
                                    position: "absolute",
                                  }}
                                /> */}
                                        </AntdPopover>
                                      )
                                    )}
                                  </Grid>
                                )}

                                {this.state.InventoryType === "3" && (
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Partnership Contact</FieldLabel>
                                      <AntdInput
                                        id="PartnershipDetails"
                                        type="text"
                                        autoComplete="off"
                                        ref={this.partnershipDetailsRef}
                                        value={this.state.PartnershipDetails}
                                        style={{
                                          marginBottom: "0px",
                                          fontSize: "16px",
                                          paddingLeft: 0,
                                        }}
                                        onChange={(e) =>
                                          this.onchangeContactSuggestion(
                                            e,
                                            "PartnershipDetails",
                                            ["partner"],
                                          )
                                        }
                                        bordered={false}
                                        placeholder="Search Partnership Contact Name / Business Name"
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                      <Divider
                                        style={{
                                          background: "#ada8a8",
                                          marginTop: "5px",
                                        }}
                                      />
                                      <div className="contactSearchIcon">
                                        <Grid container>
                                          <Grid item xs={6} sm={6} md={6}>
                                            {this.state.userData?.roleId !== 10 && (
                                              <>
                                                {!this.state.PartnershipDetails ? (
                                                  <SearchIcon
                                                    style={{ cursor: "pointer" }}
                                                  />
                                                ) : (
                                                  <>
                                                    {this.state.fieldLoader ? (
                                                      <CircularProgress
                                                        style={{
                                                          width: "25px",
                                                          height: "25px",
                                                        }}
                                                      />
                                                    ) : (
                                                      <ClearIcon
                                                        id="clearBtn"
                                                        onClick={() =>
                                                          this.clearContactSuggestion(
                                                            "PartnershipDetails",
                                                          )
                                                        }
                                                        style={{ cursor: "pointer" }}
                                                      />
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </FormControl>
                                    {this.state.partnershipDetailsArray &&
                                      this.state.partnershipDetailsArray.length > 0 &&
                                      this.state.PartnershipDetails?.length > 0 ? (
                                      <div>
                                        <AntdPopover
                                          visible={
                                            this.state.isPopOverPartnershipDetails
                                          }
                                          content={
                                            <div
                                              style={{
                                                height: "200px",
                                                overflow: "auto",
                                              }}
                                            >
                                              {this.state.dataset
                                                ?.slice(0, 15)
                                                .map((value, key) => {
                                                  return value.map((el, index) => {
                                                    if (index < 1) {
                                                      const displayName = `${el?.firstname ?? ""
                                                        } ${el?.lastname ?? ""}`;
                                                      return (
                                                        <>
                                                          {/* <Accordion>
                                                    <AccordionSummary
                                                      aria-controls="panel1d-content"
                                                      id="panel1d-header"
                                                    >
                                                      <Typography
                                                        style={{
                                                          padding: 10,
                                                          width: 300,
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {(el?.businessname ||
                                                          displayName) ??
                                                          ""}
                                                      </Typography>
                                                    </AccordionSummary> */}

                                                          {this.state.partnershipDetailsArray
                                                            ?.filter(
                                                              (v) =>
                                                                v.email == el.email,
                                                            )
                                                            .map((el, index) => {
                                                              return (
                                                                <AccordionDetails
                                                                  key={index}
                                                                >
                                                                  <Typography
                                                                    style={{
                                                                      cursor: "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                      this.handleContactSelection(
                                                                        el,
                                                                        "PartnershipDetails",
                                                                      )
                                                                    }
                                                                  >
                                                                    {this.handleContact(
                                                                      el,
                                                                    )}
                                                                  </Typography>
                                                                </AccordionDetails>
                                                              );
                                                            })}
                                                          {/* </Accordion> */}
                                                        </>
                                                      );
                                                    }
                                                  });
                                                })}
                                            </div>
                                          }
                                          trigger="click"
                                          placement="bottomRight"
                                          // placement="bottomLeft"
                                          onVisibleChange={this.handleVisibleChange}
                                        >
                                          <div
                                            style={{
                                              width: 0,
                                              height: 0,
                                              position: "absolute",
                                            }}
                                          />
                                        </AntdPopover>
                                      </div>
                                    ) : (
                                      this.state.PartnershipDetails.length > 2 &&
                                      !this.state.partnershipDetailsArray.length &&
                                      !this.state.fieldLoader &&
                                      !this.state.partnerContactId && (
                                        <AntdPopover
                                          // id={column.id}
                                          visible={
                                            this.state.PartnershipDetails?.length > 2 &&
                                            !this.state.partnershipDetailsArray
                                              .length &&
                                            !this.state.fieldLoader &&
                                            !this.state.partnerContactId
                                          }
                                          content={
                                            <div style={{ overflow: "auto" }}>
                                              <a
                                                className="dataItem"
                                                href="javascript:void(0)"
                                                onClick={() => {
                                                  // this.setState({
                                                  //   PartnershipDetails: "",
                                                  // });
                                                  const typeData = [
                                                    { id: "partner", value: "Partner" },
                                                  ];
                                                  const encodedTypeData = btoa(
                                                    JSON.stringify(typeData),
                                                  );
                                                  window.open(
                                                    `/contactmanagement/add?type=${encodedTypeData}`,
                                                    "_blank",
                                                  );
                                                  // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                }}
                                                style={{
                                                  cursor: "pointer",
                                                  textDecoration: "underline",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Click here to Create New Contact
                                              </a>
                                            </div>
                                          }
                                          trigger="click"
                                          placement="bottom"
                                        // overlayStyle={{ marginTop: "5px" }}
                                        >
                                          {/* <div
                                  style={{
                                    width: 0,
                                    height: 0,
                                    position: "absolute",
                                  }}
                                /> */}
                                        </AntdPopover>
                                      )
                                    )}
                                  </Grid>
                                )}

                                {(this.state.InventoryType === "2" ||
                                  this.state.InventoryType === "3") && (
                                    <Grid item xs={12} sm={6}>
                                      {/* <FormControl
                                className="form-width-70 margin-t-b-20 margin-p-b-20"
                                style={{ marginTop: "15px" }}
                              >
                                <InputLabel
                                  htmlFor="component-simple"
                                  style={{ color: "#424242" }}
                                >
                                  {this.state.InventoryType === "2"
                                    ? "Memo Details"
                                    : "Partnership Details"}
                                </InputLabel>
                                <Input
                                  id="component-simple"
                                  value={
                                    this.state.InventoryType === "2"
                                      ? this.state.MemoDetails
                                      : this.state.PartnershipDetails
                                  }
                                  onChange={(e) => {
                                    this.setState({
                                      MemoDetails:
                                        this.state.InventoryType === "2"
                                          ? e.target.value
                                          : "",
                                      PartnershipDetails:
                                        this.state.InventoryType === "3"
                                          ? e.target.value
                                          : "",
                                    });
                                  }}
                                />
                              </FormControl> */}
                                      <FormControl fullWidth className="ai-field">
                                        <FieldLabel>
                                          {this.state.InventoryType === "2" ? "MEMO NUMBER" : "PARTNERSHIP NUMBER"}
                                        </FieldLabel>
                                        <Input
                                          disableUnderline
                                          className="ai-input"
                                          id="component-simple"
                                          placeholder={
                                            this.state.inventory_type === "2"
                                              ? "Enter Memo Number"
                                              : "Enter Partnership Number"
                                          }
                                          value={this.state.InventoryType === "2" ? this.state.updatememo : this.state.updatepartnershipnumber}
                                          onChange={e => {
                                            this.setState({
                                              updatememo: this.state.InventoryType === "2" ? e.target.value : "",
                                              updatepartnershipnumber: this.state.InventoryType === "3" ? e.target.value : ""
                                            });
                                          }} disabled={this.state.userData && this.state.userData.roleId === 10} />
                                      </FormControl>
                                    </Grid>
                                  )}

                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Inventory Status
                                    </FieldLabel>
                                    <Select
                                      className="ai-select"
                                      id="component-simple"
                                      defaultValue={this.state.InventoryStatus}
                                      value={this.state.InventoryStatus}
                                      onChange={e => this.setState({
                                        InventoryStatus: e.target.value,
                                        isDirty: true
                                      })}
                                      disabled={this.state.memoId && this.state.InventoryStatus == 3 && this.state.sold !== 1 ? true : false}
                                      displayEmpty
                                    // renderValue={(selected) => {
                                    //   if (!selected) {
                                    //     return <span style={{ color: "#999" }}>Select Status</span>;
                                    //   }
                                    //   return selected;
                                    // }}
                                    >
                                      <MenuItem value="" disabled>
                                        Select Status
                                      </MenuItem>
                                      <MenuItem value="2">Incoming</MenuItem>
                                      <MenuItem value="6">
                                        Needs Service / Polish
                                      </MenuItem>
                                      <MenuItem value="7">At Service</MenuItem>
                                      <MenuItem value="11">Intake Complete</MenuItem>
                                      <MenuItem value="13">Need to Post</MenuItem>
                                      <MenuItem value="12">Invoiced</MenuItem>
                                      <MenuItem value="1">Inhand</MenuItem>
                                      <MenuItem value="3">Out on Memo</MenuItem>
                                      <MenuItem value="4">On Hold / Reserved</MenuItem>
                                      <MenuItem value="8">Need to Ship</MenuItem>
                                      <MenuItem value="9">
                                        Shipped waiting on payment
                                      </MenuItem>
                                      <MenuItem value="10">Sold & Cashed Out</MenuItem>
                                      <MenuItem value="5">Available to Order</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                  <div>
                                    <FormControl fullWidth className="ai-field ai-field--dropdown">
                                      <FieldLabel>Inventory Location</FieldLabel>
                                      <Input
                                        type="text"
                                        className="ai-input"
                                        placeholder="Enter location"
                                        id="autocomplete1"
                                        onChange={this.locationAutoComplete}
                                        onFocus={this.handleLocationFocus}
                                        onBlur={this.handleLocationBlur}
                                        value={this.state.locationSearch}
                                        endAdornment={
                                          this.state.locationloading ? (
                                            <InputAdornment position="end">
                                              <CircularProgress size={16} />
                                            </InputAdornment>
                                          ) : null
                                        }
                                      />
                                      {!this.state.locationloading && this.state.locationAutoCompleteData?.data?.length > 0 ? (
                                        <List
                                          className="searchlist MuiPaper-elevation1 inventrysearch ai-location-results"
                                          style={{ listStyle: "none" }}
                                        >
                                          {this.state.locationAutoCompleteData.data.map(
                                            (item, idx) => (
                                              <div key={idx}>
                                                <ListItem
                                                  className={
                                                    this.state.cursor === idx ? "active" : ""
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                  onMouseDown={() =>
                                                    this.onchangeLocation(item)
                                                  }
                                                >
                                                  <ListItemText
                                                    primary={item.locations}
                                                    style={{
                                                      marginTop: "10px",
                                                      marginLeft: "50px",
                                                    }}
                                                  />
                                                </ListItem>

                                                <Divider
                                                  variant="inset"
                                                  component="li"
                                                  style={{ margin: "5px" }}
                                                />
                                              </div>
                                            )
                                          )}
                                        </List>
                                      ) : null}
                                    </FormControl>
                                  </div>
                                </Grid>
                              </Grid>

                              <div className="ai-condition" id="conditionField">
                                <FieldLabel>Condition</FieldLabel>

                                <ConditionSelector
                                  marks={followersMarks2()}
                                  value={this.state.Condition}
                                  onChange={this.onchangeCondition}
                                />

                                <div className="ai-condition-hint">
                                  <InfoOutlinedIcon style={{ fontSize: 14 }} />
                                  Select the condition that best describes your inventory.
                                </div>

                                <FormHelperText className="error-o">
                                  {this.state.onConditionErrorText}
                                </FormHelperText>
                              </div>
                            </SectionCard>
                          </div>
                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>
                          <div className="ai-col">
                            <SectionCard icon={<DescriptionOutlinedIcon />} title="SPECIFICATIONS & PRICING">
                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>
                                  Internal Dealer Note
                                </FieldLabel>
                                <Input
                                  disableUnderline
                                  multiline
                                  className="ai-input ai-input--textarea ai-input--textarea-lg"
                                  id="component-simple"
                                  placeholder="Enter internal dealer note"
                                  onChange={this.onchangeDealerNotes}
                                  value={this.state.DealerNotes ? this.state.DealerNotes : ""}
                                />
                                <FormHelperText className="error-o">
                                  {this.state.onDealerNotesErrorText}
                                </FormHelperText>
                              </FormControl>

                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>
                                  Public Dealer Notes
                                </FieldLabel>
                                <Input
                                  disableUnderline
                                  multiline
                                  className="ai-input ai-input--textarea ai-input--textarea-lg"
                                  id="component-simple"
                                  placeholder="Enter public dealer notes"
                                  onChange={this.onchangePublicDealerNote}
                                  value={this.state.public_dealer_note ? this.state.public_dealer_note : ""}
                                  disabled={this.state.userData && this.state.userData.roleId === 10}
                                />
                                <FormHelperText className="error-o"></FormHelperText>
                              </FormControl>
                            </SectionCard>

                            <SectionCard icon={<PaidOutlinedIcon />} title="TARGET PRICING DETAILS" style={{ marginTop: "10px" }}>
                              <div className="space-top-8">
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    {getCustomLabel("custom_wholesale_price", "TARGET WHOLESALE PRICE")} ($)
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    style={{
                                      marginBottom: "10px"
                                    }}
                                    placeholder="0.00"
                                    onChange={this.onchangeWholeSalePrice}
                                    value={this.state.WholeSalePrice ? this.state.WholeSalePrice : ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onWholeSalePriceErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </div>

                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>
                                  {getCustomLabel("custom_end_customer_price", "TARGET END CUSTOMER PRICE")} ($)
                                </FieldLabel>
                                <Input
                                  disableUnderline
                                  className="ai-input"
                                  id="component-simple"
                                  style={{
                                    marginBottom: "10px"
                                  }}
                                  onChange={this.onchangeRetailPrice}
                                  value={this.state.RetailPrice ? this.state.RetailPrice : ""}
                                  disabled={this.state.userData && this.state.userData.roleId === 10}
                                  placeholder="0.00"
                                />
                                <FormHelperText className="error-o">
                                  {this.state.onRetailPriceErrorText}
                                </FormHelperText>
                              </FormControl>

                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>
                                  {getCustomLabel("custom_end_customer_wire_price", "TARGET END CUSTOMER WIRE PRICE")} ($)
                                </FieldLabel>
                                <Input
                                  disableUnderline
                                  className="ai-input"
                                  id="component-simple"
                                  style={{
                                    marginBottom: "10px"
                                  }}
                                  onChange={this.onchangeRetailWirePrice}
                                  value={this.state.RetailWirePrice ? this.state.RetailWirePrice : ""}
                                  disabled={this.state.userData && this.state.userData.roleId === 10}
                                  placeholder="0.00"
                                />
                                <FormHelperText className="error-o">
                                  {this.state.onRetailWirePriceErrorText}
                                </FormHelperText>
                              </FormControl>

                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>
                                  {getCustomLabel("custom_tag_price", "TAG PRICE")} ($)
                                </FieldLabel>
                                <Input disableUnderline className="ai-input" id="component-simple" type="text" onChange={this.onchangeTagPrice} value={this.state.tag_price || ""} disabled={this.state.userData && this.state.userData.roleId === 10} placeholder="0.00" />
                                <FormHelperText className="error-o"></FormHelperText>
                              </FormControl>
                            </SectionCard>

                            <SectionCard icon={<InsertDriveFileOutlinedIcon />} title="INVOICE FILE" style={{ marginTop: "10px" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <FieldLabel>Upload Invoice Images or File</FieldLabel>
                                <Tooltip
                                  title="Please attach images separately as high resolution JPG/PNG/JPEG/GIF/PDF/DOC/DOCX"
                                  style={{
                                    position: "relative",
                                    top: 3,
                                    cursor: "pointer",
                                  }}
                                >
                                  <span>
                                    <HelpIcon
                                      fontSize="10px"
                                      style={{
                                        color: "#CEA05F",
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              </div>
                              <div className="ai-invoice-upload">
                                <FileUploadGroup
                                  page={"Edit"}
                                  imageDetails={this.state.fileArray}
                                  onFilesChange={this.handleSelectedFiles}
                                  deleteExistingData={this.deleteExistingInvoiceFile}
                                  disabled={
                                    this.state.userData &&
                                    this.state.userData.roleId === 10
                                  }
                                />
                              </div>
                            </SectionCard>

                            <SectionCard icon={<WarningAmberOutlinedIcon />} title="ADDITIONAL OPTIONS" style={{ marginTop: "10px" }}>
                              {this.state.userData &&
                                (this.state.userData?.dealerInventorySubscription !==
                                  "access_only" ||
                                  this.state.userData?.dealerInventorySubscription !==
                                  "no_subscription") ? (
                                <div className="ai-subgroup">
                                  <p className="ai-subgroup__title">Dealer Feed</p>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="checkedB1"
                                        className="ai-checkbox"
                                        value={this.state.dealerInv}
                                        checked={this.state.dealerInv}
                                        onChange={this.handleDealerInclude}
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                    }
                                    label="Include in the Dealer Feed"
                                  />
                                </div>
                              ) : null}
                              {this.state.isShopifyEnabled &&
                                this.state.isShopifyVerified &&
                                !this.state.initialShopifyConfig &&
                                !this.state.sold ? (
                                <div className="ai-subgroup">
                                  <p className="ai-subgroup__title">Shopify Configuration</p>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="checkedB1"
                                        className="ai-checkbox"
                                        value={this.state.shopifyConfig}
                                        checked={this.state.shopifyConfig}
                                        onChange={this.handleIncludeShopify}
                                      />
                                    }
                                    label="Include in shopify"
                                  />
                                </div>
                              ) : null}
                              {this.state.isQboVerified &&
                                !this.state.qboitemid &&
                                !this.state.initialQboConfig &&
                                !this.state.sold ? (
                                <div className="ai-subgroup">
                                  <p className="ai-subgroup__title">Quickbook Configuration</p>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="checkedB1"
                                        value={this.state.qboConfig}
                                        checked={this.state.qboConfig}
                                        className="ai-checkbox"
                                        onChange={this.handleIncludeQbo}
                                      />
                                    }
                                    label="Include in the Quickbook"
                                  />
                                </div>
                              ) : null}

                              {this.state.isEbayVerified &&
                                // !this.state.ebayitemid &&
                                !this.state.initialEbayConfig &&
                                !this.state.sold ? (
                                <div className="ai-subgroup">
                                  <p className="ai-subgroup__title">
                                    Ebay Configuration
                                  </p>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="checkedB1"
                                        value={this.state.ebayConfig}
                                        checked={this.state.ebayConfig}
                                        className="float-right"
                                        onChange={this.handleIncludeEbay}
                                      />
                                    }
                                    label="Include in the Ebay"
                                  />
                                </div>
                              ) : null}
                            </SectionCard>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Container>
              </form>
            ) : null}
            {this.state.loaded && this.state.type === "misc_product" && (
              <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                <SectionCard icon={<CloudUploadOutlinedIcon />} title="UPLOADS (IMAGES & VIDEOS)" style={{ marginTop: "8px" }}>
                  <Typography className="ai-uploads__hint">
                    Upload related images and videos of the watch.
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">IMAGES</Typography>
                      <this.UploadDropzone
                        inputId="ai-upload-images"
                        icon={<ImageOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="JPG, PNG, JPEG"
                        accept="image/*"
                        onFilesSelected={this.handleImagesSelected}
                      />
                      <this.ImagePreviewGrid files={this.state.imageFiles} onRemove={this.removeImageFile} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">VIDEOS</Typography>
                      <this.UploadDropzone
                        inputId="ai-upload-videos"
                        icon={<VideocamOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="MP4, MOV"
                        accept="video/*"
                        onFilesSelected={this.handleVideosSelected}
                      />
                      <this.VideoPreviewGrid files={this.state.videoFiles} onRemove={this.removeVideoFile} />
                    </Grid>
                  </Grid>
                </SectionCard>
              </Grid>
            )}
            {this.state.type === "misc_product" && (
              <div className="ai-bottombar">
                <Button className="ai-btn ai-btn--ghost" onClick={this.handleGoBack}>
                  Cancel
                </Button>
                <Button
                  className="ai-btn ai-btn--primary"
                  style={{
                    opacity: !this.state.isDirty ? 0.6 : 1,
                    cursor: !this.state.isDirty ? "not-allowed" : "pointer",
                    pointerEvents:
                      (this.state.disabled && !this.state.isDirty) || this.state.loading
                        ? "none"
                        : "auto",
                  }}
                  disabled={(this.state.disabled && !this.state.isDirty) || this.state.loading}
                  onClick={(e) => {
                    if (!this.state.isDirty || this.state.disabled || this.state.loading) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    this.submitForm(e);
                  }}
                >
                  {this.state.loading ? (
                    <>
                      <CircularProgress size={18} style={{ color: "#fff", marginRight: 8 }} />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </Button>
              </div>
            )}

            {/* Misc Watch */}
            {this.state.type === "misc_watch" ? (
              <form className="ai-update-form" id="add_inventory_form">
                <Container maxWidth="xl" className="ai-container">
                  <div>
                    <Typography
                      variant="h5"
                      component="p"
                      className="primary-text uppercase"
                    ></Typography>
                  </div>
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid>
                      <ArrowBackIcon
                        style={{
                          color: "action",
                          paddingRight: "15px",
                          marginTop: "5px",
                          fontSize: 40,
                          cursor: "pointer",
                        }}
                        onClick={this.backNavigation}
                      ></ArrowBackIcon>
                    </Grid>
                    <Grid>
                      <div onClick={this.handleClickBreadCrumbs}>
                        <Stack spacing={1}>
                          <Breadcrumbs
                            aria-label="breadcrumb"
                            separator={
                              <span className="sperator">›</span>
                            }
                          >
                            <Link
                              className="link"
                              style={{
                                fontSize: "14px",
                                color: "#CEA05F",
                                textDecoration:
                                  "underline !important",
                                backgroundColor: "white",
                              }}
                              onClick={this.backNavigation}
                            >
                              My Inventory
                            </Link>

                            <Link
                              className="link"
                              style={{
                                fontSize: "14px",
                                color: "#CEA05F",
                                textDecoration:
                                  "underline !important",
                                backgroundColor: "white",
                              }}
                              onClick={this.handleGoBack}
                            >
                              Inventory Details
                            </Link>
                            <Link
                              style={{
                                fontSize: "14px",
                                color: "#9e9e9e",
                                backgroundColor: "white",
                              }}
                              aria-current="page"
                            >
                              Edit Inventory Details
                            </Link>
                          </Breadcrumbs>
                        </Stack>
                      </div>
                    </Grid>
                  </Grid>
                  <div style={{ marginTop: "30px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6} lg={6}>
                        <div className="ai-col">
                          <SectionCard icon={<InfoOutlinedIcon />} title="BASIC INFORMATION">
                            <Grid container spacing={2} className="ai-misc-grid">
                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Model Name</FieldLabel>
                                  <Input disableUnderline placeholder="Enter Model Name" className="ai-input" id="component-simple" onChange={this.onchangeProductName} value={this.state.product_name ? this.state.product_name : ""} disabled={this.state.userData && this.state.userData.roleId === 10} />
                                  <FormHelperText className="error-o">
                                    {this.state.onProductNameErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Inventory Title</FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    onChange={this.onchangeProductTitle}
                                    placeholder="Inventory Title"
                                    value={this.state.product_title ?? ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  <FormHelperText className="error-o"></FormHelperText>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Brand</FieldLabel>
                                  <Input
                                    disableUnderline
                                    type="text"
                                    id="autocomplete1"
                                    placeholder="Brand"
                                    onChange={this.onchangeBrandName}
                                    value={this.state.brand_name ? this.state.brand_name : ""}
                                    className="ai-input"
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  {this.state.brandloading ? (
                                    <CircularProgress />
                                  ) : this.state.brandAutoCompleteData.data.length > 0 ? (
                                    <List
                                      className="searchlist MuiPaper-elevation1 inventrysearch"
                                      style={{
                                        listStyle: "none",
                                        height: "auto",
                                      }}
                                    >
                                      {this.state.brandAutoCompleteData.data.map(
                                        (item, idx) => (
                                          <div>
                                            <ListItem
                                              className={
                                                cursor === idx
                                                  ? "active"
                                                  : ""
                                              }
                                              key={idx}
                                              onClick={() =>
                                                this.onchangebrand(item)
                                              }
                                            >
                                              <ListItemText
                                                primary={item.brandname}
                                                style={{
                                                  marginTop: "10px",
                                                  marginLeft: "50px",
                                                }}
                                              />
                                            </ListItem>
                                            <Divider
                                              variant="inset"
                                              component="li"
                                              style={{ margin: "5px" }}
                                            />
                                          </div>
                                        ),
                                      )}
                                    </List>
                                  ) : null}
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Model Number</FieldLabel>
                                  <Input disableUnderline className="ai-input" id="component-simple" onChange={this.onchangeProductModelNumber} value={this.state.model_number ? this.state.model_number : ""} disabled={this.state.userData && this.state.userData.roleId === 10} placeholder="Enter Model Number"></Input>
                                  <FormHelperText className="error-o">
                                    {this.state.onModelNumberErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Case Material</FieldLabel>
                                  <Input
                                    disableUnderline
                                    type="text"
                                    id="autocomplete1"
                                    placeholder="Case Material"
                                    onChange={this.onchangeCaseMaterial}
                                    value={this.state.case_material ? this.state.case_material : ""}
                                    className="ai-input"
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  {this.state.caseMaterialloading ? (
                                    <CircularProgress />
                                  ) : this.state.caseMaterialAutoCompleteData.data.length > 0 ? (
                                    <List
                                      className="searchlist MuiPaper-elevation1 inventrysearch"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.caseMaterialAutoCompleteData.data.map(
                                        (item, idx) => (
                                          <div key={idx}>
                                            <ListItem
                                              className={
                                                cursor === idx
                                                  ? "active"
                                                  : ""
                                              }
                                              onClick={() =>
                                                this.onchangecasematerial(
                                                  item,
                                                )
                                              }
                                            >
                                              <ListItemText
                                                primary={item.casematerial}
                                                style={{
                                                  marginTop: "10px",
                                                  marginLeft: "50px",
                                                }}
                                              />
                                            </ListItem>
                                            <Divider
                                              variant="inset"
                                              component="li"
                                              style={{ margin: "5px" }}
                                            />
                                          </div>
                                        ),
                                      )}
                                    </List>
                                  ) : null}
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Case Size</FieldLabel>
                                  <Input disableUnderline className="ai-input" id="component-simple" onChange={this.onchangeCaseSize} value={this.state.case_size ? this.state.case_size : ""} disabled={this.state.userData && this.state.userData.roleId === 10} placeholder="Please Enter Case Size" />
                                  <FormHelperText className="error-o">
                                    {this.state.onCaseSizeErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Dial Color</FieldLabel>
                                  <Input disableUnderline placeholder="Enter Dial Color" className="ai-input" id="component-simple" onChange={this.onchangeDialColor} value={this.state.dial_color ? this.state.dial_color : ""} disabled={this.state.userData && this.state.userData.roleId === 10} />
                                  <FormHelperText className="error-o">
                                    {this.state.onDialColorErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Band Material</FieldLabel>
                                  <Input
                                    disableUnderline
                                    type="text"
                                    id="autocomplete1"
                                    placeholder="Band Material"
                                    onChange={this.onchangeBandMaterial}
                                    value={this.state.band_material ? this.state.band_material : ""}
                                    className="ai-input"
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  {this.state.bandMaterialloading ? (
                                    <CircularProgress />
                                  ) : this.state.bandMaterialAutoCompleteData.data.length > 0 ? (
                                    <List
                                      className="searchlist MuiPaper-elevation1 inventrysearch"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.bandMaterialAutoCompleteData.data.map(
                                        (item, idx) => (
                                          <div key={idx}>
                                            <ListItem
                                              className={
                                                cursor === idx
                                                  ? "active"
                                                  : ""
                                              }
                                              onClick={() =>
                                                this.onchangebandmaterial(
                                                  item,
                                                )
                                              }
                                            >
                                              <ListItemText
                                                primary={item.bandmaterial}
                                                style={{
                                                  marginTop: "10px",
                                                  marginLeft: "50px",
                                                }}
                                              />
                                            </ListItem>
                                            <Divider
                                              variant="inset"
                                              component="li"
                                              style={{ margin: "5px" }}
                                            />
                                          </div>
                                        ),
                                      )}
                                    </List>
                                  ) : null}
                                </FormControl>
                              </Grid>
                            </Grid>
                          </SectionCard>

                          <SectionCard icon={<TuneOutlinedIcon />} title="PURCHASE DETAILS" style={{ marginTop: "10px" }}>
                            {(isActionAllowed(
                              this.state.viewData,
                              "purchase_from",
                            ) ||
                              isActionAllowed(
                                this.state.viewData,
                                "purchase_date",
                              )) && (
                                <Grid container spacing={2}>
                                  {isActionAllowed(
                                    this.state.viewData,
                                    "purchase_from",
                                  ) && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth className="ai-field">
                                          <FieldLabel>Purchased From</FieldLabel>
                                          <div className="ai-input-icon-wrap">
                                            <AntdInput
                                              id="PurchasedFrom"
                                              type="text"
                                              autoComplete="off"
                                              className="ai-antd-input"
                                              placeholder="Search dealer or source"
                                              ref={this.purchasedFromRef}
                                              value={this.state.PurchasedFrom}
                                              onChange={(e) =>
                                                this.onchangeContactSuggestion(
                                                  e,
                                                  "PurchasedFrom",
                                                  ["supplier", "memo_supplier"],
                                                )
                                              }
                                              bordered={false}
                                              disabled={this.state.isDisabled}
                                            />
                                            <span className="ai-input-icon-wrap__icon">
                                              {!this.state.PurchasedFrom ? (
                                                <SearchIcon
                                                  style={{ cursor: "pointer" }}
                                                  fontSize="small"
                                                />
                                              ) : this.state.fieldLoader ? (
                                                <CircularProgress
                                                  style={{ width: 18, height: 18 }}
                                                />
                                              ) : (
                                                <ClearIcon
                                                  id="clearBtn"
                                                  onClick={() =>
                                                    this.clearContactSuggestion(
                                                      "PurchasedFrom",
                                                    )
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                  fontSize="small"
                                                />
                                              )}
                                            </span>
                                          </div>
                                        </FormControl>
                                        {this.state.purchasedFromArray &&
                                          this.state.purchasedFromArray.length >
                                          0 &&
                                          this.state.PurchasedFrom?.length > 0 ? (
                                          <div>
                                            <AntdPopover
                                              visible={
                                                this.state
                                                  .isPopOverPurchasedFrom
                                              }
                                              content={
                                                <div
                                                  style={{
                                                    height: "200px",
                                                    overflow: "auto",
                                                  }}
                                                >
                                                  {this.state.dataset
                                                    ?.slice(0, 15)
                                                    .map((value, key) => {
                                                      return value.map(
                                                        (el, index) => {
                                                          if (index < 1) {
                                                            const displayName = `${el?.firstname ??
                                                              ""
                                                              } ${el?.lastname ?? ""}`;
                                                            return (
                                                              <>
                                                                {/* <Accordion>
                                                          <AccordionSummary
                                                            aria-controls="panel1d-content"
                                                            id="panel1d-header"
                                                          >
                                                            <Typography
                                                              style={{
                                                                padding: 10,
                                                                width: 300,
                                                                cursor: "pointer",
                                                              }}
                                                            >
                                                              {(el?.businessname ||
                                                                displayName) ??
                                                                ""}
                                                            </Typography>
                                                          </AccordionSummary> */}

                                                                {this.state.purchasedFromArray
                                                                  ?.filter(
                                                                    (v) =>
                                                                      v.email ==
                                                                      el.email,
                                                                  )
                                                                  .map(
                                                                    (
                                                                      el,
                                                                      index,
                                                                    ) => {
                                                                      return (
                                                                        <AccordionDetails
                                                                          key={
                                                                            index
                                                                          }
                                                                        >
                                                                          <Typography
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                            }}
                                                                            onClick={() =>
                                                                              this.handleContactSelection(
                                                                                el,
                                                                                "PurchasedFrom",
                                                                              )
                                                                            }
                                                                          >
                                                                            {this.handleContact(
                                                                              el,
                                                                            )}
                                                                          </Typography>
                                                                        </AccordionDetails>
                                                                      );
                                                                    },
                                                                  )}
                                                                {/* </Accordion> */}
                                                              </>
                                                            );
                                                          }
                                                        },
                                                      );
                                                    })}
                                                </div>
                                              }
                                              trigger="click"
                                              placement="bottomRight"
                                              // placement="bottomLeft"
                                              onVisibleChange={
                                                this.handleVisibleChange
                                              }
                                            >
                                              <div
                                                style={{
                                                  width: 0,
                                                  height: 0,
                                                  position: "absolute",
                                                }}
                                              />
                                            </AntdPopover>
                                          </div>
                                        ) : (
                                          // this.state.paymentDetailsText === "Trade" &&
                                          this.state.PurchasedFrom.length > 2 &&
                                          !this.state.purchasedFromArray
                                            .length &&
                                          !this.state.fieldLoader &&
                                          !this.state.purchaseFromContactId && (
                                            <AntdPopover
                                              // id={column.id}
                                              visible
                                              content={
                                                <div
                                                  style={{ overflow: "auto" }}
                                                >
                                                  <a
                                                    className="dataItem"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                      // this.setState({
                                                      //   PurchasedFrom: "",
                                                      // });
                                                      const typeData = [
                                                        {
                                                          id: "supplier",
                                                          value: "Supplier",
                                                        },
                                                        {
                                                          id: "memo_supplier",
                                                          value:
                                                            "Memo Supplier",
                                                        },
                                                      ];
                                                      const encodedTypeData =
                                                        btoa(
                                                          JSON.stringify(
                                                            typeData,
                                                          ),
                                                        );
                                                      window.open(
                                                        `/contactmanagement/add?type=${encodedTypeData}`,
                                                        "_blank",
                                                      );
                                                      // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                                    }}
                                                    style={{
                                                      cursor: "pointer",
                                                      textDecoration:
                                                        "underline",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Click here to Create New
                                                    Contact
                                                  </a>
                                                </div>
                                              }
                                              trigger="click"
                                              placement="bottom"
                                            // overlayStyle={{ marginTop: "5px" }}
                                            >
                                              {/* <div
                                          style={{
                                            width: 0,
                                            height: 0,
                                            position: "absolute",
                                          }}
                                        /> */}
                                            </AntdPopover>
                                          )
                                        )}
                                      </Grid>
                                    )}

                                  {isActionAllowed(
                                    this.state.viewData,
                                    "purchase_date",
                                  ) && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl
                                          fullWidth className="ai-field ai-datepicker"
                                        >
                                          <FieldLabel>Purchased Date</FieldLabel>
                                          <MuiPickersUtilsProvider
                                            utils={DateFnsUtils}
                                          >
                                            <KeyboardDatePicker
                                              // className="color-BCBCBC"
                                              margin="normal"
                                              id="date-picker-dialog"
                                              format="MM/dd/yyyy"
                                              disableFuture={true}
                                              value={
                                                this.state.purchaseDate || null
                                              }
                                              onChange={this.handlePurchaseDate}
                                              isClearable
                                              KeyboardButtonProps={{
                                                "aria-label": "change date",
                                              }}
                                              placeholder="Purchased Date - MM/DD/YYYY"
                                              onPaste={(event) =>
                                                event.preventDefault()
                                              }
                                              helperText={
                                                this.state.error["PD"]
                                                  ? "Invalid date"
                                                  : ""
                                              }
                                              error={this.state.error["PD"]}
                                            />
                                          </MuiPickersUtilsProvider>
                                          <FormHelperText className="error-o">
                                            {this.state.onpurchaseDateErrorText}
                                          </FormHelperText>
                                        </FormControl>
                                      </Grid>
                                    )}
                                </Grid>
                              )}

                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Purchase Payment Status</FieldLabel>
                                  <Select
                                    disableUnderline
                                    className="ai-select"
                                    value={this.state.paidStatus ? "paid" : "unpaid"}
                                    onChange={(e) =>
                                      this.handlePaidStatusCheck({
                                        target: { checked: e.target.value === "paid" },
                                      })
                                    }
                                    disabled={
                                      this.state.userData &&
                                      this.state.userData.roleId === 10
                                    }
                                    renderValue={(val) => (
                                      <span className="ai-status-pill">
                                        <span className="ai-status-pill__dot" />
                                        {val === "paid" ? "Paid" : "Unpaid"}
                                      </span>
                                    )}
                                  >
                                    <MenuItem value="paid">Paid</MenuItem>
                                    <MenuItem value="unpaid">Unpaid</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field ai-datepicker">
                                  {this.state.paidStatus ? (
                                    <FormControl fullWidth className="ai-field ai-datepicker">
                                      <FieldLabel>Purchase Payment Date</FieldLabel>

                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                          margin="normal"
                                          id="date-picker-purchase"
                                          format="MM/dd/yyyy"
                                          disableFuture
                                          value={this.state.paymentDate || null}
                                          onChange={this.handleDateChange}
                                          KeyboardButtonProps={{
                                            "aria-label": "change purchase payment date",
                                          }}
                                          placeholder="Purchase Payment Date - MM/DD/YYYY"
                                          onPaste={(event) => event.preventDefault()}
                                          helperText={this.state.error["PPD"] ? "Invalid date" : ""}
                                          error={Boolean(this.state.error["PPD"])}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      </MuiPickersUtilsProvider>

                                      <FormHelperText className="error-o">
                                        {this.state.onpurchaseDateErrorText}
                                      </FormHelperText>
                                    </FormControl>
                                  ) : (
                                    <FormControl fullWidth className="ai-field ai-datepicker">
                                      <FieldLabel>Purchase Payment Due Date</FieldLabel>

                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                          margin="normal"
                                          id="date-picker-purchase-due"
                                          format="MM/dd/yyyy"
                                          value={this.state.purchaseDueDate || null}
                                          onChange={this.handleDueDateChange}
                                          KeyboardButtonProps={{
                                            "aria-label": "change purchase payment due date",
                                          }}
                                          placeholder="Purchase Payment Due Date - MM/DD/YYYY"
                                          onPaste={(event) => event.preventDefault()}
                                          helperText={this.state.error["PPDD"] ? "Invalid date" : ""}
                                          error={Boolean(this.state.error["PPDD"])}
                                          disabled={
                                            this.state.userData &&
                                            this.state.userData.roleId === 10
                                          }
                                        />
                                      </MuiPickersUtilsProvider>

                                      <FormHelperText className="error-o">
                                        {this.state.onpurchaseDueDateErrorText}
                                      </FormHelperText>
                                    </FormControl>
                                  )}
                                </FormControl>
                              </Grid>
                            </Grid>

                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                Purchase Payment Details
                              </FieldLabel>
                              <Input
                                disableUnderline
                                className="ai-input"
                                id="component-simple" multiline
                                onChange={this.onchangePaymentDetails}
                                value={this.state.paymentDetailsText ? this.state.paymentDetailsText : ""}
                                disabled={this.state.userData && this.state.userData.roleId === 10}
                                placeholder="Enter payment details"
                              />
                              <FormHelperText className="error-o">
                                {this.state.onPaymentDetailsErrorText}
                              </FormHelperText>
                            </FormControl>

                            {(isActionAllowed(
                              this.state.viewData,
                              "purchase_price",
                            ) ||
                              isActionAllowed(
                                this.state.viewData,
                                "purchase_expense",
                              )) && (
                                <Grid container spacing={2}>
                                  {isActionAllowed(
                                    this.state.viewData,
                                    "purchase_price",
                                  ) && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth className="ai-field">
                                          <FieldLabel>
                                            Purchased Price ($){" "}
                                          </FieldLabel>
                                          <Input
                                            disableUnderline
                                            className="ai-input"
                                            id="component-simple"
                                            onChange={this.onchangePurchasedPrice}
                                            value={this.state.PurchasedPrice ? this.state.PurchasedPrice : ""}
                                            placeholder="0.00"
                                          />
                                          <FormHelperText className="error-o">
                                            {this.state.onPurchasedPriceErrorText}
                                          </FormHelperText>
                                        </FormControl>
                                      </Grid>
                                    )}

                                  {isActionAllowed(
                                    this.state.viewData,
                                    "purchase_expense",
                                  ) && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth className="ai-field">
                                          <FieldLabel>
                                            Purchase Expense ($)
                                          </FieldLabel>
                                          <Input
                                            disableUnderline
                                            className="ai-input"
                                            id="component-simple"
                                            onChange={this.onchangePurchaseExpense}
                                            value={this.state.purchase_expense}
                                            placeholder="0.00"
                                          />
                                          <FormHelperText className="error-o"></FormHelperText>
                                        </FormControl>
                                      </Grid>
                                    )}
                                </Grid>
                              )}

                            {isActionAllowed(
                              this.state.viewData,
                              "purchase_expense",
                            ) && (
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    {" "}
                                    Purchase Expense Note
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    onChange={this.onchangePurchaseExpenseNote}
                                    value={this.state.purchase_expense_note ? this.state.purchase_expense_note : ""}
                                    placeholder="Enter expense note"
                                  />
                                  <FormHelperText className="error-o"></FormHelperText>
                                </FormControl>
                              )}

                            {isActionAllowed(
                              this.state.viewData,
                              "total_cost",
                            ) && (
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>Total Cost ($)</FieldLabel>
                                      <Input
                                        disableUnderline
                                        className="ai-input"
                                        id="component-simple"
                                        disabled value={this.state.total_cost}
                                        placeholder="0.00"
                                      />
                                      <FormHelperText className="error-o"></FormHelperText>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                              )}
                          </SectionCard>

                          <SectionCard icon={<TuneOutlinedIcon />} title="INVENTORY DETAILS" style={{ marginTop: "10px" }}>
                            {this.state.type === "misc_watch" && (
                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>Serial Number</FieldLabel>
                                <Input
                                  disableUnderline
                                  className="ai-input"
                                  id="component-simple"
                                  onChange={this.onchangeSerialNumber}
                                  value={this.state.SerialNumber ? this.state.SerialNumber : ""}
                                  disabled={this.state.disabled || (this.state.userData && this.state.userData.roleId === 10)}
                                  placeholder="Enter serial number"
                                />
                                <FormHelperText className="error-o">
                                  {this.state.onSerialNumberErrorText}
                                </FormHelperText>
                              </FormControl>
                            )}

                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Inventory Type</FieldLabel>

                                  <Select
                                    className="ai-select"
                                    id="inventory-type"
                                    value={this.state.InventoryType === "null" ? "" : this.state.InventoryType}
                                    onChange={(e) =>
                                      this.setState({
                                        InventoryType: e.target.value,
                                        MemoDetails: "",
                                        PartnershipDetails: "",
                                        memoContactId: null,
                                        partnerContactId: null,
                                        isDirty: true,
                                      })
                                    }
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    displayEmpty
                                    renderValue={(selected) => {
                                      if (!selected) {
                                        return <span style={{ color: "#999" }}>Select Type</span>;
                                      }
                                      const typeMap = {
                                        "1": "Regular Inventory",
                                        "2": "Memo Inventory",
                                        "3": "Partnership Inventory",
                                        "5": "Consignment Inventory",
                                        "4": "Trade Inventory",
                                      };
                                      return typeMap[selected] || selected;
                                    }}
                                  >
                                    <MenuItem value="">
                                      <em>Select Type</em>
                                    </MenuItem>
                                    <MenuItem value="1">Regular Inventory</MenuItem>
                                    <MenuItem value="2">Memo Inventory</MenuItem>
                                    <MenuItem value="3">Partnership Inventory</MenuItem>
                                    <MenuItem value="5">Consignment Inventory</MenuItem>
                                    <MenuItem value="4" style={{ display: "none" }}>
                                      Trade Inventory
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>

                              {this.state.InventoryType === "2" && (
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>Memo Contact</FieldLabel>
                                    <div className="ai-input-icon-wrap">
                                      <AntdInput
                                        id="MemoDetails"
                                        type="text"
                                        ref={this.memoDetailsRef}
                                        autoComplete="off"
                                        className="ai-antd-input"
                                        value={this.state.MemoDetails}
                                        onChange={(e) =>
                                          this.onchangeContactSuggestion(
                                            e,
                                            "MemoDetails",
                                            ["memo_supplier"],
                                          )
                                        }
                                        bordered={false}
                                        placeholder="Search Memo Contact Name / Business Name"
                                        disabled={
                                          this.state.userData &&
                                          this.state.userData.roleId === 10
                                        }
                                      />
                                      {this.state.userData?.roleId !==
                                        10 && (
                                          <span className="ai-input-icon-wrap__icon">
                                            {!this.state.MemoDetails ? (
                                              <SearchIcon
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              />
                                            ) : (
                                              <>
                                                {this.state
                                                  .fieldLoader ? (
                                                  <CircularProgress
                                                    style={{
                                                      width: "25px",
                                                      height: "25px",
                                                    }}
                                                  />
                                                ) : (
                                                  <ClearIcon
                                                    id="clearBtn"
                                                    onClick={() =>
                                                      this.clearContactSuggestion(
                                                        "MemoDetails",
                                                      )
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                )}
                                              </>
                                            )}
                                          </span>
                                        )}
                                    </div>
                                  </FormControl>
                                  {this.state.memoDetailsArray &&
                                    this.state.memoDetailsArray.length >
                                    0 &&
                                    this.state.MemoDetails?.length > 0 ? (
                                    <div>
                                      <AntdPopover
                                        visible={
                                          this.state.isPopOverMemoDetails
                                        }
                                        content={
                                          <div
                                            style={{
                                              height: "200px",
                                              overflow: "auto",
                                            }}
                                          >
                                            {this.state.dataset
                                              ?.slice(0, 15)
                                              .map((value, key) => {
                                                return value.map(
                                                  (el, index) => {
                                                    if (index < 1) {
                                                      const displayName = `${el?.firstname ??
                                                        ""
                                                        } ${el?.lastname ?? ""}`;
                                                      return (
                                                        <>
                                                          {/* <Accordion>
                                                                <AccordionSummary
                                                                  aria-controls="panel1d-content"
                                                                  id="panel1d-header"
                                                                >
                                                                  <Typography
                                                                    style={{
                                                                      padding: 10,
                                                                      width: 300,
                                                                      cursor: "pointer",
                                                                    }}
                                                                  >
                                                                    {(el?.businessname ||
                                                                      displayName) ??
                                                                      ""}
                                                                  </Typography>
                                                                </AccordionSummary> */}

                                                          {this.state.memoDetailsArray
                                                            ?.filter(
                                                              (v) =>
                                                                v.email ==
                                                                el.email,
                                                            )
                                                            .map(
                                                              (
                                                                el,
                                                                index,
                                                              ) => {
                                                                return (
                                                                  <AccordionDetails
                                                                    key={
                                                                      index
                                                                    }
                                                                  >
                                                                    <Typography
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.handleContactSelection(
                                                                          el,
                                                                          "MemoDetails",
                                                                        )
                                                                      }
                                                                    >
                                                                      {this.handleContact(
                                                                        el,
                                                                      )}
                                                                    </Typography>
                                                                  </AccordionDetails>
                                                                );
                                                              },
                                                            )}
                                                          {/* </Accordion> */}
                                                        </>
                                                      );
                                                    }
                                                  },
                                                );
                                              })}
                                          </div>
                                        }
                                        trigger="click"
                                        placement="bottomRight"
                                        // placement="bottomLeft"
                                        onVisibleChange={
                                          this.handleVisibleChange
                                        }
                                      >
                                        <div
                                          style={{
                                            width: 0,
                                            height: 0,
                                            position: "absolute",
                                          }}
                                        />
                                      </AntdPopover>
                                    </div>
                                  ) : (
                                    this.state.MemoDetails?.length > 2 &&
                                    !this.state.memoDetailsArray.length &&
                                    !this.state.fieldLoader &&
                                    !this.state.memoContactId && (
                                      <AntdPopover
                                        // id={column.id}
                                        visible={
                                          this.state.MemoDetails?.length >
                                          2 &&
                                          !this.state.memoDetailsArray
                                            .length &&
                                          !this.state.fieldLoader &&
                                          !this.state.memoContactId
                                        }
                                        content={
                                          <div
                                            style={{ overflow: "auto" }}
                                          >
                                            <a
                                              className="dataItem"
                                              onClick={() => {
                                                // this.setState({
                                                //   MemoDetails: "",
                                                // });
                                                const typeData = [
                                                  {
                                                    id: "memo_supplier",
                                                    value:
                                                      "Memo Supplier",
                                                  },
                                                ];
                                                const encodedTypeData =
                                                  btoa(
                                                    JSON.stringify(
                                                      typeData,
                                                    ),
                                                  );
                                                window.open(
                                                  `/contactmanagement/add?type=${encodedTypeData}`,
                                                  "_blank",
                                                );
                                                // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                textDecoration:
                                                  "underline",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Click here to Create New
                                              Contact
                                            </a>
                                          </div>
                                        }
                                        trigger="click"
                                        placement="bottom"
                                      // overlayStyle={{ marginTop: "5px" }}
                                      >
                                        {/* <div
                                              style={{
                                                width: 0,
                                                height: 0,
                                                position: "absolute",
                                              }}
                                            /> */}
                                      </AntdPopover>
                                    )
                                  )}
                                </Grid>
                              )}

                              {this.state.InventoryType === "3" && (
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>Partnership Contact</FieldLabel>
                                    <AntdInput
                                      id="PartnershipDetails"
                                      type="text"
                                      autoComplete="off"
                                      ref={this.partnershipDetailsRef}
                                      className="ai-antd-input"
                                      value={
                                        this.state.PartnershipDetails
                                      }
                                      onChange={(e) =>
                                        this.onchangeContactSuggestion(
                                          e,
                                          "PartnershipDetails",
                                          ["partner"],
                                        )
                                      }
                                      bordered={false}
                                      placeholder="Search Partnership Contact Name / Business Name"
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                    {this.state.userData?.roleId !==
                                      10 && (
                                        <span className="ai-input-icon-wrap__icon">
                                          {!this.state
                                            .PartnershipDetails ? (
                                            <SearchIcon
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <>
                                              {this.state
                                                .fieldLoader ? (
                                                <CircularProgress
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                />
                                              ) : (
                                                <ClearIcon
                                                  id="clearBtn"
                                                  onClick={() =>
                                                    this.clearContactSuggestion(
                                                      "PartnershipDetails",
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              )}
                                            </>
                                          )}
                                        </span>
                                      )}
                                  </FormControl>
                                  {this.state.partnershipDetailsArray &&
                                    this.state.partnershipDetailsArray
                                      .length > 0 &&
                                    this.state.PartnershipDetails?.length >
                                    0 ? (
                                    <div>
                                      <AntdPopover
                                        visible={
                                          this.state
                                            .isPopOverPartnershipDetails
                                        }
                                        content={
                                          <div
                                            style={{
                                              height: "200px",
                                              overflow: "auto",
                                            }}
                                          >
                                            {this.state.dataset
                                              ?.slice(0, 15)
                                              .map((value, key) => {
                                                return value.map(
                                                  (el, index) => {
                                                    if (index < 1) {
                                                      const displayName = `${el?.firstname ??
                                                        ""
                                                        } ${el?.lastname ?? ""}`;
                                                      return (
                                                        <>
                                                          {/* <Accordion>
                                                                <AccordionSummary
                                                                  aria-controls="panel1d-content"
                                                                  id="panel1d-header"
                                                                >
                                                                  <Typography
                                                                    style={{
                                                                      padding: 10,
                                                                      width: 300,
                                                                      cursor: "pointer",
                                                                    }}
                                                                  >
                                                                    {(el?.businessname ||
                                                                      displayName) ??
                                                                      ""}
                                                                  </Typography>
                                                                </AccordionSummary> */}

                                                          {this.state.partnershipDetailsArray
                                                            ?.filter(
                                                              (v) =>
                                                                v.email ==
                                                                el.email,
                                                            )
                                                            .map(
                                                              (
                                                                el,
                                                                index,
                                                              ) => {
                                                                return (
                                                                  <AccordionDetails
                                                                    key={
                                                                      index
                                                                    }
                                                                  >
                                                                    <Typography
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.handleContactSelection(
                                                                          el,
                                                                          "PartnershipDetails",
                                                                        )
                                                                      }
                                                                    >
                                                                      {this.handleContact(
                                                                        el,
                                                                      )}
                                                                    </Typography>
                                                                  </AccordionDetails>
                                                                );
                                                              },
                                                            )}
                                                          {/* </Accordion> */}
                                                        </>
                                                      );
                                                    }
                                                  },
                                                );
                                              })}
                                          </div>
                                        }
                                        trigger="click"
                                        placement="bottomRight"
                                        // placement="bottomLeft"
                                        onVisibleChange={
                                          this.handleVisibleChange
                                        }
                                      >
                                        <div
                                          style={{
                                            width: 0,
                                            height: 0,
                                            position: "absolute",
                                          }}
                                        />
                                      </AntdPopover>
                                    </div>
                                  ) : (
                                    this.state.PartnershipDetails.length >
                                    2 &&
                                    !this.state.partnershipDetailsArray
                                      .length &&
                                    !this.state.fieldLoader &&
                                    !this.state.partnerContactId && (
                                      <AntdPopover
                                        // id={column.id}
                                        visible={
                                          this.state.PartnershipDetails
                                            ?.length > 2 &&
                                          !this.state
                                            .partnershipDetailsArray
                                            .length &&
                                          !this.state.fieldLoader &&
                                          !this.state.partnerContactId
                                        }
                                        content={
                                          <div
                                            style={{ overflow: "auto" }}
                                          >
                                            <a
                                              className="dataItem"
                                              href="javascript:void(0)"
                                              onClick={() => {
                                                // this.setState({
                                                //   PartnershipDetails: "",
                                                // });
                                                const typeData = [
                                                  {
                                                    id: "partner",
                                                    value: "Partner",
                                                  },
                                                ];
                                                const encodedTypeData =
                                                  btoa(
                                                    JSON.stringify(
                                                      typeData,
                                                    ),
                                                  );
                                                window.open(
                                                  `/contactmanagement/add?type=${encodedTypeData}`,
                                                  "_blank",
                                                );
                                                // window.open(`${window.location.origin}/contactmanagement/add`, "_blank");
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                textDecoration:
                                                  "underline",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Click here to Create New
                                              Contact
                                            </a>
                                          </div>
                                        }
                                        trigger="click"
                                        placement="bottom"
                                      // overlayStyle={{ marginTop: "5px" }}
                                      >
                                        {/* <div
                                              style={{
                                                width: 0,
                                                height: 0,
                                                position: "absolute",
                                              }}
                                            /> */}
                                      </AntdPopover>
                                    )
                                  )}
                                </Grid>
                              )}

                              {(this.state.InventoryType === "2" ||
                                this.state.InventoryType === "3") && (
                                  <Grid item xs={12} sm={6}>
                                    {/* <FormControl className="form-width-70 margin-t-b-20 margin-p-b-20">
                                            <InputLabel
                                              htmlFor="component-simple"
                                              style={{ color: "#424242" }}
                                            >
                                              {this.state.InventoryType === "2"
                                                ? "Memo Details"
                                                : "Partnership Details"}
                                            </InputLabel>
                                            <Input
                                              id="component-simple"
                                              value={this.state.InventoryType === "2" ? this.state.MemoDetails : this.state.PartnershipDetails}
                                              onChange={(e) => {
                                                this.setState({
                                                  MemoDetails:
                                                    this.state.InventoryType ===
                                                      "2"
                                                      ? e.target.value
                                                      : "",
                                                  PartnershipDetails:
                                                    this.state.InventoryType ===
                                                      "3"
                                                      ? e.target.value
                                                      : "",
                                                });
                                              }}
                                            />
                                          </FormControl> */}
                                    <FormControl fullWidth className="ai-field">
                                      <FieldLabel>
                                        {this.state.InventoryType === "2" ? "MEMO NUMBER" : "PARTNERSHIP NUMBER"}
                                      </FieldLabel>
                                      <Input
                                        disableUnderline
                                        className="ai-input"
                                        id="component-simple"
                                        placeholder={
                                          this.state.inventory_type === "2"
                                            ? "Enter Memo Number"
                                            : "Enter Partnership Number"
                                        }
                                        value={this.state.InventoryType === "2" ? this.state.updatememo : this.state.updatepartnershipnumber}
                                        onChange={e => {
                                          this.setState({
                                            updatememo: this.state.InventoryType === "2" ? e.target.value : "",
                                            updatepartnershipnumber: this.state.InventoryType === "3" ? e.target.value : ""
                                          });
                                        }} disabled={this.state.userData && this.state.userData.roleId === 10} />
                                    </FormControl>
                                  </Grid>
                                )}

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>
                                    Inventory Status
                                  </FieldLabel>

                                  <Select
                                    className="ai-select"
                                    id="component-simple"
                                    defaultValue={this.state.InventoryStatus}
                                    value={this.state.InventoryStatus}
                                    onChange={e => this.setState({
                                      InventoryStatus: e.target.value,
                                      isDirty: true
                                    })}
                                    disabled={this.state.memoId && this.state.InventoryStatus == 3 && this.state.sold !== 1 ? true : false}
                                    displayEmpty
                                  // renderValue={(selected) => {
                                  //   if (!selected) {
                                  //     return <span style={{ color: "#999" }}>Select Status</span>;
                                  //   }
                                  //   return selected;
                                  // }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Status
                                    </MenuItem>
                                    <MenuItem value="2">Incoming</MenuItem>
                                    <MenuItem value="6">
                                      Needs Service / Polish
                                    </MenuItem>
                                    <MenuItem value="7">
                                      At Service
                                    </MenuItem>
                                    <MenuItem value="11">
                                      Intake Complete
                                    </MenuItem>
                                    <MenuItem value="13">Need to Post</MenuItem>
                                    <MenuItem value="12">Invoiced</MenuItem>
                                    <MenuItem value="1">Inhand</MenuItem>
                                    <MenuItem value="3">
                                      Out on Memo
                                    </MenuItem>
                                    <MenuItem value="4">
                                      On Hold / Reserved
                                    </MenuItem>
                                    <MenuItem value="8">
                                      Need to Ship
                                    </MenuItem>
                                    <MenuItem value="9">
                                      Shipped waiting on payment
                                    </MenuItem>
                                    <MenuItem value="10">
                                      Sold & Cashed Out
                                    </MenuItem>
                                    <MenuItem value="5">
                                      Available to Order
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field ai-field--dropdown">
                                  <FieldLabel>Inventory Location</FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    placeholder="Enter Inventory Location"
                                    id="autocomplete1"
                                    onChange={this.locationAutoComplete}
                                    onFocus={this.handleLocationFocus}
                                    onBlur={this.handleLocationBlur}
                                    value={this.state.locationSearch}
                                    endAdornment={
                                      this.state.locationloading ? (
                                        <InputAdornment position="end">
                                          <CircularProgress size={16} />
                                        </InputAdornment>
                                      ) : null
                                    }
                                  />
                                  {!this.state.locationloading && this.state.locationAutoCompleteData?.data?.length > 0 ? (
                                    <List
                                      className="searchlist MuiPaper-elevation1 inventrysearch ai-location-results"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.locationAutoCompleteData.data.map(
                                        (item, idx) => (
                                          <div key={idx}>
                                            <ListItem
                                              className={
                                                this.state.cursor === idx ? "active" : ""
                                              }
                                              style={{ cursor: "pointer" }}
                                              onMouseDown={() =>
                                                this.onchangeLocation(item)
                                              }
                                            >
                                              <ListItemText
                                                primary={item.locations}
                                                style={{
                                                  marginTop: "10px",
                                                  marginLeft: "50px",
                                                }}
                                              />
                                            </ListItem>

                                            <Divider
                                              variant="inset"
                                              component="li"
                                              style={{ margin: "5px" }}
                                            />
                                          </div>
                                        )
                                      )}
                                    </List>
                                  ) : null}
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Band Size</FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    placeholder="Enter Band Size"
                                    onChange={this.onchangeBandSize}
                                    value={this.state.BandSize ? this.state.BandSize : ""}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                  />
                                  <FormHelperText className="error-o">
                                    {this.state.onBandSizeErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>
                            </Grid>

                            <div className="ai-condition" id="conditionField">
                              <FieldLabel>Condition</FieldLabel>
                              <ConditionSelector
                                marks={followersMarks1()}
                                value={this.state.Condition}
                                onChange={this.onchangeCondition}
                              />
                              <div className="ai-condition-hint">
                                <InfoOutlinedIcon style={{ fontSize: 14 }} />
                                Select the condition that best describes your inventory.
                              </div>
                              <FormHelperText className="error-o">
                                {this.state.onConditionErrorText}
                              </FormHelperText>
                            </div>
                          </SectionCard>
                        </div>
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <div className="ai-col">
                          <SectionCard icon={<DescriptionOutlinedIcon />} title="SPECIFICATIONS & PRICING">
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                Number Of Links / Screws
                              </FieldLabel>
                              <Input
                                disableUnderline
                                className="ai-input"
                                id="component-simple"
                                onChange={this.onchangeNumberOfLinks}
                                value={this.state.NumberOfLinks ? this.state.NumberOfLinks : ""}
                                disabled={this.state.userData && this.state.userData.roleId === 10}
                                placeholder="Enter number"
                              />
                              <FormHelperText className="error-o">
                                {this.state.onNumberOfLinksErrorText}
                              </FormHelperText>
                            </FormControl>

                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                Internal Dealer Note
                              </FieldLabel>
                              <Input
                                disableUnderline
                                multiline
                                className="ai-input ai-input--textarea ai-input--textarea-lg"
                                id="component-simple"
                                onChange={this.onchangeDealerNotes}
                                value={this.state.DealerNotes ? this.state.DealerNotes : ""}
                                placeholder="Enter internal note"
                              />
                              <FormHelperText className="error-o">
                                {this.state.onDealerNotesErrorText}
                              </FormHelperText>
                            </FormControl>

                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                Public Dealer Notes
                              </FieldLabel>
                              <Input
                                disableUnderline
                                multiline
                                className="ai-input ai-input--textarea ai-input--textarea-lg"
                                id="component-simple"
                                onChange={this.onchangePublicDealerNote}
                                value={this.state.public_dealer_note ? this.state.public_dealer_note : ""}
                                disabled={this.state.userData && this.state.userData.roleId === 10}
                                placeholder="Enter public dealer notes"
                              />
                              <FormHelperText className="error-o"></FormHelperText>
                            </FormControl>
                          </SectionCard>

                          <SectionCard icon={<PaidOutlinedIcon />} title="TARGET PRICING DETAILS" style={{ marginTop: "10px" }}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                {getCustomLabel("custom_wholesale_price", "TARGET WHOLESALE PRICE ($)")}
                              </FieldLabel>
                              <Input
                                disableUnderline
                                className="ai-input"
                                id="component-simple"
                                onChange={this.onchangeWholeSalePrice}
                                value={this.state.WholeSalePrice ? this.state.WholeSalePrice : ""}
                                disabled={this.state.userData && this.state.userData.roleId === 10}
                                placeholder="0.00"
                              />
                              <FormHelperText className="error-o">
                                {this.state.onWholeSalePriceErrorText}
                              </FormHelperText>
                            </FormControl>

                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                {getCustomLabel("custom_end_customer_price", "TARGET END CUSTOMER PRICE ($)")}
                              </FieldLabel>
                              <Input
                                disableUnderline
                                className="ai-input"
                                id="component-simple"
                                onChange={this.onchangeRetailPrice}
                                value={this.state.RetailPrice ? this.state.RetailPrice : ""}
                                disabled={this.state.userData && this.state.userData.roleId === 10}
                                placeholder="0.00"
                              />
                              <FormHelperText className="error-o">
                                {this.state.onRetailPriceErrorText}
                              </FormHelperText>
                            </FormControl>

                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                {getCustomLabel("custom_end_customer_wire_price", "TARGET END CUSTOMER WIRE PRICE")} ($)
                              </FieldLabel>
                              <Input
                                disableUnderline
                                className="ai-input"
                                id="component-simple"
                                onChange={this.onchangeRetailWirePrice}
                                value={this.state.RetailWirePrice ? this.state.RetailWirePrice : ""}
                                disabled={this.state.userData && this.state.userData.roleId === 10}
                                placeholder="0.00"
                              />
                              <FormHelperText className="error-o">
                                {this.state.onRetailWirePriceErrorText}
                              </FormHelperText>
                            </FormControl>

                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                {getCustomLabel("custom_tag_price", "TAG PRICE ($)")}
                              </FieldLabel>
                              <Input disableUnderline className="ai-input" id="component-simple" type="text" onChange={this.onchangeTagPrice} value={this.state.tag_price || ""} disabled={this.state.userData && this.state.userData.roleId === 10} placeholder="0.00" />
                              <FormHelperText className="error-o"></FormHelperText>
                            </FormControl>
                          </SectionCard>

                          <SectionCard icon={<InsertDriveFileOutlinedIcon />} title="INVOICE FILE" style={{ marginTop: "10px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <FieldLabel>Upload Invoice Images or File</FieldLabel>
                              <Tooltip
                                title="Please attach images separately as high resolution JPG/PNG/JPEG/GIF/PDF/DOC/DOCX"
                                style={{
                                  position: "relative",
                                  top: 3,
                                  cursor: "pointer",
                                }}
                              >
                                <span>
                                  <HelpIcon
                                    fontSize="10px"
                                    style={{
                                      color: "#CEA05F",
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </div>
                            <div className="ai-invoice-upload">
                              <FileUploadGroup
                                page="Edit"
                                imageDetails={this.state.fileArray}
                                onFilesChange={this.handleSelectedFiles}
                                deleteExistingData={this.deleteExistingInvoiceFile}
                                disabled={
                                  this.state.userData &&
                                  this.state.userData.roleId === 10
                                }
                              />
                            </div>
                          </SectionCard>

                          <SectionCard icon={<WarningAmberOutlinedIcon />} title="ADDITIONAL OPTIONS" style={{ marginTop: "10px" }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="checkedB"
                                  className="ai-checkbox"
                                  onClick={this.handleCheck1}
                                  checked={this.state.box == true}
                                  disabled={
                                    this.state.userData &&
                                    this.state.userData.roleId === 10
                                  }
                                />
                              }
                              label="I have a box"
                            />
                            <div className="ai-subgroup">
                              <p className="ai-subgroup__title">Type of Paper</p>
                              <div className="ai-checkbox-inline">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      value="Warranty"
                                      className="ai-checkbox"
                                      checked={this.state.warranty_paper == "1"}
                                      onChange={this.handleTypeOfWarranty}
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                  }
                                  label="Warranty"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      className="ai-checkbox"
                                      value="Archive"
                                      checked={this.state.archive == "1"}
                                      onChange={this.handleTypeOfArchive}
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                  }
                                  label="Archive"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      className="ai-checkbox"
                                      value="isService"
                                      checked={this.state.isService}
                                      onChange={this.handleTypeOfService}
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                  }
                                  label="Service Card/Paper"
                                />
                              </div>
                              {this.state.warranty_paper && (
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <FieldLabel>Warranty Expiry Date</FieldLabel>
                                  <KeyboardDatePicker
                                    className="ai-datepicker ai-datepicker-paper"
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="MM/dd/yyyy"
                                    value={this.state.purchaseDate1 || null}
                                    onChange={(date, e) => {
                                      this.handleDateChange1(date, e, "Warranty");
                                    }}
                                    KeyboardButtonProps={{
                                      "aria-label": "change date",
                                    }}
                                    helperText={
                                      this.state.error["Warranty"]
                                        ? "Invalid date"
                                        : ""
                                    }
                                    error={this.state.error["Warranty"]}
                                    placeholder="Warranty - MM/DD/YYYY"
                                    onPaste={(event) => event.preventDefault()}
                                    disabled={
                                      this.state.userData &&
                                      this.state.userData.roleId === 10
                                    }
                                  />
                                </MuiPickersUtilsProvider>
                              )}
                              {this.state.archive && (
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <FieldLabel>Archive Date</FieldLabel>
                                  <KeyboardDatePicker
                                    className="ai-datepicker ai-datepicker-paper"
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="MM/dd/yyyy"
                                    value={this.state.archiveDate || null}
                                    onChange={(date, e) => {
                                      this.handleDateChange1(date, e, "Archive");
                                    }}
                                    KeyboardButtonProps={{
                                      "aria-label": "change date",
                                    }}
                                    style={{
                                      marginBottom: "20px",
                                      marginTop: "8px",
                                    }}
                                    helperText={
                                      this.state.error["Archive"]
                                        ? "Invalid date"
                                        : ""
                                    }
                                    error={this.state.error["Archive"]}
                                    placeholder="Archive - MM/DD/YYYY"
                                    onPaste={(event) => event.preventDefault()}
                                    disabled={
                                      this.state.userData &&
                                      this.state.userData.roleId === 10
                                    }
                                  />
                                </MuiPickersUtilsProvider>
                              )}
                              {this.state.isService && (
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <FieldLabel>Service Card / Paper Date</FieldLabel>
                                  <KeyboardDatePicker
                                    className="ai-datepicker ai-datepicker-paper"
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="MM/dd/yyyy"
                                    value={this.state.serviceDate || null}
                                    onChange={(date, e) => {
                                      this.handleDateChange1(date, e, "Service");
                                    }}
                                    KeyboardButtonProps={{
                                      "aria-label": "change date",
                                    }}
                                    style={{
                                      marginBottom: "20px",
                                      marginTop: "0px",
                                    }}
                                    helperText={
                                      this.state.error["Service"]
                                        ? "Invalid date"
                                        : ""
                                    }
                                    error={this.state.error["Service"]}
                                    placeholder="Service Card / Paper - MM/DD/YYYY"
                                    onPaste={(event) => event.preventDefault()}
                                    disabled={
                                      this.state.userData &&
                                      this.state.userData.roleId === 10
                                    }
                                  />
                                </MuiPickersUtilsProvider>
                              )}
                            </div>

                            <div className="ai-subgroup">
                              <p className="ai-subgroup__title">Modification</p>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="checkedB1"
                                    className="ai-checkbox"
                                    checked={this.state.ismodified}
                                    onChange={this.handleCheck2}
                                    disabled={
                                      this.state.userData &&
                                      this.state.userData.roleId === 10
                                    }
                                  />
                                }
                                label="Modified"
                              />
                              {this.state.ismodified && (
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel className="ai-subgroup__title">
                                    Modification Details
                                  </FieldLabel>
                                  <Input
                                    disableUnderline
                                    className="ai-input"
                                    id="component-simple"
                                    value={this.state.modification_deatils}
                                    onChange={this.onchangeModificationDetails}
                                    multiline
                                    maxRows={4}
                                    disabled={this.state.userData && this.state.userData.roleId === 10}
                                    placeholder="Enter modification details"
                                  />
                                  <FormHelperText className="error-o"></FormHelperText>
                                </FormControl>
                              )}
                            </div>

                            {this.state.userData &&
                              (this.state.userData?.dealerInventorySubscription ===
                                "access_only" ||
                                this.state.userData?.dealerInventorySubscription ===
                                "no_subscription") ? null : (
                              <div className="ai-subgroup">
                                <p className="ai-subgroup__title">Dealer Feed</p>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      className="ai-checkbox"
                                      value={this.state.dealerInv}
                                      checked={this.state.dealerInv}
                                      onChange={this.handleDealerInclude}
                                      disabled={
                                        this.state.userData &&
                                        this.state.userData.roleId === 10
                                      }
                                    />
                                  }
                                  label="Include in the Dealer Feed"
                                />
                              </div>
                            )}
                            {this.state.isShopifyEnabled &&
                              this.state.isShopifyVerified &&
                              !this.state.initialShopifyConfig &&
                              !this.state.sold ? (
                              <div className="ai-subgroup">
                                <p className="ai-subgroup__title">Shopify Configuration</p>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      className="ai-checkbox"
                                      value={this.state.shopifyConfig}
                                      checked={this.state.shopifyConfig}
                                      onChange={this.handleIncludeShopify}
                                    />
                                  }
                                  label="Include in shopify"
                                />
                              </div>
                            ) : null}
                            {this.state.isQboVerified &&
                              !this.state.qboitemid &&
                              !this.state.initialQboConfig &&
                              !this.state.sold ? (
                              <div className="ai-subgroup">
                                <p className="ai-subgroup__title">Quickbook Configuration</p>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      value={this.state.qboConfig}
                                      checked={this.state.qboConfig}
                                      className="ai-checkbox"
                                      onChange={this.handleIncludeQbo}
                                    />
                                  }
                                  label="Include in the Quickbook"
                                />
                              </div>
                            ) : null}

                            {this.state.isEbayVerified &&
                              // !this.state.ebayitemid &&
                              !this.state.initialEbayConfig &&
                              !this.state.sold ? (
                              <div className="ai-subgroup">
                                <p className="ai-subgroup__title">
                                  Ebay Configuration
                                </p>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="checkedB1"
                                      value={this.state.ebayConfig}
                                      checked={this.state.ebayConfig}
                                      className="float-right"
                                      onChange={this.handleIncludeEbay}
                                    />
                                  }
                                  label="Include in the Ebay"
                                />
                              </div>
                            ) : null}
                          </SectionCard>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Container>
              </form>
            ) : null}
            {this.state.loaded && this.state.type === "misc_watch" && (
              <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                <SectionCard icon={<CloudUploadOutlinedIcon />} title="UPLOADS (IMAGES & VIDEOS)" style={{ marginTop: "8px" }}>
                  <Typography className="ai-uploads__hint">
                    Upload related images and videos of the watch.
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">IMAGES</Typography>
                      <this.UploadDropzone
                        inputId="ai-upload-images"
                        icon={<ImageOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="JPG, PNG, JPEG"
                        accept="image/*"
                        onFilesSelected={this.handleImagesSelected}
                      />
                      <this.ImagePreviewGrid files={this.state.imageFiles} onRemove={this.removeImageFile} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">VIDEOS</Typography>
                      <this.UploadDropzone
                        inputId="ai-upload-videos"
                        icon={<VideocamOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="MP4, MOV"
                        accept="video/*"
                        onFilesSelected={this.handleVideosSelected}
                      />
                      <this.VideoPreviewGrid files={this.state.videoFiles} onRemove={this.removeVideoFile} />
                    </Grid>
                  </Grid>
                </SectionCard>
              </Grid>
            )}
            {this.state.type === "misc_watch" && (
              <div className="ai-bottombar">
                <Button className="ai-btn ai-btn--ghost" onClick={this.handleGoBack}>
                  Cancel
                </Button>
                <Button
                  className="ai-btn ai-btn--primary"
                  style={{
                    opacity: !this.state.isDirty ? 0.6 : 1,
                    cursor: !this.state.isDirty ? "not-allowed" : "pointer",
                    pointerEvents:
                      (this.state.disabled && !this.state.isDirty) || this.state.loading
                        ? "none"
                        : "auto",
                  }}
                  disabled={(this.state.disabled && !this.state.isDirty) || this.state.loading}
                  onClick={(e) => {
                    if (!this.state.isDirty || this.state.disabled || this.state.loading) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    this.submitForm(e);
                  }}
                >
                  {this.state.loading ? (
                    <>
                      <CircularProgress size={18} style={{ color: "#fff", marginRight: 8 }} />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </Button>
              </div>
            )}
          </Paper>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps({
  individualBrowseWatchesInfo,
  auth,
  dealer,
  browseWatchesInfo,
}) {
  localStorage.setItem("menuTitle", "ADD INVENTORY");
  return {
    individualBrowseWatchesInfo:
      individualBrowseWatchesInfo.individualBrowseWatchesInfo,
    currentUser: auth.currentUser,
    autocompleteProducts: dealer.autoCompleteProducts,
    brandInfo: browseWatchesInfo.brandInfo,
    caseMaterialInfo: browseWatchesInfo.caseMaterialInfo,
    brandMaterialInfo: browseWatchesInfo.brandMaterialInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      individualBrowseWatch,
      searchProducts,
      brandList,
      caseMaterial,
      brandMaterial,
    },
    dispatch,
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(inventryupdateComponent);
